{
  "general.login": "ล็อกอิน",
  "general.logout": "ล็อกเอาต์",
  "general.title_zero": "Story",
  "general.title_one": "Story",
  "general.title_other": "Stories",
  "general.chapter_zero": "Episode",
  "general.chapter_one": "Episode",
  "general.chapter_other": "Episodes",
  "general.character_zero": "ตัวละคร",
  "general.character_one": "ตัวละคร",
  "general.character_other": "ตัวละคร",
  "general.title_language": "ภาษา",
  "general.display_language": "ภาษาที่แสดง",
  "general.category_zero": "Category",
  "general.category_one": "Category",
  "general.category_other": "Categories",
  "general.category.fantasy": "Fantasy",
  "general.category.urban_fantasy": "Contemporary Fantasy",
  "general.category.romance_fantasy": "Romantic Fantasy",
  "general.category.oriental_fantasy": "Martial Arts",
  "general.category.boyslove": "LGBTQ+ M/M",
  "general.category.girlslove": "LGBTQ+ F/F",
  "general.category.alternative_history": "Alternate History",
  "general.category.drama": "Drama",
  "general.category.daily": "Daily Life",
  "general.category.action": "Action",
  "general.category.romance": "Romance",
  "general.category.gag_comedy": "Comedy",
  "general.category.horror": "Horror",
  "general.category.mystery": "Mystery",
  "general.category.horror_mystery": "Horror Mystery",
  "general.category.sci_fi": "Sci-fi",
  "general.category.know_how": "Know-how",
  "general.category.Daily": "Daily Life",
  "general.create_title": "Create Story",
  "general.edit_title": "Edit Story",
  "general.create_character": "Create Character",
  "general.edit_character": "Edit Character",
  "general.all": "ทั้งหมด",
  "general.home": "โฮม",
  "general.navigation": "เมนูหลัก",
  "general.best": "HotTap",
  "general.discover": "UnTap",
  "general.my_titles": "My Stories",
  "general.library": "Library",
  "general.profile": "Profile",
  "general.my": "ของฉัน",
  "general.bubblepick": "Bubble Pick",
  "general.username": "ยูเซอร์โคด",
  "general.writername": "ชื่อเล่น",
  "general.description": "Description",
  "general.setting": "ตั้งค่า",
  "general.setting_email": "อีเมล",
  "general.setting_autosave": "Autosave",
  "general.setting_reading_mode": "Preferred Reading Method",
  "general.setting_change_password": "Change Password",
  "general.save": "บันทึก",
  "general.exitsave": "บันทึกและออกจากหน้านี้",
  "general.cancel": "ยกเลิก",
  "general.next": "ถัดไป",
  "general.create": "สร้าง",
  "general.create_button": "สร้าง",
  "general.add_chapter": "Create Episode",
  "general.edit": "แก้ไข",
  "general.delete": "ลบ",
  "general.publish": "เผยแพร่",
  "general.unpublish": "เป็นส่วนตัว",
  "general.publishrequest": "Request Publication",
  "general.stay_on": "ยกเลิก",
  "general.leave": "ออก",
  "general.done": "สำเร็จ",
  "general.no_chapter_name": "Untitled",
  "general.unsaved_changes": "มีการแก้ไขที่ยังไม่ถูกบันทึก",
  "general.unsaved_changes_message": "ต้องการบันทึกการเปลี่ยนแปลงหรือไม่?",
  "general.unsaved_changes_warning_message": "เนื้อหาที่คุณกำลังสร้างจะไม่ถูกบันทึก",
  "general.leave_confirm_message": "คุณต้องการออกจากหน้านี้หรือไม่?",
  "general.asset_no_list_message": "There are no assets.",
  "general.chapter_status.publish_requested": "Publication Requested",
  "general.chapter_status.published": "เผยแพร่",
  "general.chapter_status.unpublished": "เป็นส่วนตัว",
  "general.title_status.draft": "Draft",
  "general.title_status.ongoing": "Ongoing",
  "general.title_status.completed": "Story Completed",
  "general.title_status.blocked": "ถูกบล็อก",
  "general.title_status.waiting": "Pending",
  "general.character_name": "Character Name",
  "general.character_status": "Character Description",
  "general.character_position.left": "Left",
  "general.character_position.right": "Right",
  "general.image_filetype_validation_message": "Only webp, png and jpg file formats are supported.",
  "general.image_size_validation_message": "Each image file cannot exceed 10MB.",
  "general.image_load_validation_message": "Image failed to load. Please try again.",
  "general.contact_customer_support_error_message": "Something went wrong. Please contact customer support.",
  "general.yes": "ใช่",
  "general.no": "ไม่ใช่",
  "general.modify": "แก้ไข",
  "general.modify_button": "แก้ไข",
  "general.save_alert": "มีการแก้ไขที่ยังไม่ได้ถูกบันทึก<br/>ต้องการจะออกจากหน้านี้อยู่หรือไม่?",
  "general.save_success_message": "Your changes were successfully saved.",
  "general.save_fail_message": "บันทึกการเปลี่ยนแปลงไม่สำเร็จ โปรดลองใหม่อีกครั้ง",
  "general.delete_alert_message": "คุณแน่ใจที่จะลบใช่หรือไม่?",
  "general.delete_success_message": "Deleted successfully.",
  "general.saving_successful": "บันทึกสำเร็จ",
  "general.saving_unsuccessful": "บันทึกไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
  "general.terms_of_service": "ข้อกำหนดการให้บริการ",
  "general.privacy_policy": "นโยบายความเป็นส่วนตัว",
  "general.operation_policy": "นโยบายการดำเนินงาน",
  "general.juvenile_protection_policy": "นโยบายการคุ้มครองเยาวชน",
  "general.apply": "ใช้",
  "general.language_letter_zero": "Character",
  "general.language_letter_one": "Character",
  "general.language_letter_other": "Characters",
  "general.tap_zero": "Tap",
  "general.tap_one": "Tap",
  "general.tap_other": "Taps",
  "general.scroll_zero": "Scroll",
  "general.scroll_one": "Scroll",
  "general.scroll_other": "Scrolls",
  "general.original": "Original",
  "general.gallery": "แกลเลอรี",
  "general.camera": "Camera",
  "general.size": "ไซซ์",
  "general.contest": "Contest",
  "general.challenge": "Challenge",
  "general.bubbletap_original": "Original",
  "general.bubbleup": "BubbleUp",
  "general.bubbleup.challenge_header_button": "BubbleUp challenge",
  "general.bubbleup.challenge_message": "I'm trying to BubbleUp.",
  "general.story_created_complete": "Your story has been created.",
  "general.list_tap_asset_sort_last_hour": "1 ชั่วโมงล่าสุด",
  "general.list_tap_asset_sort_daily": "รายวัน",
  "general.list_tap_asset_sort_weekly": "รายสัปดาห์",
  "general.list_tap_asset_sort_monthly": "รายเดือน",
  "general.list_tap_asset_sort_all": "ทั้งหมด",
  "general.tap_order_newest": "ใหม่ล่าสุด",
  "general.tap_order_liked": "ถูกใจเยอะที่สุด",
  "general.tap_order_oldest": "เก่าที่สุด",
  "general.tap.order_int_hourly": "{{int_number}}ชั่วโมง",
  "general.tap.order_int_daily": "{{int_number}}วัน",
  "general.tap.order_int_weekly": "{{int_number}}สัปดาห์",
  "general.tap.order_int_monthly": "{{int_number}}เดือน",
  "general.pass.basic": "BASIC",
  "general.pass.super": "SUPER",
  "general.pass.hyper": "HYPER",
  "general.comments": "รีวิว",
  "general.event_awarded": "รับ {{int_numbers}} บับเบิลเรียบร้อยแล้ว!",
  "general.event_awarded_description1": "รับรางวัลกิจกรรม และกรอบโปรไฟล์นักสืบเรียบร้อยแล้ว<br/>ไปตามหาคนร้ายกันเลย!",
  "general.event_popup_alert1": "กิจกรรมนี้เข้าร่วมได้เฉพาะผู้ใช้ในเกาหลีใต้เท่านั้น",
  "general.event_popup_alert2": "เข้าร่วมได้เฉพาะผู้ใช้ที่ยืนยันตัวตนแล้ว",
  "general.event_popup_alert3": "คุณได้เข้าร่วมกิจกรรมนี้แล้ว",
  "general.event_popup_alert4": "กิจกรรมนี้สิ้นสุดแล้ว",
  "general.bubbles_zero": "{{int_numbers}} บับเบิล",
  "general.bubbles_one": "{{int_numbers}} บับเบิล",
  "general.bubbles_other": "{{int_numbers}} บับเบิล",
  "general.copy": "คัดลอก",
  "general.maintenance_title": "อยู่ระหว่างปรับปรุงระบบ",
  "general.maintenance_title2": "เรากำลังปรับปรุงระบบเพื่อการบริการที่ดีขึ้น<br/>กรุณาลองใหม่อีกครั้งในภายหลัง",
  "general.maintenance_description": "เวลาปิดปรับปรุง: วันนี้ เวลา 04:30 - 07:30 น.",
  "general.maintenance_period": "เวลาปิดปรับปรุง: {{startDate}} {{startTime}} - {{endTime}} น.",
  "popup.banner_close_button": "ปิด",
  "popup.close_for_a_day_button": "ซ่อน 24 ชั่วโมง",
  "popup.banner_close_for_a_day_button": "ซ่อน 3 วัน",
  "register.userinfo_username_message": "กรุณาใส่ยูเซอร์โคด",
  "register.userinfo_username_used_validation_message": "ยูเซอร์โคดนี้ถูกใช้ไปแล้ว",
  "register.userinfo_writername_used_validation_message": "ชื่อเล่นนี้ถูกใช้ไปแล้ว",
  "register.userinfo_username_impossible_used_validation_message": "ยูเซอร์โคดนี้ไม่สามารถใช้งานได้",
  "register.userinfo_writername_impossible_used_validation_message": "ชื่อเล่นนี้ไม่สามารถใช้งานได้",
  "register.userinfo_username_format_validation_message": "กรุณาใส่ยูเซอร์โคดด้วยตัวอักษรภาษาอังกฤษและตัวเลข 6~25 ตัวอักษร",
  "register.userinfo_writername_format_validation_message": "กรุณาระบุด้วยตัวอักษร, ตัวเลข หรืออักขระพิเศษเป็นจำนวน 2 ~25 ตัว",
  "register.userinfo_password_message": "กรุณาใส่รหัสผ่าน",
  "register.userinfo_password_placeholder": "รหัสผ่าน",
  "register.userinfo_password_format_validation_message": "กรุณาใส่ 8~25 ตัวอักษรโดยใส่ตัวอักษรและตัวเลขด้วยกัน",
  "register.userinfo_next": "ยืนยัน",
  "register.userinfo_password_retype_placeholder": "ยืนยันรหัสผ่าน",
  "register.userinfo_username_description_message": "กรุณาใส่ยูเซอร์โคดอย่างระมัดระวังเพราะชื่อผู้ใช้ไม่สามารถเปลี่ยนได้ในภายหลัง",
  "register.userinfo_email_title_message": "กรุณาใส่อีเมล",
  "register.userinfo_email_description_message": "ยืนยันอีเมลของคุณเพื่อกู้รหัสผ่าน",
  "register.userinfo_email_description_message2": "เมื่อยืนยันอีเมลเรียบร้อยแล้ว<br/>คุณจะสามารถใช้บริการได้ตามที่ระบุไว้ด้านล่างนี้",
  "register.userinfo_email_certification_message": "จำเป็นต้องยืนยันอีเมล",
  "register.userinfo_email_certification_message2": "กรุณาตรวจสอบสถานะการยืนยันอีเมล",
  "register.userinfo_email_certification_button": "ยืนยัน",
  "register.userinfo_email_checkbox_description_message1": "กู้รหัสผ่าน",
  "register.userinfo_email_checkbox_description_message2": "ข้อมูลการชนะกิจกรรม",
  "register.userinfo_email_checkbox_description_message3": "BubbleUp selection guide",
  "register.userinfo_email_checkbox_description_message4": "Serial proposal",
  "register.userinfo_verification_agree_select_all": "ยอมรับทั้งหมด",
  "register.userinfo_verification_privacy_policy": "นโยบายความเป็นส่วนตัว",
  "register.userinfo_verification_terms_of_service": "ข้อกำหนดการให้บริการ",
  "register.userinfo_verification_agree_description1": "สามารถยืนยันตัวตนได้สูงสุด 3 บัญชีต่อ 1 ชื่อเท่านั้น",
  "register.userinfo_verification_agree_description2": "คุณจะสามารถสร้างหรือใช้เนื้อหาผู้ใหญ่ได้หลังจากที่ยืนยันตัวตนแล้วเท่านั้น",
  "register.userinfo_verification_failed_modal_description": "การยืนยันตัวตนสามารถยืนยันได้สูงสุด 3 บัญชีต่อ 1 ชื่อเท่านั้น",
  "register.userinfo_verification_failed_modal_retry": "ทำอีกครั้ง",
  "register.userinfo_set_nickname_title": "ตั้งค่าชื่อเล่น",
  "register.userinfo_set_nickname_skip": "ข้าม",
  "register.userinfo_set_nickname_placeholder": "กรุณาใส่ชื่อเล่นที่คุณต้องการใช้",
  "register.userinfo_set_nickname_description1": "นี่คือชื่อเล่นที่จะใช้เรียกคุณในการสนทนา และใช้ทั่วทั้งบริการ",
  "register.userinfo_set_nickname_description2": "ในกรณีที่ตั้งค่าโปรไฟล์ ตัวละครสามารถเรียกคุณด้วยชื่ออื่นแทนชื่อเล่นนี้ได้",
  "register.userinfo_set_nickname_description3": "คุณสามารถเปลี่ยนชื่อเล่นได้ตลอดเวลาใน My Page",
  "register.userinfo_set_nickname_done_button": "สำเร็จ",
  "register.userinfo_set_nickname_format_validation_message": "กรุณาระบุด้วยตัวอักษร, ตัวเลข หรืออักขระพิเศษเป็นจำนวน 2 ~25 ตัว",
  "register.userinfo_set_nickname_already_used_validation_message": "ชื่อเล่นนี้ถูกใช้งานแล้ว",
  "register.userinfo_set_nickname_inappropriate_words_validation_message": "มีคำที่ไม่เหมาะสมอยู่ในชื่อเล่น กรุณาใส่ชื่อเล่นอื่น",
  "register.userinfo_set_nickname_invalid_characters_validation_message": "ชื่อเล่นนี้มีตัวอักษรที่ไม่สามารถใช้งานได้รวมอยู่ด้วย",
  "register.userinfo_set_country_korea": "대한민국",
  "register.userinfo_set_country_thai": "ประเทศไทย",
  "register.userinfo_set_country_taiwan": "臺灣",
  "register.userinfo_set_country_japan": "日本",
  "login.userinfo_message": "กรุณาใส่ <strong>ยูเซอร์โคด</strong>และ <strong>รหัสผ่าน</strong>เพื่อล็อกอิน",
  "login.userinfo_login": "ล็อกอิน",
  "login.userinfo_forgot_password_message": "คุณลืมรหัสผ่านใช่หรือไม่?",
  "login.userinfo_username_format_validation_message": "กรุณาใส่ยูเซอร์โคดด้วยตัวอักษรภาษาอังกฤษและตัวเลข 6~25 ตัวอักษร",
  "login.userinfo_password_format_validation_message": "กรุณาใส่รหัสผ่าน 8~25 ตัวอักษรโดยใส่ตัวอักษรและตัวเลขด้วยกัน",
  "login.userinfo_username_fail_validation_message": "ไม่พบยูเซอร์โคด กรุณาลองใหม่อีกครั้ง",
  "login.userinfo_password_fail_validation_message": "รหัสผ่านไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง",
  "login.userinfo_password_not_set_validation_message": "คุณยังไม่ได้ตั้งรหัสผ่าน กรุณาเข้าไปตั้งรหัสผ่านในบัญชีโซเชียลของคุณก่อน",
  "login.password_reset_password_first_description_message": "กรุณาใส่ยูเซอร์โคดและอีเมลที่ยืนยันแล้วของคุณ",
  "login.password_reset_password_second_description_message": "<strong>รหัสผ่านใหม่</strong>จะถูกส่งไปยังอีเมลเพื่อให้คุณรีเซ็ตรหัสผ่าน",
  "login.password_reset_password_username_placeholder": "กรุณาใส่ยูเซอร์โคด",
  "login.password_reset_password_email_placeholder": "กรุณาใส่อีเมลที่ยืนยันแล้ว",
  "login.password_reset_password_button": "รีเซ็ตรหัสผ่าน",
  "login.password_reset_password_username_fail_validation_message": "กรุณาใส่ยูเซอร์โคด 6 ตัวอักษรขึ้นไป",
  "login.password_reset_password_email_fail_validation_message": "กรุณาใส่อีเมลที่ถูกต้อง",
  "login.password_reset_password_username_fail_validation_toast": "ไม่พบยูเซอร์โคด กรุณาลองใหม่อีกครั้ง",
  "login.password_reset_password_email_validation_email_none_message": "ไม่พบอีเมลที่ได้รับการยืนยันในบัญชีนี้",
  "login.password_reset_password_email_success_title": "อีเมลจะถูกส่งไปเพื่อให้คุณรีเซ็ตรหัสผ่าน",
  "login.password_reset_password_email_success_message": "กรุณาตรวจกล่องจดหมายในอีเมลของคุณ",
  "login.password_reset_password_email_current_validation_toast": "รหัสผ่านไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง",
  "login.password_reset_password_email_new_validation_toast": "รหัสผ่านไม่ตรงกับรหัสผ่านใหม่",
  "login.password_reset_password_email_validation_email_verify_message": "กรุณาใส่อีเมลให้ถูกต้อง",
  "login.connect_fail_unknown_title": "มีข้อผิดพลาดที่ไม่คาดคิดเกิดขึ้น",
  "login.connect_fail_unknown_description": "กรุณาแจ้งเกี่ยวกับข้อผิดพลาดนี้กับเรา<br/>(th.support@bubbletap.com)",
  "login.account_member": "คุณเคยสมัครอยู่แล้วหรือไม่?",
  "login.account_kakao": "ล็อกอินด้วยบัญชี <strong>Kakao</strong>",
  "login.account_google": "ล็อกอินด้วยบัญชี <strong>Google</strong>",
  "login.account_facebook": "ล็อกอินด้วยบัญชี <strong>Facebook</strong>",
  "login.account_apple": "ล็อกอินด้วยบัญชี <strong>Apple</strong>",
  "login.account_agree_policy": "เมื่อคุณล็อกอินแล้ว <link1>หมายความว่าคุณยอมรับข้อกำหนดการให้บริการ</link1>และ<link2>นโยบายความเป็นส่วนตัวของเรา</link2>",
  "login.account_fail_toast": "ล็อกอินไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
  "login.account_fail_password_toast": "รหัสผ่านไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง",
  "login.account_cancel_toast": "ล็อกอินถูกยกเลิก",
  "login.account_must_login": "กรุณาล็อกอินก่อนใช้บริการ",
  "login.nonlogin_users_login_button": "ไปหน้าล็อกอิน",
  "login.account_existing_account_title": "เข้าสู่ระบบด้วยบัญชีเดิม",
  "login.account_social_account_title": "เข้าสู่ระบบด้วยบัญชีโซเชียล",
  "login.password_reset_modal_title": "ส่งอีเมลสำหรับตั้งค่ารหัสผ่านใหม่เรียบร้อยแล้ว",
  "login.password_reset_modal_description": "กรุณาตรวจสอบอีเมลของคุณ",
  "login.password_change_login_button": "ตั้งรหัสผ่านใหม่และเข้าสู่ระบบ",
  "login.password_change_title": "เปลี่ยนรหัสผ่าน",
  "gnb.about_bubblechat": "เกี่ยวกับบับเบิลแชต",
  "gnb.studio": "สตูดิโอ",
  "gnb.faq": "คำถามที่พบบ่อย",
  "gnb.guide_download": "ดาวน์โหลดไกด์",
  "story.my_titles.title_list": "Stories",
  "story.my_titles.published_titles": "Published Stories",
  "story.create_title.list_thumbnail_guide_message": "Create a new story.",
  "story.create_title.list_null_text": "You have not started any stories.",
  "story.create_edit_title.add_cover": "Add a cover image.",
  "story.create_edit_title.bubbletap_original_cover_assets_alert_name": "Original Cover Asset",
  "story.create_edit_title.title_completed_label": "Story Completed",
  "story.create_edit_title.select_categories_text": "Select up to 2 categories for your story.",
  "story.create_edit_title.add_characters_text": "Add characters to your story.",
  "story.create_characters.name_guide_text": "Enter name of new character. ",
  "story.create_characters.status_guide_text": "Please provide a description of the character.",
  "story.create_characters.position_guide_text": "Select character's positioning: Left or Right.",
  "story.select_characters_text": "Select characters for your story.",
  "story.delete_characters_confirmation_message": "Do you want to delete this character?",
  "story.delete_characters_warning_message": "This character will no longer be available for this story.",
  "story.delete_characters_validation_message": "Unable to delete this character.",
  "story.delete_characters_info_message": "Characters used in the story cannot be removed.",
  "story.delete_title_confirmation_message": "This action cannot be undone. <br/>Are you sure you want to delete this story?",
  "story.delete_title_character_chapter_warning_message": "All characters and episodes in this story will be deleted.",
  "story.delete_title_like_warning_message": "All likes in this story will be deleted.",
  "story.delete_title_comment_warning_message": "All comments in this story will be deleted.",
  "story.delete_title_read_warning_message": "All taps in this story will be deleted.",
  "story.create_edit_title.title_validation_message": "The title must be between 1 and 40 characters.",
  "story.create_edit_title.description_validation_message": "The story description must be between 1 and 150 characters.",
  "story.create_edit_title.category_validation_message": "Choose at least 1 category.",
  "story.create_edit_title.status_validation_message": "The story description section cannot be empty.",
  "story.create_edit_title.delete_chapter_confirmation_message": "Are you sure you want to delete this episode?",
  "story.create_edit_title.delete_chapter_warning_message": "This episode will no longer be available in the story.",
  "story.create_edit_title_serial_chapter_unpublished_impossible_alert_message": "Episode cannot be unpublished. ",
  "story.create_edit_title_serial_chapter_published_impossible_alert_message": "Episode cannot be published. ",
  "story.create_edit_title_serial_chapter_deleted_impossible_alert_message": "Episode cannot be deleted.",
  "story.create_edit_title.title_placeholder": "Enter the title of the story.",
  "story.create_edit_title.description_placeholder": "Provide a short description of the story.",
  "story.create_edit_title.chapter_order_tooltip": "Click to change the order of episodes. ",
  "story.create_title_info_title": "Title",
  "story.create_edit_component_delete_message": "Deleted",
  "story.create_characters.bubbletap_original_avatar_assets_alert_name": "Character Avatar",
  "story.create_characters.edit_image_zoom_button": "Zoom",
  "story.create_characters.edit_image_reset_all_button": "Reset All",
  "story.create_characters.edit_image_remove_background_button": "Remove background",
  "story.create_characters.edit_image_send_button": "Send",
  "story.create_characters.edit_image_cancel_button": "Cancel",
  "story.create_edit_title_serial_title_delete_impossible_alert_message": "Story cannot be deleted.",
  "story.create_edit_title_serial_title_completed_impossible_alert_message": "Story's serialized status cannot be changed.",
  "story.create_edit_title_status_change_publishrequest_alert_title": "Once a publication request is made, you cannot change its status.",
  "story.create_edit_title_status_change_publishrequest_alert_message": "Once a publication request is made, you cannot edit or delete the episode.",
  "story.create_edit_title_status_change_publishrequest_alert_error_message": "Request failed. Please try again.",
  "story.create_edit_title.list_null_message": "Publish your story and share it with your friends.",
  "preview.controller_play_button": "Play",
  "preview.controller_pause_button": "Pause",
  "preview.controller_replay_button": "Replay",
  "preview.controller_end_button": "End",
  "preview.controller_info_scroll_zero": "Scroll Count",
  "preview.controller_info_scroll_one": "Scroll Count",
  "preview.controller_info_scroll_other": "Scroll Count",
  "preview.controller_info_tap_zero": "Tap Count",
  "preview.controller_info_tap_one": "Tap Count",
  "preview.controller_info_tap_other": "Tap Count",
  "preview.controller_info_letter_zero": "Character Count",
  "preview.controller_info_letter_one": "Character Count",
  "preview.controller_info_letter_other": "Character Count",
  "profile.username_placeholder": "กรุณาใส่ยูเซอร์โคดที่ต้องการใช้",
  "profile.description_placeholder": "โปรดใส่คำแนะนำเกี่ยวกับฉัน",
  "profile.username_length_validation_message": "กรุณาตั้งยูเซอร์โคดด้วยตัวอักษร 6 - 25 ตัว",
  "profile.username_format_validation_message": "ยูเซอร์โคดต้องใช้ตัวอักษรภาษาอังกฤษและตัวเลขเท่านั้น",
  "profile.image_upload": "อัปโหลดรูปโปรไฟล์",
  "chapter.confirm_publish_chapter_message": "Do you want to publish this episode?",
  "chapter.confirm_draft_chapter_message": "Do you want to save this episode as draft?",
  "chapter.info_fail_validation_message": "Chapter does not exist",
  "chapter.edit": "Edit Episode",
  "chapter.edit_background_image": "Background<br/>Image",
  "chapter.edit_background_your_image": "Use your own images.",
  "chapter.edit_background_simple_color": "Background Simple Color",
  "chapter.edit_text_input_narrative_placeholder": "Start writing narrative here.",
  "chapter.edit_text_input_character_placeholder": "Start writing dialogue here.",
  "chapter.edit_text_input_background_image_button": "Background Image",
  "chapter.edit_text_input_narrative_button": "Narrative",
  "chapter.edit_text_input_image_button": "Image",
  "chapter.edit_text_input_clear_room_button": "New Page",
  "chapter.edit_text_input_narrative_characters_limit_toast": "Narratives are limited to 10,000 characters. ",
  "chapter.edit_text_input_dialogue_characters_limit_toast": "Dialogues are limited to 10,000 characters.",
  "chapter.edit_text_input_newpage_limit_message": "You cannot create New Pages consecutively.",
  "chapter.edit_text_input_newpage_warning_alert_message": "New Page function cannot be the first operation.",
  "chapter.edit_text_input_between_newpage_contents_limit_message": "Content cannot be deleted. Delete New Page first and try again.",
  "chapter.edit_page_clear_room_tap": "Start with New Page",
  "chapter.edit_page_current_location_line": "Current Location",
  "chapter.edit_page_delete_message": "Successfully Deleted",
  "chapter.edit_page_background_color_tap": "Background<br/>Color",
  "chapter.edit_preview_tooltip": "ดูตัวอย่าง",
  "chapter.edit_save_tooltip": "To save, please enter title and at least the first line of episode.",
  "chapter.edit_save_publish_chapter_warning_alert_message": "Published episodes cannot be edited.",
  "chapter.edit_chapter_name_text": "Episode Title",
  "chapter.edit_chapter_title_placeholder": "Please enter episode title.",
  "chapter.edit_create_chapter": "Create Episode",
  "chapter.edit_back": "Back",
  "chapter.edit_chapter_title": "Episode Title",
  "chapter.edit_text_edit_text": "Edit Text",
  "chapter.edit_text_change_monologue": "Switch to Monologue",
  "chapter.edit_text_change_dialogue": "Switch to Dialogue",
  "chapter.edit_assets_background_color": "Background Color",
  "chapter.edit_assets_background_title": "Background Image",
  "chapter.edit_assets_background_category_your_image": "My Image",
  "chapter.edit_assets_background_category_simple_color": "Simple Color",
  "chapter.edit_assets_background_category_bubbletap_original": "BubbleTap Original Background",
  "chapter.edit_assets_animated_overlay_image": "Overlay",
  "chapter.edit_text_auto_separation": "Conversation auto separation",
  "chapter.edit_text_auto_separation_enter": "Hit Enter<br/>to separate conversation! ",
  "chapter.edit_text_convo_type": "Change conversation type",
  "chapter.edit_cut": "Cut",
  "chapter.edit_paste": "Paste",
  "chapter.edit_searchby_char": "Search by character name.",
  "chapter.edit_assets_bubbletap_original_transition_action_sheet": "Changeover",
  "chapter.edit_assets_bubbletap_original_transition_screen_name": "Please set your screen changeover speed ",
  "chapter.edit_assets_bubbletap_original_transition_image_button": "Gradual screen changeover (image type)",
  "chapter.edit_assets_bubbletap_original_transition_text_button": "Quick screen changeover (text type)",
  "chapter.list_reading_mode_screen_name": "Please set your preferred reading method.",
  "chapter.list_reading_tap_mode_button": "Tap Mode",
  "chapter.list_reading_scroll_mode_button": "Scroll Mode",
  "chapter.list_reading_tap_mode_alert_title": "Set to Tap Mode",
  "chapter.list_reading_tap_mode_alert_message": "To change settings, go to<br/><strong>My Page > Settings > Preferred Reading Method.</strong>",
  "chapter.list_reading_scroll_mode_alert_title": "Set to Scroll Mode",
  "chapter.list_reading_scroll_mode_alert_message": "To change settings, go to<br/><strong>My Page > Settings > Preferred Reading Method.</strong>",
  "chapter.list_non_login_user_reading_mode_setting_alert_message": "To change settings, login and go to<br/><strong>My Page > Settings > Preferred Reading Method.</strong>",
  "chapter.list_share_fail_message": "Can't find the app",
  "chapter.edit_assets_bubbletap_original_soundeffect_action_sheet": "Add Sound Effect",
  "chapter.edit_assets_bubbletap_original_soundeffect_screen_name": "Sound Effect",
  "chapter.edit_assets_bubbletap_original_soundeffect_main_category1": "BubbleTap Sound Effect",
  "chapter.edit_assets_bubbletap_original_soundeffect_main_category2": "Favorites",
  "chapter.edit_assets_bubbletap_original_soundeffect_category1": "Nature",
  "chapter.edit_assets_bubbletap_original_soundeffect_category2": "Objects",
  "chapter.edit_assets_bubbletap_original_soundeffect_category3": "Animals",
  "chapter.edit_assets_bubbletap_original_soundeffect_category4": "Places",
  "chapter.edit_assets_bubbletap_original_soundeffect_category5": "People",
  "chapter.edit_assets_bubbletap_original_soundeffect_category6": "Genre",
  "chapter.edit_assets_bubbletap_original_soundeffect_category7": "Miscellaneous",
  "chapter.edit_assets_bubbletap_original_soundeffect_categories_screen_name": "Sound Effects",
  "chapter.edit_assets_bubbletap_original_soundeffect_edit_action_sheet": "Remove sound effects. ",
  "chapter.edit_assets_bubbletap_original_soundeffect_play_failed_toast": "Failed to play audio.",
  "chapter.list_free_label": "Free",
  "chapter.list_owned_label": "ซื้อ",
  "chapter.list_rented_label": "Rented",
  "chapter.list_rented_expire_label": "Rental Period Ended",
  "chapter.list_share_title": "Share",
  "chapter.list_share_kakaotalk_label": "Kakao Talk",
  "chapter.list_share_kakaotalk_message": "Go see it right now!",
  "chapter.list_share_instagram_label": "Instagram",
  "chapter.list_share_link_label": "Copy link",
  "chapter.list_share_link_message": "Link has been copied.",
  "chapter.list_rented_label_time1": "{{int_rentDay}}D {{int_rentHour}}H",
  "chapter.list_rented_label_time2": "{{int_rentDay}}D",
  "chapter.list_rented_label_time3": "{{int_rentHour}}H {{int_rentMinute}}M",
  "chapter.list_rented_label_time4": "{{int_rentHour}}H",
  "chapter.list_rented_label_time5": "{{int_rentMinute}}M",
  "chapter.list_charge_status": "Read episodes for free. ",
  "chapter.list_charge_time_day_description_zero": "Unlock a free episode after {{int_rentDay}} day",
  "chapter.list_charge_time_day_description_one": "Unlock a free episode after {{int_rentDay}} day",
  "chapter.list_charge_time_day_description_other": "Unlock a free episode after {{int_rentDay}} days",
  "chapter.list_charge_time_hour_description_zero": "Unlock a free episode after {{int_rentHour}} hr",
  "chapter.list_charge_time_hour_description_one": "Unlock a free episode after {{int_rentHour}} hr",
  "chapter.list_charge_time_hour_description_other": "Unlock a free episode after {{int_rentHour}} hrs",
  "chapter.list_charge_time_minute_description_zero": "Unlock a free episode after {{int_rentMinute}} min",
  "chapter.list_charge_time_minute_description_one": "Unlock a free episode after {{int_rentMinute}} min",
  "chapter.list_charge_time_minute_description_other": "Unlock a free episode after {{int_rentMinute}} mins",
  "chapter.list_charge_time_count_day_description": "{{int_rentDay}}D left",
  "chapter.list_charge_time_count_day_hour_description": "{{int_rentDay}}D {{int_rentHour}}H left",
  "chapter.list_charge_time_count_hour_description": "{{int_rentHour}}H left",
  "chapter.list_charge_time_count_hour_minute_description": "{{int_rentHour}}H {{int_rentMinute}}M left",
  "chapter.list_charge_time_count_minute_description": "{{int_rentMinute}}M left",
  "chapter.list_free_count": "{{int_count}} Free Episodes",
  "chapter.list_charge_info_alert_tittle": "Wait for Free Content",
  "chapter.list_charge_time_day_info_alert_message1_zero": "If you wait {{int_rentDay}} day after using the pass, we will give you 1 free pass.",
  "chapter.list_charge_time_day_info_alert_message1_one": "If you wait {{int_rentDay}} day after using the pass, we will give you 1 free pass.",
  "chapter.list_charge_time_day_info_alert_message1_other": "If you wait {{int_rentDay}} days after using the pass, we will give you 1 free pass.",
  "chapter.list_charge_time_hour_info_alert_message1_zero": "If you wait {{int_rentHour}} hour after using the pass, we will give you 1 free pass.",
  "chapter.list_charge_time_hour_info_alert_message1_one": "If you wait {{int_rentHour}} hour after using the pass, we will give you 1 free pass.",
  "chapter.list_charge_time_hour_info_alert_message1_other": "If you wait {{int_rentHour}} hours after using the pass, we will give you 1 free pass.",
  "chapter.list_charge_time_minute_info_alert_message1_zero": "If you wait {{int_rentMinute}} minute after using the pass, we will give you 1 free pass.",
  "chapter.list_charge_time_minute_info_alert_message1_one": "If you wait {{int_rentMinute}} minute after using the pass, we will give you 1 free pass.",
  "chapter.list_charge_time_minute_info_alert_message1_other": "If you wait {{int_rentMinute}} minutes after using the pass, we will give you 1 free pass.",
  "chapter.list_charge_time_info_alert_message2": "With this pass, you can rent for 3 days. ",
  "chapter.list_charge_time_info_alert_message3": "You cannot use the pass for the latest {{int_rentRecent}} episodes.",
  "chapter.list_purchase_purchased_chapter_button": "Purchased Episodes",
  "chapter.list_purchase_chapter_collect": "Purchase",
  "chapter.list_purchase_chapter_rent": "Rent",
  "chapter.list_purchase_chapter_free_charge": "Rent for Free",
  "chapter.list_purchase_alert_my_bubble": "My Bubbles",
  "chapter.list_purchase_alert_message": "Would you like to purchase an episode?",
  "chapter.list_purchase_failed_alert_message": "Your purchase could not be completed. Please try again.",
  "chapter.list_purchase_alert_footer_message": "Rental period is 72 hours. ",
  "chapter.edit_autosave_error_toast_message": "Autosave was unsuccessful. ",
  "chapter.edit_autosave_saving_text": "Autosave in Progress",
  "chapter.edit_autosave_success_text": "Autosave Complete",
  "chapter.edit_autosave_last_success_time_text": "Last Save",
  "chapter.read_config_font_size_change": "ขนาดตัวอักษร",
  "asset_browser.add": "Add",
  "asset_browser.in_use": "In Use",
  "asset_browser.max_num_images_limit_info_text": "Select up to 20 images.",
  "asset_browser.no_asset_in_use_message": "No assets in use. ",
  "asset_browser.character_image": "Character Image",
  "asset_browser.narrative_image": "Narrative Image",
  "setting.edit_email_verify_now_button": "ยืนยันอีเมล",
  "setting.edit_email_re_verify_button": "ยืนยันใหม่",
  "setting.edit_email_password_change_button": "กรุณายืนยันอีเมล",
  "setting.edit_email_verify_message": "Please confirm your email",
  "setting.edit_email_verify_info_text": "ยืนยันอีเมล<br/>เพื่อกู้รหัสผ่าน",
  "setting.edit_email_verify_text": "ใส่อีเมล",
  "setting.edit_email_verify_placeholder": "กรุณาใส่อีเมลที่ต้องการยืนยัน",
  "setting.edit_cancel_button": "ยกเลิก",
  "setting.edit_email_verify_verify_now_button": "ยืนยัน",
  "setting.edit_email_verify_validation_text": "กรุณาใส่อีเมลที่ถูกต้อง",
  "setting.edit_email_verify_success_message": "อีเมลยืนยัน<br/>ได้ถูกส่งไปยังที่อยู่อีเมลที่คุณใส่แล้ว",
  "setting.edit_email_verify_success_info_text": "กรุณายืนยันอีเมลของคุณภายใน 24 ชั่วโมง",
  "setting.edit_email_verify_fail_current_text": "นี่คืออีเมลที่ได้รับการยืนยันในปัจจุบัน",
  "setting.edit_email_verify_fail_use_text": "อีเมลนี้มีผู้ใช้แล้ว",
  "setting.edit_ok_button": "ยืนยัน",
  "setting.edit_email_verify_email_template_message": "ยืนยันอีเมล",
  "setting.edit_email_verify_email_template_guide_text": "กรุณาคลิกปุ่มด้านล่างหากต้องการยืนยันอีเมล",
  "setting.edit_email_verify_email_template_info_text": "อีเมลนี้มีอายุการใช้งาน 24 ชั่วโมง",
  "setting.edit_email_verify_email_template_click_here_button": "ยืนยัน",
  "setting.edit_email_verify_email_template_success_message": "ยืนยันสำเร็จ",
  "setting.edit_email_verify_email_template_success_text": "ขอบคุณสำหรับการยืนยัน! อีเมลของคุณยืนยันสำเร็จแล้ว",
  "setting.edit_email_verify_email_template_close_window_button": "ปิดหน้าต่าง",
  "setting.edit_email_verify_email_template_fail_message": "อีเมลยืนยันนี้ไม่สามารถใช้ได้อีกต่อไป",
  "setting.edit_email_verify_email_template_fail_text": "รหัสยืนยันหมดอายุ กรุณาลองใหม่อีกครั้ง",
  "setting.edit_email_verify_email_template_expiration_message": "อีเมลนี้ถูกยืนยันเรียบร้อยแล้ว",
  "setting.edit_email_verify_email_template_expiration_text": "กรุณายืนยันด้วยอีเมลอื่น",
  "setting.edit_email_verify_email_template_move_studio_button": "กลับไปยังสตูดิโอ",
  "setting.edit_email_re_verify_message": "กรุณายืนยันอีเมลใหม่อีกครั้ง",
  "setting.edit_email_re_verify_info_text": "คุณสามารถเปลี่ยนอีเมลยืนยันเป็นอีเมลอื่นได้ กรุณาใส่อีเมลใหม่",
  "setting.edit_autosave_setup_alert_title_message": "Setup Autosave",
  "setting.edit_autosave_setup_alert_description_message": "Set your episode autosave time",
  "setting.edit_autosave_setup_time_value_one_minute": "Autosave every 1 min",
  "setting.edit_autosave_setup_time_value_three_minutes": "Autosave every 3 min",
  "setting.edit_autosave_setup_time_value_five_minutes": "Autosave every 5 min",
  "setting.edit_autosave_setup_time_value_on": "ON",
  "setting.edit_autosave_setup_time_value_off": "OFF",
  "setting.edit_autosave_setup_time_status_one_minute": "1 min",
  "setting.edit_autosave_setup_time_status_three_minutes": "3 min",
  "setting.edit_autosave_setup_time_status_five_minutes": "5 min",
  "setting.edit_autosave_setup_time_status_minute": "min",
  "setting.edit_reading_tap_mode_title_message": "Tap Mode",
  "setting.edit_reading_tap_mode_description_message": "Navigate content by tapping.",
  "setting.edit_reading_scroll_mode_title_message": "Scroll Mode",
  "setting.edit_reading_scroll_mode_description_message": "Navigate content by scrolling.",
  "setting.edit_password_change_your_password_description": "กรุณาใส่รหัสผ่านปัจจุบันและรหัสผ่านใหม่",
  "setting.edit_password_change_your_password_message": "กรุณาเปลี่ยนรหัสผ่าน",
  "setting.edit_password_input_current_password_placeholder": "กรุณาใส่รหัสผ่านปัจจุบัน",
  "setting.edit_password_input_new_password_placeholder": "กรุณาใส่รหัสผ่านใหม่",
  "setting.edit_password_input_re_type_new_password_placeholder": "กรุณาใส่รหัสผ่านใหม่อีกครั้ง",
  "setting.edit_password_change_your_password_validation_text": "กรุณาใส่ตัวอักษรภาษาอังกฤษ, ตัวเลขและอักขระพิเศษ 8~25 ตัว ",
  "setting.edit_password_change_your_password_validation_toast": "คุณใส่รหัสผ่านไม่ถูกต้อง",
  "setting.edit_password_change_new_password_validation_toast": "คุณใส่รหัสผ่านปัจจุบันของคุณ กรุณาใส่รหัสผ่านอื่น",
  "setting.edit_password_change_success_message": "เปลี่ยนรหัสผ่านสำเร็จ",
  "setting.edit_password_change_success_text": "ตอนนี้คุณสามารถล็อกอิน<br/>ผ่านรหัสผ่านใหม่ได้แล้ว",
  "setting.edit_password_change_enable_validation_text": "คุณสามารถใช้รหัสผ่านนี้ได้",
  "setting.edit_password_change_new_password_again_placeholder": "กรุณาใส่รหัสผ่านใหม่อีกครั้ง",
  "setting.edit_password_change_new_password_match_validation_text": "รหัสผ่านใหม่ของคุณตรงกัน",
  "setting.edit_password_change_new_password_not_match_validation_text": "รหัสผ่านใหม่ของคุณไม่ตรงกัน",
  "setting.edit_setuppassword_title_message": "ตั้งค่ารหัสผ่าน",
  "setting.edit_setuppassword_description_message": "รหัสผ่านที่คุณตั้งไว้<br/>จะถูกใช้เมื่อคุณล็อกอินด้วยยูเซอร์โคดของคุณ",
  "setting.edit_setuppassword_new_password_placeholder": "กรุณาใส่รหัสผ่าน",
  "setting.edit_setuppassword_new_password_validation_text": "กรุณาใส่ตัวอักษรภาษาอังกฤษ, ตัวเลขและอักขระพิเศษ 8~25 ตัว ",
  "setting.edit_setuppassword_new_password_again_placeholder": "กรุณาใส่รหัสผ่านใหม่อีกครั้ง",
  "setting.edit_setuppassword_new_password_again_validation_text": "กรุณาใส่รหัสผ่านใหม่อีกครั้งหนึ่ง",
  "setting.edit_setuppassword_change_button": "ตั้งค่า",
  "setting.edit_setuppassword_alert_title": "ตั้งค่ารหัสผ่านสำเร็จ",
  "setting.edit_setuppassword_alert_description": "คุณสามารถล็อกอินด้วยรหัสผ่านนี้ได้",
  "register.userinfo_password_not_match_validation_text": "รหัสผ่านของคุณไม่ตรงกัน",
  "register.userinfo_password_match_validation_text": "รหัสผ่านของคุณตรงกัน",
  "email.template_footer_message": "อีเมลนี้ใช้สำหรับส่งอีเมลเท่านั้นหากมีคำถามเพิ่มเติมกรุณาติดต่อฝ่ายบริการลูกค้า",
  "email.template_title": "รีเซ็ตรหัสผ่าน",
  "email.template_password_reset_body_title": "รีเซ็ตรหัสผ่าน",
  "email.template_password_reset_body_description": "กรุณากดปุ่มด้านล่างหากต้องการรีเซ็ตรหัสผ่าน",
  "email.template_password_reset_reset_password_button": "รีเซ็ตรหัสผ่าน",
  "email.page_password_reset_success_title": "<strong>รีเซ็ตรหัสผ่านสำเร็จ</strong>.",
  "email.page_password_reset_success_description": "กรุณาล็อกอินด้วยรหัสผ่านใหม่",
  "email.page_password_reset_fail_title": "<strong>ลิงก์สำหรับรีเซ็ตรหัสผ่านใช้ไม่ได้เนื่องจากลิงก์หมดอายุ</strong>",
  "email.page_password_reset_fail_title_no_strong": "ลิงก์สำหรับรีเซ็ตรหัสผ่านใช้ไม่ได้เนื่องจากลิงก์หมดอายุ",
  "email.page_password_reset_fail_description": "กรุณาลองใหม่ด้วยอีเมลอื่น",
  "email.page_password_reset_validation_text": "กรุณาใส่ตัวอักษรภาษาอังกฤษและตัวเลขรวมกันแล้ว 8~25 ตัวอักษร",
  "email.page_password_reset_re_type_validation_text": "กรุณาใส่ตัวอักษรภาษาอังกฤษและตัวเลขรวมกันแล้ว 8~25 ตัวอักษร",
  "email.page_password_reset_re_type_match_validation_text": "กรุณาใส่รหัสผ่านเดียวกันอีกครั้ง",
  "block.account_title": "บัญชีของคุณถูกระงับ",
  "block.account_message": "หากมีข้อสงสัยกรุณาติดต่อที่ศูนย์บริการลูกค้า ",
  "block.account_re_active_date_text": "Reactivation Date",
  "block.account_contact_us_button": "Contact Us",
  "block.title_title": "Your story is blocked and cannot be published.",
  "block.useraccount_alert_message": "ตอนนี้คุณอยู่ในสถานะถูกระงับจากบับเบิลแชต",
  "block.community_alert_message": "You are blocked from community activity.",
  "block.account_unblocked_date_text": "Account Reinstatement Date",
  "block.reason": "Reason",
  "profile.introduction": "Introduction",
  "block.block_button": "บล็อก",
  "block.block_alert_title_character": "ต้องการบล็อกตัวละครนี้หรือไม่?",
  "block.block_toast_complete": "บล็อกสำเร็จแล้ว",
  "block.block_toast_failed": "บล็อกไม่สำเร็จ",
  "block.block_toast_failed2": "ไม่สามารถบล็อกเพิ่มเติมได้",
  "block.block_list": "รายการที่บล็อก",
  "block.block_list_empty_character": "ยังไม่มีตัวละครที่ถูกบล็อก",
  "block.unblock_toast_deleted": "ตัวละครนี้ถูกลบแล้ว",
  "block.unblock_button": "ยกเลิกการบล็อก",
  "block.unblock_alert_title_character": "ต้องการยกเลิกการบล็อกตัวละครนี้หรือไม่?",
  "block.unblock_toast_complete": "ยกเลิกการบล็อกสำเร็จแล้ว",
  "block.unblock_toast_failed": "ยกเลิกการบล็อกไม่สำเร็จ",
  "banner.body_title": "สร้างสตอรีของคุณ<be/>ที่บับเบิลแท็บสตูดิโอ",
  "banner.body_description": "คุณสามารถสร้างสตอรีที่หลากหลายและสนุกยิ่งขึ้นไปอีกได้ที่<br/>บับเบิลแท็บสตูดิโอ",
  "banner.body_button": "ไปยังบับเบิลแท็บสตูดิโอ",
  "footer.rights_message": "© 2025 Bubble Tap CO., LTD.",
  "footer.ceo_text": "CEO",
  "footer.ceo_name_text": "JB Park",
  "footer.address_text": "ที่อยู่",
  "footer.address_info_text": "5F, 207, Teheran-ro, Gangnam-gu, Seoul, Republic of Korea",
  "footer.company_name_text": "Bubble Tap CO., LTD.",
  "footer.tel_text": "TEL",
  "footer.tel_info_text": "＋82 02-2039-7572",
  "footer.email_text": "Email ",
  "footer.email_info_text": "th.support@bubbletap.com",
  "footer.registration_number_text": "เลขทะเบียนนิติบุคคล",
  "footer.registration_bus_report_num": "เลขอนุญาตธุรกิจโทรคมนาคม",
  "browser.support_alert_title_message": "Please update your web browser!",
  "browser.support_alert_description_message": "BubbleChat Studio is optimized for your browser's latest version.",
  "browser.support_alert_chrome_description_message": "BubbleChat Studio is compatible with Google Chrome version 9 and above.  ",
  "browser.support_alert_edge_description_message": "BubbleChat Studio is compatible with Microsoft Edge version 18 and above.  ",
  "browser.support_alert_safari_description_message": "BubbleChat Studio is compatible with Safari version 14 and above.  ",
  "browser.support_alert_firefox_description_message": "BubbleChat Studio is compatible with Mozilla Firefox version 65 and above.  ",
  "browser.support_alert_ie_description_message": "Unfortunately, Internet Explorer is not supported.",
  "error.page_title_message": "Incorrect URL",
  "error.page_description_message": "Click the button below to visit the BubbleChat website.",
  "error.page_bubblechat_go_button": "Go to the BubbleChat website",
  "contest.agree_message": "Participate",
  "contest.agree_confirm_message": "{{string_contestName}}' is participating.",
  "contest.agree_alert_title": "{{string_contestName}}' participation information",
  "contest.agree_alert_description": "By checking this box, you agree to participate in the current contest.",
  "contest.publish_alert_title": "You cannot publish this episode.",
  "contest.publish_alert_description_first": "Each episode entry must be at least {{int_mintext}} characters long.",
  "contest.publish_alert_description_second": "Character count:",
  "contest.save_alert_title": "You cannot save this episode.",
  "contest.save_alert_description_first": "Each episode entry must be at least {{int_mintext}} characters long.",
  "contest.save_alert_description_second": "Character count:",
  "contest.delete_alert_title": "You cannot delete this story.",
  "contest.delete_alert_description": "Story can only be deleted when in draft format.",
  "contest.modify_alert_title": "You cannot modify this story.",
  "contest.modify_alert_description": "While your entry is being evaluated, you cannot edit or delete your story.",
  "contest.edit_draft_alert_title": "You cannot modify this story.",
  "contest.edit_draft_alert_description": "While your entry is being evaluated, you cannot edit your story.",
  "contest.bubbleup.challenge_message": "Challenge",
  "contest.bubbleup.challenge_description": "Anyone can do it!",
  "contest.edit_draft_alert_character_title": "You cannot modify this character.",
  "contest.edit_draft_alert_character_description": "While your entry is being evaluated, you cannot edit your characters.",
  "contest.edit_draft_alert_warning_message": "If you delete this story, your participation in contest will be canceled.",
  "contest.agree_end_error_alert_tittle": "You cannot participation in contest. ",
  "contest.agree_end_error_alert_message": "You cannot participate because the contest or event has ended.",
  "contest.title": "การประกวด",
  "profile.edit_username_description": "เปลี่ยนยูเซอร์โคด",
  "profile.edit_writername_description": "เปลี่ยนชื่อเล่น",
  "profile.edit_username_description_message": "กรุณาใส่ยูเซอร์โคดใหม่",
  "profile.edit_writername_description_message": "กรุณาใส่ชื่อเล่นใหม่",
  "profile.edit_username_duplicate_message": "ยูเซอร์โคดนี้ถูกใช้แล้ว",
  "profile.category_community_other_post_list_null_message": "ลองสร้างโพสต์แรกดูสิ!",
  "profile.following_suggestion": "เริ่มติดตาม",
  "profile.gather_followers": "รวบรวมผู้ติดตาม",
  "profile.category_community_post_list_null_message": "ยังไม่มีโพสต์",
  "profile.sns_category_following_list_null_message": "คุณไม่ได้ติดตามใครเลย",
  "profile.sns_category_follower_list_null_message": "คุณยังไม่มีผู้ติดตาม",
  "notice.legal_content_alert_message": "This website and its entire content, including but not limited to text, graphics, images, logos, and multimedia, are the property of BubbeTap Corp.\nand may only be used within the BubbleChat Studio and BubbleChat App platform. Any use of this website's content, including reproduction, modification,\ndistribution, transmission, republication, display, or performance, without the explicit written consent of BubbleChat Corp. is strictly prohibited. ",
  "notice.legal_content_alert_create_story_title_message": "Please read the precautions!",
  "notice.legal_content_alert_create_story_main_message": "Violating any of the following when creating stories, episodes, titles, covers, text, and characters  may be subject to sanctions in accordance with the BubbleChat Operating Policy and any applicable laws.",
  "notice.legal_content_alert_create_story_body_message1": "Illegally sharing or posting the intellectual property of others, including, but not limited to, other BubbleChat members, without their consent",
  "notice.legal_content_alert_create_story_body_message2": "Creating and distributing works, covers, characters, etc. that divulge personal information, violate privacy, portray third parties in a defamatory way, or infringe on the rights of others, including, but not limited to, celebrities",
  "notice.legal_content_alert_create_story_body_message3": "Deceiving others by impersonating someone other than yourself or disseminating false information",
  "notice.legal_content_alert_create_story_body_message4": "Repeatedly using excessive profanity, abusive language, etc. to cause disgust, discomfort, or fear",
  "notice.legal_content_alert_create_story_body_message5": "Creating or disseminating violent and inflammatory content",
  "notice.legal_content_alert_create_story_body_message6": "Creating or disseminating pornographic material or material depicting graphic sexual acts",
  "notice.legal_content_alert_create_story_body_message7": "Content that makes direct and explicit threats of violence against others, or that encourages others to engage in self-harming behavior or suicide.",
  "notice.legal_content_alert_create_story_body_message8": "Promotes discrimination or prejudice against a particular person or group of people",
  "notice.legal_content_alert_create_story_body_message9": "Engaging in, or teaching or aiding and abetting, any conduct that is prohibited by applicable law or that is subject to criminal penalties.",
  "notice.legal_content_alert_create_story_body_message10": "Promoting, advertising, or selling any goods or services prohibited by applicable law",
  "notice.legal_content_alert_create_story_body_message11": "Creating or disseminating content that poses a direct and serious threat to public safety",
  "notice.legal_content_alert_create_story_body_message12": "BubbleChat may and will take action to remove or suspend your account without notice for publishing any material in violation of these terms.",
  "notice.legal_content_alert_create_story_body_message13": "BubbleChat may use the text, images, and other parts of the created stories for purposes of advertising or marketing BubbleChat, the created story from which the text, image, etc. is utilized, or as BubbleChat deems required and relevant.",
  "notice.legal_content_alert_create_story_tail_message": "Users shall indemnify and hold BubbleChat harmless from<br/>all legal actions, suits, claims or judgements arising from<br/>any of violation of these terms and conditions.",
  "notice.legal_content_alert_create_story_button": "Create a story after agreeing",
  "ai.create_edit_title.cover_name": "AI Service",
  "ai.create_edit_title.name": "AI Image",
  "ai.create_edit_title.cover_message": "Create your own cover with BubbleChat AI.",
  "ai.create_screen_title.image_similarity_name": "Similarity",
  "ai.create_screen_title.image_similarity_message": "The greater the similarity, the closer to the original image!",
  "ai.create_screen_title.image_style_name": "Style",
  "ai.create_screen_title.image_view_all_name": "View all",
  "ai.create_screen_title.image_prompt_name": "Prompt",
  "ai.create_screen_title.image_prompt_example_name": "Prompt example",
  "ai.create_screen_title.image_prompt_example_description1": "Change the background and place the woman in space.",
  "ai.create_screen_title.image_prompt_example_description2": "A woman in space.",
  "ai.create_screen_title.image_prompt_example_description3": "Age this person to look like they’re in their 80s and give me a full-body shot.",
  "ai.create_screen_title.image_prompt_example_description4": "Elderly person, wrinkles, full-body shot",
  "ai.create_screen_title.image_prompt_example_description5": "Boy, expressionless, blonde, fair skin, white t-shirt, jeans, forest",
  "ai.create_screen_title.image_prompt_example_description6": "A handsome man in his 20s with brown hair and green eyes wearing a sky blue shirt over a white t-shirt and black pants with a gentle smile on his face; rainy weather; road; holding an umbrella.",
  "ai.create_screen_title.image_prompt_example_description7": "A man lying on a sunbed on the beach holding a cocktail and sunbathing; palm trees; seagulls",
  "ai.create_screen_title.image_prompt_example_description8": "silhouette style, cinematic film still of the silhouette of an owl sitting on a branch at night, very detailed, haze lighting, backlit, 4k uhd masterpiece",
  "ai.create_screen_title.image_prompt_description": "Please write a description of your desired image.",
  "ai.create_screen_title.original_image_button": "Use as is",
  "ai.create_screen_title.random_image_button": "Create a random image",
  "ai.create_screen_title.ai_image_button": "Create an image with AI",
  "ai.create_screen_title.return_message": "Do you want to quit without using the image you created?",
  "ai.create_studio_background_color_edit_name": "Edit background color",
  "ai.create_studio_background_upload_fail_message": "Uploading the image you entered failed.",
  "ai.create_studio_background_example_description1": "Blue skies and wide coastlines",
  "ai.create_studio_background_example_description2": "Overall blue sky background",
  "ai.create_studio_background_example_description3": "The upper part is a gray ceiling, the lower part is classroom desks and chairs.",
  "ai.create_studio_background_example_description4": "Blue sky and mountains, old hanok alley",
  "ai.create_studio_background_example_description5": "A city illuminated by rainy skies and atmospheric lights.",
  "ai.create_studio_background_example_description6": "Pastel colored warehouse interior",
  "ai.create_studio_background_example_description7": "Outdoor swimming pool with dark starry sky",
  "ai.create_studio_background_example_description8": "White margin at the top of the image, alley between houses at the bottom",
  "ai.loading_screen_advertising_message1": "เรื่องราวสนุกสนานผ่านปลายนิ้วของคุณ",
  "ai.loading_screen_advertising_message2": "ลองสนุกสนานไปกับสตอรีของคุณที่สร้างได้ไม่ยากได้ในบับเบิลแชต!",
  "ai.loading_screen_alert_description": "Current number in the queue",
  "ai.loading_screen_alert_message": "Creating AI image",
  "ai.loading_screen_alert_message2": "Waiting for service connection.",
  "ai.result_screen_alert_message": "AI image creation complete!",
  "ai.result_screen_alert_prompt_description1": "Add a prompt!",
  "ai.result_screen_alert_prompt_description2": "Change your prompt!",
  "ai.result_screen_title.ai_image_button1": "Recreate",
  "ai.result_screen_title.ai_image_button2": "Use",
  "ai.result.fail_create_image_message": "AI image creation failed.",
  "ai.button_background": "พื้นหลัง",
  "notification.list_title": "Notifications",
  "notification.my_news_title": "For Me",
  "notification.freebie_reads_title": "Freebie Reads",
  "notification.events_title": "Events",
  "notification.bubble_title": "Your Currency",
  "notification.notice_title": "Announcements",
  "notification.list_unread_notification": " การแจ้งเตือนที่ยังไม่ได้อ่าน",
  "notification.list_all_read": " อ่านทั้งหมด",
  "notification.delete_90days_message": "You have no notifications.",
  "notification.delete_90days_message_part2": "Notifications are deleted after 90 days.",
  "notification.notice_history_headline_description": "You can check notification details in the Bubble Tap app.",
  "tag.title": "Tags",
  "tag.selection": "เลือก 1-10 แท็ก",
  "tag.selection_notification": "Select one or more tags.",
  "tag.suggestion_button": "Suggest tags",
  "tag.suggestion_title": "Suggest tags",
  "tag.suggestion_description": "Let us know what tags you would like to add,<br/>and they may get added after internal review!",
  "tag.suggestion_placeholder": "Create tag name and request",
  "tag.suggestion_submission_button": "Suggestion",
  "tag.selection_untap": "Select tags and find the story you want!",
  "tag.suggestion_no_match": "There are no stories that fit the tag.",
  "search.category_story_tab_msg": "Search for the story you want to read.",
  "search.category_profile_tab_msg": "ค้นหาชื่อเล่นที่คุณต้องการค้นหา",
  "search.category_title_list_null_message": "No story matches your query.",
  "search.category_profile_null_message": "ไม่พบชื่อเล่นที่ตรงกัน",
  "search.asset_none": "The asset you are looking for is not found.",
  "search.story": "Find the story you want to read.",
  "topup.purchase_receive_bonus": "Participate in events and receive bonuses.",
  "report.result_title": "เราได้รับรายงานของคุณแล้ว",
  "report.result_description": "เราจะตรวจสอบ<br/>รายงานที่คุณส่งโดยละเอียด",
  "report.error_occurred": "เกิดข้อผิดพลาดระหว่างส่งรายงาน!",
  "report.result_fail_description": "ขออภัยในความไม่สะดวก <br/>กรุณาลองใหม่อีกครั้ง",
  "report.type.chat_sexual_content": "เนื้อหาที่เกี่ยวกับทางเพศ",
  "report.type.chat_violent_content": "เนื้อหาที่เกี่ยวกับความรุนแรง",
  "report.type.chat_hate_discrimination": "เนื้อหาที่มีการเหยียดหยามและสร้างความแตกแยก",
  "report.type.chat_privacy_violation": "การคุกคามสิทธิหรือเนื้อหาอันเป็นส่วนบุคคล",
  "report.type.chat_other": "อื่นๆ",
  "chapter.read_end_comment_list_null_message": "Please write a comment.",
  "chapter.list_null_message": "No published stories.",
  "library.category_favorites_asset_add_msg": "Register your favorite<br/>assets as favorites.",
  "library.category_favorites_list_null_message": "Bookmark the stories you are interested in.",
  "library.category_purchased_story_list_null_message": "ซื้อสตอรี",
  "network.internet_no_connection_title": "Network Error.",
  "network.internet_no_connection_message": "There is a problem with your internet connection.<br/>Please try again.",
  "setting.edit_delete_account_button": "ลบบัญชี",
  "setting.edit_delete_account_screen_name": "ลบบัญชี",
  "setting.edit_delete_account_screen_agree_alert_set_password_title": "กรุณาตั้งรหัสผ่าน",
  "setting.edit_delete_account_screen_agree_alert_set_password_description": "คุณยังไม่ได้ตั้งรหัสผ่าน กรุณาตั้งรหัสผ่าน",
  "setting.edit_delete_account_screen_title": "คุณแน่ใจว่าต้องการลบบัญชีของคุณใช่หรือไม่?",
  "setting.edit_delete_account_screen_description": "หากลบบัญชีแล้วคุณจะไม่สามารถเข้าถึงเนื้อหาคนบับเบิลแชตได้",
  "setting.edit_delete_account_screen_agree_message": "ฉันได้อ่านและยอมรับข้อกำหนดตามที่ระบุไว้",
  "setting.edit_delete_account_screen_agree_story_message": "ทุกสตอรีที่คุณสร้างขึ้นจะถูกลบและไม่สามารถกู้คืนได้<br/>นอกจากนี้เนื้อหาที่จ่ายเงินและฟรีทั้งหมดรวมไปถึงสตอรีที่ซื้อจะถูกลบและไม่สามารถกู้คืนได้เช่นกัน",
  "setting.edit_delete_account_screen_agree_post_message": "All content and posts created by this account will be lost. Content and posts shared or reproduced by a third party will not be deleted.",
  "setting.edit_delete_account_screen_agree_revenue_message": "บันทึกยอดขายที่มาจากเนื้อหาของบัญชีนี้ทั้งหมดจะหายไปและไม่สามารถกู้คืนได้<br/>นอกจากนี้คุณจะไม่สามารถถอนยอดขายที่ค้างอยู่ในบัญชีนี้ได้",
  "setting.edit_delete_account_screen_agree_delete_message": "In accordance with relevant regulations, personal data will be stored for the mandated time and then deleted.",
  "setting.edit_delete_account_screen_agree_verification_message": "You cannot re-verify your identity for seven days if you delete your account post identity verification.",
  "setting.edit_delete_account_screen_agree_confirm_password_message": "Enter your password to verify you are the account holder.",
  "setting.edit_delete_account_screen_agree_alert_agree_title": "Please agree to all of the terms and conditions.",
  "setting.edit_delete_account_screen_agree_alert_agree_description": "You may delete your account if you agree to the following terms and conditions.",
  "setting.edit_delete_account_screen_agree_alert_password_title": "Incorrect Password",
  "setting.edit_delete_account_screen_agree_alert_password_description": "Please enter your current password.",
  "setting.edit_delete_account_screen_agree_alert_delete_account_title": "Account Successfully Deleted",
  "setting.edit_delete_account_screen_agree_alert_delete_account_description": "บับเบิลแชตยังคงรอสตอรีของทุกท่านอยู่เสมอ!",
  "identity.verification": "ยืนยันตัวตน",
  "identity.verification.adult": "การยืนยันตัวตน",
  "identity.verification_request": "กรุณายืนยันตัวตน",
  "identity.verification_completed": "ยืนยันตัวตนสำเร็จ",
  "identity.reverification_completed_title": "การยืนยันตัวตนซ้ำเสร็จสิ้นแล้ว",
  "identity.reverification_completed_description": "ตอนนี้คุณสามารถเข้าถึงเนื้อหาสำหรับผู้ใหญ่ได้",
  "identity.verification_explanation1": "การยืนยันตัวตนเป็นกระบวนการที่ถูกต้องตามกฎหมายเพื่อยืนยันว่าบัญชีที่คุณใช้เป็นของคุณ",
  "identity.verification_explanation2": "คุณสามารถยืนยันตัวตนของคุณด้วยชื่อเดียวกันได้สูงสุด 2 บัญชี",
  "identity.verification_explanation3": "เมื่อการยืนยันตัวตนของคุณสำเร็จแล้ว คุณจะไม่สามารถยกเลิกรายละเอียดหรือเปลี่ยนชื่อได้",
  "identity.verification_explanation4": "หากคุณได้รับเลือกให้เข้าร่วมบับเบิลอัปคุณจะต้องยืนยันตัวตนให้เสร็จสิ้นก่อนดำเนินการตามขั้นตอนถัดไป",
  "identity.verification_notify1": "ฉันยินยอม<link1>ให้มีการรวบรวมและใช้ข้อมูลส่วนบุคคล<link1>",
  "identity.verification_notify2": "ฉันตกลงที่จะรับผิดชอบทางกฎหมายหากฉันใช้ชื่อของบุคคลอื่นหรือให้ข้อมูลส่วนตัวที่ไม่ใช่ของตนเอง",
  "identity.verification_toverify": "ยืนยัน",
  "identity.verification_expired": "การยืนยันตัวตนหมดอายุ",
  "identity.verification_success": "ยืนยันตัวตนสำเร็จ",
  "identity.verification_completed2": "ยืนยันสำเร็จ",
  "identity.verification_complete_date": "วันที่ยืนยันตัวตนสำเร็จ",
  "identity.verification_failed": "ยืนยันตัวตนไม่สำเร็จ",
  "identity.verification_cancelled": "ผู้ใช้ยกเลิกการยืนยันตัวตน",
  "identity.verification_failed_reason_unknown": "ล้มเหลวด้วยเหตุผลที่ไม่อาจทราบได้",
  "identity.verification_fail_message": "ยืนยันตัวตนไม่สำเร็จ",
  "identity.verification_success_message": "ยืนยันตัวตนสำเร็จ",
  "charging_stn.free_tap": "สถานีบับเบิลฟรี",
  "charging_stn.paid_tap": "สถานีเติมบับเบิล",
  "charging_stn.free_msg_choose_button": "กดปุ่มที่ชอบ",
  "charging_stn.free_msg_get_bubbles": "รับบับเบิลฟรี",
  "charging_stn.top_title": "สถานีเติมบับเบิล",
  "charging_stn.top_title_a": "ฟรีบับเบิล",
  "charging_stn.button_bubble": "สถานีเติมบับเบิล",
  "charging_stn.button_preparing": "กำลังเตรียม",
  "charging_stn.info_msg": "ข้อมูลเกี่ยวกับสถานีเติมบับเบิล",
  "charging_stn.info_msg_expiration": "รางวัลจากโฆษณาที่จ่ายผ่านสถานีจะมีอายุการใช้งาน 7 วัน",
  "charging_stn.info_msg_refund": "รางวัลจากโฆษณาที่จ่ายผ่านสถานีไม่สามารถขอคืนได้",
  "charging_stn.info_msg_charge_time": "หลังจากเล่นโฆษณา, อาจต้องใช้เวลาถึง 3 นาทีในการได้รับบับเบิล",
  "charging_stn.info_msg_inquiry": "ในกรณีที่ไม่สามารถเติมบับเบิลได้ โปรดติดต่อส่งแบบสอบถามสถานีแต่ละแห่งและทางเราจะทำการจ่ายให้หลังตรวจสอบ",
  "charging_stn.free_button": "สถานีเติมบับเบิลเลขที่ {{int_number}} ",
  "payment.page_bubble_zero": "บับเบิลของฉัน",
  "payment.page_bubble_one": "บับเบิลของฉัน",
  "payment.page_bubble_other": "บับเบิลของฉัน",
  "payment.page_paid_bubble_zero": "บับเบิลที่มีค่าใช้จ่าย",
  "payment.page_paid_bubble_one": "บับเบิลที่มีค่าใช้จ่าย",
  "payment.page_paid_bubble_other": "บับเบิลที่มีค่าใช้จ่าย",
  "payment.page_bonus_bubble_zero": "โบนัสบับเบิล",
  "payment.page_bonus_bubble_one": "โบนัสบับเบิล",
  "payment.page_bonus_bubble_other": "โบนัสบับเบิล",
  "payment.page_reward_bubble_zero": "แลกบับเบิล",
  "payment.page_reward_bubble_one": "แลกบับเบิล",
  "payment.page_reward_bubble_other": "แลกบับเบิล",
  "payment.page_purchase_tab": "เติม",
  "payment.page_spent_tab": "ซื้อ",
  "payment.page_bonus_tab": "โบนัส",
  "payment.page_list_bubble_zero": "บับเบิล",
  "payment.page_list_bubble_one": "บับเบิล",
  "payment.page_list_bubble_other": "บับเบิล",
  "payment.history_rewards": "รางวัล",
  "payment.history_awarded_bonus": "การจ่ายโบนัส",
  "payment.history_expired_bonus": "โบนัสหมดอายุ",
  "payment.history_ad_reward": "การจ่ายรางวัลจากโฆษณา",
  "payment.history_adj": "การแก้ไข",
  "payment.history_purchased_ep": "การซื้อตอน",
  "payment.history_rented_ep": "การเช่าตอน",
  "payment.history_in_app_purchase": "การชำระเงินแบบ In-app",
  "payment.history_topup_bubble": "ซื้อบับเบิล",
  "payment.history_refunded": "การขอคืน",
  "payment.history_receive_bonus": "ลองเข้าร่วมกิจกรรมและรับโบนัสดูสิ",
  "payment.history_purchase_shampoo_title": "ซื้อ",
  "payment.history_purchase_shampoo_detail": "ซื้อแชมพู",
  "payment.history_refund_shampoo": "ขอคืน",
  "payment.history_refund_for_censored_image": "ขอคืนเงินภาพที่ถูกเซนเซอร์",
  "payment.status_progress": "กำลังดำเนินการชำระเงิน",
  "payment.status_failed": "การชำระเงินไม่สำเร็จ หากต้องการสอบถามเพิ่มเติมกรุณาติดต่อ</link1>ฝ่ายบริการลูกค้า </link1>",
  "payment.status_invalid_info": "ข้อมูลบัตรไม่ถูกต้อง<br/>กรุณาลองใหม่อีกครั้ง",
  "payment.status_completed": "ชำระเงินสำเร็จ",
  "payment.status_successful": "ชำระเงินสำเร็จ!",
  "payment.unavailable_paid_episodes": "ไม่สามารถเช่าหรือซื้อตอนที่ต้องชำระเงินได้",
  "chat.home_home_title": "โฮม",
  "chat.home_characters_title": "ตัวละคร",
  "chat.home_characters_count_zero": "ตัวละคร",
  "chat.home_characters_count_one": "ตัวละคร",
  "chat.home_characters_count_other": "ตัวละคร",
  "chat.home_universes_title": "จักรวาล",
  "chat.home_universes_count_zero": "จักรวาล",
  "chat.home_universes_count_one": "จักรวาล",
  "chat.home_universes_count_other": "จักรวาล",
  "chat.home_scenes_title": "ฉาก",
  "chat.home_scenes_count_zero": "ฉาก",
  "chat.home_scenes_count_one": "ฉาก",
  "chat.home_scenes_count_other": "ฉาก",
  "chat.home_nsfw_toggle": "โหมดตื่นเต้น",
  "chat.home_nsfw_toggle_modal_title": "",
  "chat.home_nsfw_toggle_modal_description": "",
  "chat.home_nsfw_toggle_modal_confirm": "",
  "chat.home_nsfw_toggle_modal_cancel": "",
  "chat.home_nsfw_toggle_reject_country_modal_title": "",
  "chat.home_first_title": "ตัวละครและจักรวาลของคุณ",
  "chat.home_first_select_character": "ตัวละครไหนที่คุณต้องการสนทนา?",
  "chat.home_first_select_character_female": "ตัวละครหญิง",
  "chat.home_first_select_character_male": "ตัวละครชาย",
  "chat.home_first_start_chat": "เริ่มแชต",
  "chat.home_first_failed_character_list_message": "เรียกดูรายชื่อตัวละครไม่สำเร็จ",
  "chat.home_first_failed_character_list_refresh_message": "กรุณารีเฟรชใหม่อีกครั้ง",
  "chat.home_first_failed_character_list_refresh_button": "รีเฟรช",
  "chat.home_nsfw_toggle_mobile": "โหมดตื่นเต้น",
  "chat.home_first_shampoo_empty": "แชมพูของคุณถูกใช้หมดแล้ว",
  "chat.home_first_verification_super_shampoo": "หากคุณยืนยันตัวตนตอนนี้คุณจะได้รับการอัปเกรดเป็นเมจิกโพชันทันที เพื่อให้คุณได้ลองประสบการณ์เมจิกโพชันที่จะทำให้คุณแชตได้อย่างอิสระเป็นเวลา 24 ชั่วโมง ",
  "chat.home_first_verification_super_shampoo_description": "ซูเปอร์แชมพูให้คุณแชตได้มากกว่าแชมพูทั่วไปถึง 10 เท่า!<br/>*คุณสามารถแชตได้ฟรีในกรณีที่มีแชมพูเต็มอยู่<br/>*การเติมแชมพูอาจใช้เวลานานสูงสุดถึง 24 ชั่วโมง",
  "chat.home_first_verification_no_thanks": "ไม่ ขอบคุณ",
  "chat.home_first_verification_button": "ยืนยันตัวตน",
  "chat.home_first_upgrade_super_shampoo": "อัปเกรดเป็นซูเปอร์แชมพู!",
  "chat.home_first_shampoo_bubbles_empty": "แชมพูและบับเบิลของคุณถูกใช้หมดแล้ว",
  "chat.home_first_normal_shampoo_empty": "แชมพูของคุณถูกใช้หมดแล้ว",
  "chat.home_first_get_super_shampoo": "รับซูเปอร์แชมพู",
  "chat.home_first_no_show_again": "ไม่ต้องแสดงอีก",
  "chat.home_first_verification_super_shampoo_upgrade": "เมื่อยืนยันตัวตนเป็นครั้งแรก คุณจะได้รับการอัปเกรดเป็น 'ซูเปอร์แชมพู' เป็นเวลา 24 ชั่วโมง ทำให้คุณสนทนาฟรีได้มากยิ่งขึ้น!",
  "chat.home_first_sign_in": "ล็อกอินและลองใช้<strong>แชมพู</strong>คุยฟรี<br/><strong> ทุกวัน</strong>ดูสิ!",
  "chat.home_first_start_kakao": "เริ่มใช้งานด้วย <strong>Kakao</strong>",
  "chat.home_first_start_google": "เริ่มใช้งานด้วย <strong>Google</strong>",
  "chat.home_first_start_apple": "เริ่มใช้งานด้วย <strong>Apple</strong>",
  "chat.home_first_welcome_title": "ยินดีต้อนรับ",
  "chat.home_first_welcome_sub_title": "เพื่อฉลองการสมัครสมาชิกเราได้มอบซูเปอร์แชมพูให้คุณแล้ว! ลองคุยกับตัวละครให้หลากหลายและมากขึ้นดูสิ",
  "chat.home_first_welcome_description": "หากคุณต้องการแชตฟรีเพิ่มขึ้น 10 เท่า โปรดยืนยันตัวตนและรับซูเปอร์แชมพู",
  "chat.home_first_welcome_regular": "ใช้แชมพูปกติ",
  "chat.home_first_welcome_super": "รับซูเปอร์แชมพู",
  "chat.home_first_wait_title": "เดี๋ยว! คุณยังสามารถสนทนาได้อีก",
  "chat.home_first_wait_description": "ยืนยันตัวตนภายใน 10 วินาทีนี้รับไปเลยซูเปอร์แชมพูเพื่อปลดล็อกแชตฟรี",
  "chat.home_first_wait_topup": "เติมเงิน",
  "chat.home_first_wait_verify": "ยืนยันตัวตน",
  "chat.home_first_supershampoo_title": "อัปเกรดเป็นซูเปอร์แชมพูสำเร็จ!",
  "chat.home_first_supershampoo_description": "ตอนนี้คุณสามารถแชตได้มากขึ้น 10 เท่าเป็นเวลา 24 ชั่วโมง<br/>เช็กซูเปอร์แชมพูได้ที่ [My Page]",
  "chat.home_first_supershampoo_done": "สำเร็จ",
  "chat.home_more_button": "ดูเพิ่มเติม",
  "chat.home_sidebar_create": "สร้าง",
  "chat.home_sidebar_reward": "รางวัล",
  "chat.home_recent_chats": "แชตล่าสุด",
  "chat.title_chat_list": "รายการแชต",
  "chat.home_sidebar_chat_list": "รายการแชต",
  "chat.home_sidebar_favorites": "รายการโปรด",
  "chat.home_sidebar_likes": "ถูกใจ",
  "chat.home_sidebar_charging_station": "สถานีเติมเงิน",
  "chat.home_sidebar_guide": "ไกด์",
  "chat.home_sidebar_bg_fx": "กำหนดฉาก",
  "chat.home_sidebar_bubbletap": "บับเบิลแท็บ",
  "chat.home_sidebar_download": "ดาวน์โหลด",
  "chat.home_sidebar_display": "โหมดหน้าจอ",
  "chat.home_sidebar_community": "คอมมูนิตี้",
  "chat.home_sidebar_discord": "Discord",
  "chat.home_sidebar_bubble_apartment": "อพาร์ตเมนต์บับเบิล",
  "chat.home_sidebar_facebook": "Facebook",
  "chat.home_sidebar_x": "บัญชีทางการ X",
  "chat.home_sidebar_kakaotalk": "KakaoTalk",
  "chat.home_sidebar_threads": "Threads",
  "chat.home_sidebar_instagram": "Instagram",
  "chat.home_sidebar_pinterest": "Pinterest",
  "chat.tap_order_recent": "ล่าสุด",
  "chat.tap_order_liked": "ถูกใจมากที่สุด",
  "chat.tap_order_played": "เล่นมากที่สุด",
  "chat.tap_asset_sort_all": "ทั้งหมด",
  "chat.tap_asset_sort_week": "รายอาทิตย์",
  "chat.tap_asset_sort_month": "รายเดือน",
  "chat.tap_asset_tap_rising": "กำลังมาแรง",
  "chat.tap_asset_tap_follow": "ติดตาม",
  "chat.tap_asset_tap_follow_empty": "ยังไม่ได้ติดตามครีเอเตอร์คนไหนเลย",
  "chat.tap_asset_tap_follow_featured_creators": "แนะนำครีเอเตอร์",
  "chat.tap_asset_tap_follow_featured_creators_failed": "ไม่สามารถดึงข้อมูลครีเอเตอร์แนะนำได้<br/>กรุณาลองใหม่อีกครั้งในภายหลัง",
  "chat.tap_asset_tap_now": "เรียลไทม์",
  "chat.tap_asset_more_options_button": "ตั้งค่าเพิ่มเติม",
  "chat.tap_asset_more_options_modal_title": "ตัวกรอง",
  "chat.tap_asset_more_options_modal_sort": "เรียงตาม",
  "chat.tap_asset_more_options_modal_gender": "เพศตัวละคร",
  "chat.tap_asset_modal_all_characters": "ตัวละครทั้งหมด",
  "chat.tap_asset_modal_male_characters": "ตัวละครชาย",
  "chat.tap_asset_modal_female_characters": "ตัวละครหญิง",
  "chat.tap_asset_modal_other_characters": "ตัวละครอื่น ๆ",
  "chat.tap_asset_modal_type": "ประเภท",
  "chat.tap_asset_modal_random": "สุ่ม",
  "chat.tap_asset_more_options_modal_latest": "ล่าสุด",
  "chat.tap_asset_more_options_modal_multi_images": "หลายภาพ",
  "chat.tap_asset_more_options_modal_most": "มากที่สุด",
  "chat.tap_asset_more_options_modal_least": "น้อยที่สุด",
  "chat.tap_asset_more_options_modal_none": "ไม่มี",
  "chat.tap_asset_more_options_modal_most_commented": "คอมเมนต์มากที่สุด",
  "chat.tap_asset_more_options_modal_sort_none": "ไม่ได้เลือก",
  "chat.tap_asset_empty": "ไม่พบผลลัพธ์ที่ตรงกัน",
  "chat.home_login": "ล็อกอิน",
  "chat.home_terms_of_service": "ข้อกำหนดการให้บริการ",
  "chat.home_privacy_policy": "นโยบายความเป็นส่วนตัว",
  "chat.home_operational_policy": "นโยบายการดำเนินงาน",
  "chat.home_juvenile_protection_policy": "นโยบายความปลอดภัยของเด็กและเยาวชน",
  "chat.home_app_downloads_appstore": "ดาวน์โหลดบับเบิลแชตจาก App Store",
  "chat.home_app_downloads_googleplay": "ดาวน์โหลดบับเบิลแชตจาก Google Play",
  "chat.home_notification_list_unread": "แจ้งเตือนที่ไม่ได้อ่าน",
  "chat.home_notification_list_read_all": "อ่านทั้งหมดแล้ว",
  "chat.home_notification_list_view_more": "ดูเพิ่มเติม",
  "chat.home_notification_setting": "ตั้งค่าการแจ้งเตือน",
  "chat.home_notification_setting_agree_date": "วันที่ยอมรับแจ้งเตือน",
  "update.setting_comment_label": "แจ้งเตือนความเห็น",
  "update.setting_comment_description": "คุณจะได้รับแจ้งเตือนเมื่อมีความเห็นใหม่ในแอสเซตของคุณ",
  "update.setting_reply_label": "แจ้งเตือนความเห็นตอบกลับ",
  "update.setting_reply_description": "คุณจะได้รับแจ้งเตือนเมื่อมีความเห็นตอบกลับใหม่ในความเห็นของคุณ",
  "update.setting_like_label": "แจ้งเตือนถูกใจ",
  "update.setting_like_description": "คุณจะได้รับแจ้งเตือนเมื่อมีคนถูกใจความเห็น, ความเห็นตอบกลับและแอสเซตของคุณ",
  "update.setting_follow_label": "แจ้งเตือนผู้ติดตาม",
  "update.setting_follow_description": "คุณจะได้รับแจ้งเตือนเมื่อมีคนติดตามคุณ",
  "update.setting_event_label": "แจ้งเตือนอีเวนต์",
  "update.setting_event_description": "คุณจะได้รับแจ้งเตือนเกี่ยวกับอีเวนต์ต่างๆ",
  "update.setting_nighttime_event_label": "แจ้งเตือนอีเวนต์ยามวิกาล",
  "update.setting_nighttime_event_description": "คุณจะได้รับแจ้งเตือนเกี่ยวกับอีเวนต์ในช่วงเวลาระหว่าง 21:00 น. ~ 08:00 น.",
  "update.setting_depletion_label": "แจ้งเตือนการใช้พอยต์",
  "update.setting_depletion_description": "คุณจะได้รับแจ้งเตือนเมื่อพอยต์หมด",
  "update.setting_personal_label": "แจ้งเตือนสำคัญส่วนบุคคล",
  "update.setting_personal_description": "เราจะส่งแจ้งเตือนเกี่ยวกับข่าวสารสำคัญส่วนบุคคลให้คุณทราบ",
  "update.setting_official_label": "ประกาศข่าวสารของบับเบิลแชต",
  "update.setting_official_description": "เราจะประกาศสถานการณ์ของบับเบิลแชตให้คุณทราบ",
  "chat.list_empty": "เริ่มแชตกับตัวละครที่คุณสนใจ",
  "chat.list_menu_view_details": "ดูรายละเอียด",
  "chat.list_menu_delete": "ลบ",
  "chat.list_menu_delete_alert_cancel": "ยกเลิก",
  "chat.list_menu_delete_alert_delete": "ลบ",
  "chat.list_modal_character_title": "ตัวละคร",
  "chat.list_modal_character_description": "อธิบายตัวละคร",
  "chat.list_modal_character_information": "ข้อมูล",
  "chat.list_modal_character_information_gender": "เพศ",
  "chat.list_modal_character_information_age": "อายุ",
  "chat.list_modal_character_information_age_help_text": "ไม่สามารถสร้างตัวละครที่อายุต่ำกว่า 19 ปีในโหมดตื่นเต้นได้",
  "chat.list_modal_character_information_job": "อาชีพ",
  "chat.list_modal_character_information_character": "นิสัย",
  "chat.list_modal_character_information_speaking_style": "สไตล์คำพูด",
  "chat.list_modal_character_information_interests": "ความสนใจ",
  "chat.list_modal_character_information_details": "รายละเอียดเพิ่มเติม",
  "chat.list_modal_character_information_details_private_exist": "มีรายละเอียดเพิ่มเติมที่ไม่เปิดเผย",
  "chat.list_modal_first_sentence": "คำพูดแรก",
  "chat.list_modal_universe": "จักรวาล",
  "chat.list_modal_scene": "ฉาก",
  "chat.list_modal_persona_title": "ตัวตนของฉัน",
  "chat.list_modal_persona_information": "ข้อมูล",
  "chat.list_modal_persona_gender": "เพศ",
  "chat.list_modal_persona_age": "อายุ",
  "chat.list_modal_persona_job": "อาชีพ",
  "chat.list_modal_persona_character": "นิสัย",
  "chat.list_modal_persona_speaking_style": "สไตล์คำพูด",
  "chat.list_modal_persona_interests": "ความสนใจ",
  "chat.list_modal_persona_details": "รายละเอียด",
  "chat.list_modal_universe_title": "จักรวาล",
  "chat.list_modal_universe_relationship": "ความสัมพันธ์ระหว่างฉันและตัวละคร",
  "chat.list_modal_universe_introduction": "รายละเอียดจักรวาล",
  "chat.list_modal_universe_details": "รายละเอียดเพิ่มเติม",
  "chat.list_modal_universe_private_relationship": "มีรายละเอียดความสัมพันธ์ที่ไม่เปิดเผย",
  "chat.list_modal_universe_private_details": "มีรายละเอียดเพิ่มเติมที่ไม่เปิดเผย",
  "chat.list_modal_scene_title": "ฉาก",
  "chat.list_modal_scene_details": "รายละเอียดเพิ่มเติม",
  "chat.list_modal_scene_private_details": "มีรายละเอียดเพิ่มเติมที่ไม่เปิดเผย",
  "chat.list_modal_edit_chat_name_title": "ชื่อห้องแชต",
  "chat.list_modal_edit_chat_name_placeholder": "ใส่ชื่อห้องแชต",
  "chat.list_edit_chat_selected": "เลือก{{int_numbers}}",
  "chat.list_edit_delete_button": "ลบห้องแชต",
  "chat.list_edit_select": "เลือกรายการ",
  "chat.list_edit_delete": "ลบ",
  "chat.list_edit_delete_all": "ลบทั้งหมด",
  "chat.list_edit_select_all": "เลือกทั้งหมด",
  "chat.list_edit_deselect_all": "ยกเลิกที่เลือกทั้งหมด",
  "chat.list_edit_chats": "แก้ไขห้องแชต",
  "chat.list_edit_delete_failed": "ลบไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
  "chat.list_edit_edit_failed": "เกิดข้อผิดพลาดขณะแก้ไข กรุณาลองใหม่อีกครั้ง",
  "chat.information_character_title": "ตัวละคร",
  "chat.information_character_none": "ยังไม่ได้เลือกตัวละคร",
  "chat.information_asset_information": "ข้อมูล",
  "chat.information_asset_information_nsfw": "ตื่นเต้น",
  "chat.information_unit_thousand": "",
  "chat.information_unit_ten_thousand": "",
  "chat.information_unit_hundred_million": "",
  "chat.information_asset_information_first_release": "วันเผยแพร่ครั้งแรก",
  "chat.information_character_deleted_account": "บัญชีที่ถูกลบ",
  "chat.information_character_deleted_account_toast": "บัญชีที่ถูกลบ",
  "chat.information_start_chat": "เริ่มแชต",
  "chat.information_start_chat_guest": "เริ่มแชต",
  "chat.information_resume_chat": "แชตต่อ",
  "chat.information_custom_chat": "ปรับแต่งแชต",
  "chat.information_like": "ถูกใจ",
  "chat.information_like_fail_message": "ถูกใจล้มเหลว",
  "chat.information_unlike_fail_message": "ยกเลิกการถูกใจล้มเหลว",
  "chat.information_favorite": "รายการโปรด",
  "chat.information_favorite_fail_message": "เลือกรายการโปรดไม่สำเร็จ",
  "chat.information_unfavorite_fail_message": "ยกเลิกรายการโปรดไม่สำเร็จ",
  "chat.information_persona": "ตัวตนของคุณตอนนี้",
  "chat.information_persona_active": "กำลังใช้",
  "chat.information_persona_add": "เพิ่มตัวตน",
  "chat.information_character_introduction": "อธิบายตัวละคร",
  "chat.information_information": "ข้อมูล",
  "chat.information_character_gender": "เพศ",
  "chat.information_character_age": "อายุ",
  "chat.information_character_job": "อาชีพ",
  "chat.information_character_character": "นิสัย",
  "chat.information_character_speaking_style": "สไตล์คำพูด",
  "chat.information_character_interests": "ความสนใจ",
  "chat.information_details": "รายละเอียดเพิ่มเติม",
  "chat.information_details_user": "ฉัน",
  "chat.information_details_private_only": "รายละเอียดเพิ่มเติมที่ไม่เปิดเผย",
  "chat.information_details_private_exist": "มีรายละเอียดเพิ่มเติมที่ไม่เปิดเผย",
  "chat.information_first_sentence": "คำพูดแรก",
  "chat.information_universe": "จักรวาล",
  "chat.information_universe_none": "ยังไม่ได้เลือกจักรวาล",
  "chat.information_more": "ดูเพิ่มเติม",
  "chat.information_scene": "ฉาก",
  "chat.information_scene_none": "ยังไม่ได้เลือกฉาก",
  "chat.custom_selected_universe": "จักรวาลที่เลือก",
  "chat.custom_selected_scene": "ฉากที่เลือก",
  "chat.information_delete": "ลบ",
  "chat.information_edit": "แก้ไข",
  "chat.information_delete_alert_message_universe": "หากคุณลบจักรวาลนี้ จักรวาลจะถูกลบออกจากตัวละครทุกตัวที่คุณตั้งค่าไว้ <br/>ต้องการลบหรือไม่? ",
  "chat.information_delete_alert_message_scene": "หากคุณลบฉากนี้ ฉากจะถูกลบออกจากตัวละครทุกตัวที่คุณตั้งค่าไว้ <br/>ต้องการลบหรือไม่? ",
  "chat.information_delete_alert_message_failed": "ลบไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
  "chat.information_delete_alert_cancel": "ยกเลิก",
  "chat.information_delete_alert_delete": "ลบ",
  "chat.information_reviews_submit_button": "ส่งรีวิว",
  "chat.information_reviews_placeholder": "เขียนรีวิว",
  "chat.information_reviews_empty": "ยังไม่มีรีวิว",
  "chat.information_reviews_few_seconds": "ไม่กี่วินาทีก่อน",
  "chat.information_reviews_seconds": "{{int_seconds}}วินาทีก่อน",
  "chat.information_reviews_minutes": "{{int_minutes}}นาทีก่อน",
  "chat.information_reviews_hours": "{{int_hours}}ชั่วโมงที่แล้ว",
  "chat.information_reviews_view_translation": "ดูคำแปล",
  "chat.information_reviews_view_original": "ดูต้นฉบับ",
  "chat.information_reviews_view_translation_unsupported_language_toast": "ไม่รองรับภาษานี้",
  "chat.information_reviews_delete failed": "ลบไม่สำเร็จ",
  "chat.information_reviews_deleted_user_username": "ผู้ใช้ลบบัญชีแล้ว",
  "chat.information_reviews_deleted_user_review": "ความเห็นนี้เป็นของผู้ใช้ที่ลบบัญชีแล้ว",
  "chat.information_reviews_deleted_review": "รีวิวนี้ถูกลบแล้ว",
  "chat.information_replies": "ตอบ",
  "chat.information_sort_recent": "ล่าสุด",
  "chat.information_sort_liked": "นิยมที่สุด",
  "chat.information_new_comment": "มีคนแสดงความคิดเห็นใหม่",
  "chat.information_new_reply": "มีคนตอบกลับความคิดเห็นของคุณ",
  "chat.information_write_comment": "เขียนแสดงความคิดเห็น",
  "chat.information_write_reply": "เขียนการตอบกลับ",
  "chat.information_reply_delete_fail_message": "ลบการตอบกลับไม่สำเร็จ",
  "chat.information_delete_comment_alert": "คุณแน่ใจที่จะลบความคิดเห็นนี้ใช่หรือไม่?",
  "chat.information_delete_reply_alert": "คุณแน่ใจที่จะการตอบกลับนี้ใช่หรือไม่?",
  "chat.information_comment_characters_limit_message": "การแสดงความคิดเห็นถูกจำกัดไว้ไม่เกิน 1,000 ตัวอักษร",
  "chat.information_reply_characters_limit_message": "การตอบกลับถูกจำกัดไว้ไม่เกิน 1,000 ตัวอักษร",
  "chat.information_comment_character": "มีคนแสดงความคิดเห็นที่ตัวละคร {{string_characterName}}",
  "chat.information_comment_universe": "มีคนแสดงความคิดเห็นที่จักรวาล {{string_universeName}}",
  "chat.information_comment_scene": "มีคนแสดงความคิดเห็นที่ฉาก {{string_sceneName}}",
  "chat.information_comment_edit_placeholder": "ใส่เนื้อหาที่ต้องการแก้ไข",
  "chat.information_reply_edit_placeholder": "ใส่เนื้อหาที่ต้องการแก้ไข",
  "chat.information_comment_edit": "แก้ไข",
  "chat.information_comment_delete": "ลบ",
  "chat.information_comment_edit_done": "แก้ไข",
  "chat.information_comment_edit_cancel": "ยกเลิก",
  "chat.information_comment_view_all_comment": "ดูความคิดเห็นทั้งหมด",
  "chat.information_comment_pin_failed": "ปักหมุดความเห็นไม่สำเร็จ",
  "chat.information_comment_unpin_failed": "ยกเลิกปักหมุดความเห็นไม่สำเร็จ",
  "chat.information_comment_post_failed": "แสดงความเห็นไม่สำเร็จ",
  "chat.information_comment_edit_failed": "แก้ไขความเห็นไม่สำเร็จ",
  "chat.information_comment_delete_success": "ลบความเห็นสำเร็จ",
  "chat.information_comment_delete_failed": "ลบความเห็นไม่สำเร็จ",
  "chat.information_comment_like_failed": "ถูกใจความเห็นไม่สำเร็จ ",
  "chat.information_comment_report_success": "รายงานสำเร็จ",
  "chat.information_comment_report_failed": "รายงานไม่สำเร็จ",
  "chat.information_reply_post_failed": "ตอบกลับความเห็นไม่สำเร็จ",
  "chat.information_reply_edit_failed": "แก้ไขความเห็นตอบกลับไม่สำเร็จ",
  "chat.information_reply_delete_success": "ลบความเห็นตอบกลับสำเร็จ",
  "chat.information_reply_delete_failed": "ลบความเห็นตอบกลับไม่สำเร็จ",
  "chat.information_reply_like_failed": "ถูกใจความเห็นตอบกลับไม่สำเร็จ",
  "chat.information_reply_report_success": "รายงานสำเร็จ",
  "chat.information_reply_report_failed": "รายงานไม่สำเร็จ",
  "chat.information_comment_reply_deleted_comment": "คุณไม่สามารถตอบกลับความเห็นที่ถูกลบไปแล้วได้",
  "chat.information_comment_pin_deleted_comment": "คุณไม่สามารถปักหมุดหรือยกเลิกปักหมุดความเห็นที่ถูกลบไปแล้วได้",
  "chat.information_reviews_report": "รายงาน",
  "chat.information_reviews_report_modal_title": "รายงานความเห็น",
  "chat.information_reply_report_modal_title": "รายงานความเห็นตอบกลับ",
  "chat.information_reply_deleted_user": "ความเห็นตอบกลับนี้เป็นของผู้ใช้ที่ลบบัญชีแล้ว",
  "chat.information_reply_deleted": "ความเห็นตอบกลับนี้ถูกลบไปแล้ว",
  "chat.information_leave_reply": "ตอบกลับความเห็น",
  "chat.information_comment_button_submit_only": "ส่ง",
  "chat.information_comment_show_more": "ดูเพิ่มเติม",
  "chat.information_comment_show_less": "ย่อ",
  "chat.information_comment_show_more2": "ขยาย",
  "chat.information_reviews_report_modal_description": "โปรดแจ้งสาเหตุการรายงาน",
  "chat.information_reviews_report_modal_dropdown": "เลือกหัวข้อที่ต้องการรายงาน",
  "chat.information_reviews_report_modal_misconduct": "พฤติกรรมไม่เหมาะสม",
  "chat.information_reviews_report_modal_unapproved": "โฆษณาที่ไม่ได้รับอนุญาต",
  "chat.information_reviews_report_modal_personal": "ข้อมูลส่วนตัวรั่วไหล",
  "chat.information_reviews_report_modal_promo": "โฆษณา",
  "chat.information_reviews_report_modal_other": "อื่นๆ",
  "chat.information_reviews_report_modal_placeholder": "ระบุสาเหตุที่ต้องการรายงาน",
  "chat.information_reviews_report_modal_cancel": "ยกเลิก",
  "chat.information_reviews_report_modal_submit": "ส่ง",
  "chat.information_character_report_modal_title": "รายงานตัวละคร",
  "chat.information_universe_report_modal_title": "รายงานจักรวาล",
  "chat.information_scene_report_modal_title": "รายงานฉาก",
  "chat.information_asset_report_modal_copyright_title": "การลอกเลียนแบบ / การละเมิดลิขสิทธิ์",
  "chat.information_asset_report_modal_copyright_description": "รายงานการลอกเลียนแบบและการละเมิดลิขสิทธิ์จะดำเนินการตามหลักฐานและเอกสารประกอบการ",
  "chat.information_universe_introduction": "อธิบายจักรวาล",
  "chat.information_universe_relationship": "ความสัมพันธ์ระหว่างฉันและตัวละคร",
  "chat.information_relationship_private_only": "รายละเอียดความสัมพันธ์ที่ไม่เปิดเผย",
  "chat.information_relationship_private_exist": "มีรายละเอียดความสัมพันธ์ที่ไม่เปิดเผย",
  "chat.information_scene_introduction": "อธิบายจักรวาล",
  "chat.information_scene_place": "สถานที่",
  "chat.information_scene_time": "ช่วงเวลา",
  "chat.information_character_load_fail_message": "โหลดข้อมูลตัวละครล้มเหลว",
  "chat.information_universe_load_fail_message": "โหลดข้อมูลจักรวาลล้มเหลว",
  "chat.information_scene_load_fail_message": "โหลดข้อมูลฉากล้มเหลว",
  "chat.information_private_fail_message_character": "ไม่พบตัวละคร",
  "chat.information_private_fail_message_universe": "ไม่พบจักรวาล",
  "chat.information_private_fail_message_scene": "ไม่พบฉาก",
  "chat.information_no_chat_nsfw_characters": "คุณไม่สามารถแชตกับตัวละครอายุต่ำกว่า 19 ในโหมดตื่นเต้นได้",
  "chat.information_character_details_private_only": "คำอธิบายตัวละครนี้ไม่เปิดเผย",
  "chat.information_character_details_private_exist": "มีคำอธิบายตัวละครที่ไม่เปิดเผย",
  "chat.information_background_details_private_only": "คำอธิบายฉากหลังนี้ไม่เปิดเผย",
  "chat.information_background_details_private_exist": "มีคำอธิบายฉากหลังที่ไม่เปิดเผย",
  "chat.information_lorebook_private_only": "ตั้งค่าข้อมูลที่ไม่เปิดเผย",
  "chat.information_lorebook_private_exist": "มีการตั้งค่าข้อมูลที่ไม่เปิดเผย",
  "chat.information_weekly_character": "ตัวละครยอดนิยมประจำสัปดาห์",
  "chat.information_weekly_universe": "จักรวาลยอดนิยมประจำสัปดาห์",
  "chat.information_weekly_scene": "ฉากยอดนิยมประจำสัปดาห์ ",
  "chat.custom_title": "ปรับแต่งแชต",
  "chat.custom_help_text_title": "ลองสร้างแชตในแบบของคุณ",
  "chat.custom_help_text_description": "คุณสามารถแชตผ่านเนื้อหาที่ถูกสร้างโดยคุณ",
  "chat.custom_character": "ตัวละคร",
  "chat.custom_universe": "จักรวาล",
  "chat.custom_optional": "เลือก ",
  "chat.custom_scene": "ฉาก",
  "chat.custom_add": "เพิ่ม",
  "chat.custom_change": "เปลี่ยน",
  "chat.custom_create": "สร้าง",
  "chat.custom_first_sentence": "คำพูดแรก",
  "chat.custom_first_sentence_placeholder": "โปรดใส่คำพูดแรกของ{{string_characterName}}",
  "chat.custom_first_sentence_edit_modal_title": "แก้ไขคำพูดแรก",
  "chat.custom_first_sentence_edit_modal_description": "คุณสามารถแก้ไขคำพูดแรกของตัวละครได้!",
  "chat.custom_first_sentence_edit_modal_placeholder": "โปรดใส่คำพูดแรกของ{{string_characterName}}",
  "chat.custom_first_sentence_edit_modal_cancel": "ยกเลิก",
  "chat.custom_first_sentence_edit_modal_save": "แก้ไข",
  "chat.custom_start_chat": "แชตเลย",
  "chat.custom_character_modal_title": "เลือกตัวละคร",
  "chat.custom_modal_done": "เรียบร้อย",
  "chat.custom_modal_tag_placeholder": "ค้นหาแท็ก",
  "chat.custom_modal_tap_recents": "ล่าสุด",
  "chat.custom_modal_tap_favorites": "ถูกใจ",
  "chat.custom_character_modal_tap_my": "ตัวละครของฉัน",
  "chat.custom_universe_modal_title": "เลือกจักรวาล",
  "chat.custom_universe_modal_tap_my": "จักรวาลของฉัน",
  "chat.custom_scene_modal_title": "เลือกฉาก",
  "chat.custom_scene_modal_tap_my": "ฉากของฉัน",
  "chat.custom_select_character": "โปรดเลือกตัวละคร",
  "chat.custom_select_universe": "โปรดเลือกจักรวาล",
  "chat.custom_select_scene": "โปรดเลือกฉาก",
  "chat.custom_retry": "ลองใหม่อีกครั้ง",
  "chat.custom_back_home": "กลับไปหน้าโฮม",
  "chat.custom_find_character_failed": "ค้นหาตัวละครที่คุณต้องการไม่พบเหรอ?",
  "chat.custom_go_create_character": "สร้างตัวละครของฉัน",
  "chat.custom_report_once": "คุณสามารถรายงานได้เพียงหนึ่งครั้ง",
  "chat.custom_private_universe_selected": "จักรวาลส่วนตัวได้ถูกเลือกแล้ว กรุณาเลือกจักรวาลอื่น",
  "chat.custom_private_scene_selected": "ฉากส่วนตัวได้ถูกเลือกแล้ว กรุณาเลือกฉากอื่น",
  "chat.custom_nsfw_age_verification": "ตัวละคร, จักรวาลและฉากโหมดตื่นเต้นจะพร้อมใช้งานหลังจากยืนยันอายุแล้ว",
  "chat.custom_no_exist_assets": "มีตัวละคร, จักรวาลและฉากที่ไม่ปรากฏรวมอยู่ด้วย กรุณาลองใหม่อีกครั้ง",
  "chat.custom_create_chat_failed": "การแชตล้มเหลว กรุณาลองใหม่อีกครั้ง",
  "chat.custom_search_characters": "ค้นหาตัวละคร",
  "chat.custom_search_universes": "ค้นหาจักรวาล",
  "chat.custom_search_scenes": "ค้นหาฉาก",
  "chat.custom_search_no_results": "ไม่พบการค้นหา",
  "chat.custom_select_modal_asset_same_language": "จักรวาลและฉากที่สร้างภายใต้การตั้งค่าภาษาเดียวกันเท่านั้นที่สามารถตั้งค่าเป็นค่าเริ่มต้นได้",
  "chat.character.list_empty": "ไม่พบตัวละคร",
  "chat.universe.list_empty": "ไม่พบจักรวาล",
  "chat.scene.list_empty": "ไม่พบฉาก",
  "chat.popup_settings_title": "ตั้งค่าแชต",
  "chat.popup_name_title": "ชื่อ",
  "chat.popup_name_placeholder": "กรุณาใส่ชื่อของคุณ",
  "chat.popup_chat_mode_title": "สไตล์",
  "chat.popup_chat_mode_chat": "โหมดแชต",
  "chat.popup_chat_mode_story": "โหมดเนื้อเรื่อง",
  "chat.popup_model_title": "โมเดล AI",
  "chat.popup_model_estimated_cost": "ราคาประมาณการ",
  "chat.popup_model_estimated_cost_failed": "การตอบกลับล้มเหลว",
  "chat.popup_model_estimated_cost_description": "ค่าใช้จ่ายอาจเปลี่ยนแปลง ตามปริมาณพรอมต์ ปริมาณแชต และความยาวคำตอบ",
  "chat.popup_model_diamond": "Diamond",
  "chat.popup_model_dia_description": "โมเดลคุณภาพสูงและเต็มไปด้วยความคิดสร้างสรรค์",
  "chat.popup_model_price_bubble": "บับเบิล",
  "chat.popup_model_emerald": "Emerald",
  "chat.popup_model_emerald_description": "โมเดลสมดุลที่มีการแสดงออกระดับสูง",
  "chat.popup_model_ruby": "Ruby",
  "chat.popup_model_ruby_description": "โมเดลที่คุ้มค่าและรวดเร็ว",
  "chat.popup_model_best": "แนะนำ",
  "chat.popup_nsfw_toggle_title": "โหมตื่นเต้น",
  "chat.popup_nsfw_toggle_description_nsfw_enable": "เปิดใช้งานโหมดตื่นเต้นเพื่อบทสนทนาที่ตื่นเต้นเร้าใจ",
  "chat.popup_nsfw_toggle_description_nsfw_disable": "ไม่สามารถใช้งานโหมดตื่นเต้นกับตัวละครที่มีอายุต่ำกว่า 19 ปี",
  "chat.popup_done": "ยืนยัน",
  "chat.popup_label_new": "New",
  "chat.popup_label_beta": "Beta",
  "chat.popup_label_value": "สุดคุ้ม",
  "chat.popup_label_sale": "ลดราคา",
  "chat.popup_label_date": "ถึง {{int_date}}",
  "chat.popup_chat_ai_model_signature": "Signature",
  "chat.popup_chat_ai_model_basic": "ทั่วไป",
  "chat.conversation_ai_model_basic_failed_message": "โหลดข้อความไม่สำเร็จ, บับเบิลยังไม่ถูกหัก",
  "chat.conversation_ai_model_basic_switch_failed": "เปลี่ยนโมเดล AI ไม่สำเร็จ ",
  "chat.popup_character_switched_nsfw_alert": "ตัวละครถูกเปลี่ยนเป็นโหมดตื่นเต้น",
  "chat.popup_character_switched_nsfw_alert_description": "คุณจะสามารถแชตได้หลังจากยืนยันอายุ",
  "chat.popup_nsfw_asset_normal_mode_failed_message": "ตัวละคร/จักรวาล/ฉากโหมดตื่นเต้น ไม่สามารถสนทนาได้ในโหมดทั่วไป",
  "chat.conversation_menu": "เมนู",
  "chat.conversation_username": "ชื่อผู้ใช้",
  "chat.conversation_menu_gallery": "แกลเลอรี",
  "chat.conversation_menu_display_images": "ดูรูปภาพ",
  "chat.conversation_menu_gallery_unlock_button": "ปลดล็อก",
  "chat.conversation_menu_gallery_unlock_image": "ปลดล็อกรูปภาพนี้ผ่านการสนทนา",
  "chat.conversation_menu_gallery_no_images": "ไม่พบรูปภาพในแกลเลอรี",
  "chat.conversation_menu_settings": "ตั้งค่า",
  "chat.conversation_menu_oldbie_shampoo": "แชมพู",
  "chat.conversation_menu_newbie_shampoo": "ซูเปอร์ แชมพู",
  "chat.conversation_menu_hyper_shampoo": "ไฮเปอร์แชมพู",
  "chat.conversation_menu_shampoo_loading": "กำลังรีฟิล",
  "chat.conversation_menu_shampoo_error": "รีฟิลล้มเหลว",
  "chat.popup_new_user_title": "ยินดีต้อนรับเข้าสู่การเป็นสมาชิก!",
  "chat.popup_new_user_description": "เพื่อฉลองการสมัครสมาชิก เราขอมอบ 'แชมพู' เพื่อให้คุณได้แชตฟรี!",
  "chat.popup_newbie_shampoo_title": "อัปเกรดเป็นซูเปอร์แชมพูสำเร็จ!",
  "chat.popup_newbie_shampoo_description": "เพลิดเพลินกับการแชตฟรีมากยิ่งขึ้นไปกับซูเปอร์แชมพูได้ 24 ชั่วโมง",
  "chat.popup_same_identity_under_seven_days_description": "หากคุณลบบัญชีที่เคยยืนยันตัวตนแล้วคุณจะไม่สามารถยืนยันตัวตนในบัญชีอื่นภายใต้ชื่อเดียวกันได้เป็นเวลา 7 วัน",
  "chat.popup_same_identity_over_seven_days_description": "ในฐานะผู้ใช้ปัจจุบันคุณสามารถใช้แชมพูปกติเพื่อแชตฟรีได้",
  "chat.popup_newbie_shampoo_history_exist_description": "เนื่องจากคุณได้รับสิทธิประโยชน์จากซูเปอร์แชมพูในบัญชีนี้แล้วคุณจึงสามารถใช้แชมพูปกติเพื่อแชตฟรีได้",
  "chat.popup_newbie_to_oldbie_title": "สิ้นสุดการใช้งานซูเปอร์แชมพูแล้ว",
  "chat.popup_newbie_to_oldbie_description": "จากนี้คุณสามารถแชตฟรีได้โดยการใช้แชมพูปกติ",
  "chat.popup_newbie_to_oldbie_description_purchase": "ต้องการซื้อเพิ่มเติมหรือไม่?",
  "chat.popup_shampoo_limit_message": "คุณใช้แชมพูหมดแล้วจากนี้คุณสามารถแชตได้โดยการใช้บับเบิล",
  "chat.conversation_menu_charging_station": "เติมบับเบิล",
  "chat.popup_persona_in_use": "กำลังใช้โหมดเพอร์โซน่า",
  "chat.popup_persona_notes": "โน้ต",
  "chat.popup_persona_notes_placeholder": "โน้ตเพอร์โซนา",
  "chat.popup_persona_pass_message": "อัปเกรดแชมพูเพื่อเพิ่มเพอร์โซน่า",
  "chat.popup_persona_pass_alert_message": "เพอร์โซน่านี้เกินจำนวนอักษรสูงสุดที่แพ็กเกจรองรับ<br/>กรุณาซื้อแพ็กเกจเพิ่มเติมหรือปรับข้อความ",
  "chat.popup_persona_content_empty": "ไม่มีตัวละครที่ตั้งค่าไว้",
  "chat.popup_persona_deleted_title": "เพอร์โซน่านี้ถูกลบไปแล้ว",
  "chat.popup_persona_deleted_description": "หากเปลี่ยนเพอร์โซนาแล้ว จะไม่สามารถกู้คืนได้<br/>ยืนยันการเปลี่ยนเพอร์โซนาหรือไม่?",
  "chat.popup_usernote_title": "หมายเหตุผู้ใช้งาน",
  "chat.popup_usernote_in_use": "กำลังใช้งานโน้ตของผู้ใช้",
  "chat.popup_usernote_pass_message": "อัปเกรดแชมพูเพื่อเพิ่มโน้ตของผู้ใช้",
  "chat.popup_usernote_pass_alert_message": "โน้ตของผู้ใช้นี้เกินจำนวนอักษรสูงสุดที่แพ็กเกจปัจจุบันรองรับ<br/>กรุณาซื้อแพ็กเกจเพิ่มเติมหรือปรับลดจำนวนอักษร",
  "chat.popup_usernote_content_title": "เนื้อหา",
  "chat.popup_usernote_content_placeholder": "โปรดระบุเนื้อหาที่คุณต้องการให้ตัวละครจดจำ",
  "chat.popup_usernote_toggle": "นำไปใช้กับการแชต",
  "chat.popup_usernote_save": "บันทึก",
  "chat.popup_usernote_save_fail_message": "การบันทึกล้มเหลว",
  "chat.popup_usernote_fail_message": "โหลดหมายเหตุผู้ใช้งานไม่สำเร็จ",
  "chat.popup_usernote_copied_toast": "คัดลอกโน้ตของผู้ใช้แล้ว",
  "chat.popup_usernote_copied_failed_toast": "คัดลอกโน้ตของผู้ใช้ไม่สำเร็จ<br/>กรุณาลองอีกครั้ง",
  "chat.popup_edit_user_message_title": "ข้อความที่ฉันส่ง",
  "chat.popup_edit_character_message_title": "ข้อความที่ตัวละครส่ง",
  "chat.popup_edit_edit_button": "แก้ไข",
  "chat.popup_edit_placeholder": "โปรดระบุข้อความ",
  "chat.popup_edit_deleted_message": "ความเห็นนี้ถูกลบแล้ว",
  "chat.popup_rpm_limit_description_one": "การส่งข้อความล้มเหลว โปรดส่งอีกครั้งหลังจาก {{int_seconds}} วินาที",
  "chat.popup_rpm_limit_description_other": "การส่งข้อความล้มเหลว โปรดส่งอีกครั้งหลังจาก {{int_seconds}} วินาที",
  "chat.popup_exit_title": "ต้องการออกจากห้องแชตนี้ใช่หรือไม่?",
  "chat.popup_exit_description": "บทสนทนาทั้งหมดที่มีกับตัวละครที่เลือกจะหายไป",
  "chat.bottom_exit_title": "ออกจากห้องแชต",
  "chat.popup_purchase_title": "ไม่สามารถแชตต่อได้เนื่องจากมีบับเบิลไม่พอ",
  "chat.popup_purchase_description": "เติมบับเบิลเพื่อทำการแชตต่อ",
  "chat.popup_purchase_event_per_chat": "ต่อ 1 แชต",
  "chat.popup_purchase_button": "เติมบับเบิล",
  "chat.conversation_send_message_placeholder": "ใส่การกระทำในเครื่องหมาย * *",
  "chat.conversation_shampoo_refill_alert_toast": "แชมพูเหลือน้อยกว่า {{int_number}}% แล้ว!",
  "chat.conversation_shampoo_refill_alert_toast_button": "รีฟิลแชมพูหน่อยไหม",
  "chat.conversation_current_shampoo_refill_message_modal": "แชมพูปัจจุบัน",
  "chat.conversation_current_shampoo_refill_description1_modal": "อุ๊ย! แชมพูของคุณหมดแล้ว!🫣",
  "chat.conversation_current_shampoo_refill_description2_modal": "หากรีฟิลตอนนี้คุณจะสามารถใช้งานได้อย่างต่อเนื่อง",
  "chat.conversation_current_super_shampoo_refill_description3_modal": "การรีฟิลซูเปอร์แชมพูเป็นการเติมแชมพูโดยไม่ขยายระยะเวลาการใช้งานของซูเปอร์แชมพู",
  "chat.conversation_current_hyper_shampoo_refill_description3_modal": "แพ็กเกจรีฟิลไฮเปอร์แชมพู จะชาร์จทันทีโดยไม่ขยายระยะเวลาใช้งาน",
  "chat.conversation_current_shampoo_refill_description5_modal": "เกินจำนวนอักษรสูงสุดของแพ็กเกจแล้ว",
  "chat.conversation_current_shampoo_refill_description6_modal": "แพ็กเกจนี้รองรับได้สูงสุด <strong>{{string_textCount}} ตัวอักษร</strong><br/>กรุณาซื้อแพ็กเกจเพิ่มเติมหรือปรับข้อความ",
  "chat.conversation_current_shampoo_refill_description7_modal": "แพ็กเกจนี้รองรับได้สูงสุด <strong>{{string_textCount}} ตัวอักษร</strong><br/>กรุณาซื้อแพ็กเกจเพิ่มเติมหรือปรับข้อความเพอร์โซน่า",
  "chat.conversation_current_shampoo_refill_description8_modal": "แชมพูหมด ทำให้จำนวนอักษรที่ใช้งานได้ลดลง",
  "chat.conversation_current_shampoo_refill_description9_modal": "ขณะนี้สามารถใช้ได้สูงสุด {{string_textCount}} ตัวอักษร<br/>กรุณาเติมแชมพูหรือปรับข้อความ",
  "chat.conversation_current_shampoo_refill_description10_modal": "ขณะนี้สามารถใช้ได้สูงสุด {{string_textCount}} ตัวอักษร<br/>กรุณาเติมแชมพูหรือปรับข้อความ",
  "chat.conversation_current_shampoo_refill_description11_modal": "เพอร์โซน่าหรือโน้ตของผู้ใช้อาจแสดงผลไม่สมบูรณ์",
  "chat.conversation_expired_ai_model_change_modal": "การให้บริการของโมเดลนี้ได้สิ้นสุดลงแล้ว<br/>กรุณาเลือกโมเดลอื่น",
  "chat.conversation_ai_model_change_modal": "การให้บริการของโมเดลที่ใช้งานอยู่ในห้องสนทนานี้<br/>ได้สิ้นสุดลงแล้ว",
  "chat.conversation_ai_model_change_description_modal": "กรุณาคลิกที่ไอคอนมุมขวาบน<br/>แล้วเปลี่ยน ‘โมเดล AI ที่กำลังใช้งาน’ ",
  "chat.conversation_ai_model_change_alert_toast": "โมเดลนี้ได้หยุดการให้บริการแล้ว<br/>กรุณาเปลี่ยน ‘โมเดล AI ที่กำลังใช้งาน’ ",
  "chat.conversation_ai_model_pass_modal_title": "อัปเกรดแชมพู",
  "chat.conversation_ai_model_pass_modal_description1": "แพ็กเกจปัจจุบันไม่รองรับโมเดลที่เลือก",
  "chat.conversation_ai_model_pass_modal_description2": "ซื้อแพ็กเกจเพื่อใช้งานโมเดลเพิ่มเติม",
  "chat.conversation_ai_model_pass_modal_back_button": "กลับ",
  "chat.conversation_ai_model_change_modal2_title": "โมเดลนี้ไม่รองรับกับแพ็กเกจปัจจุบันของคุณ",
  "chat.conversation_ai_model_change_modal2_description": "คลิกไอคอนมุมขวาบน แล้วเปลี่ยน ‘โมเดล AI’",
  "chat.conversation_ai_model_change_alert_toast2": "ไม่สามารถใช้โมเดลนี้ได้ในแพ็กเกจปัจจุบัน กรุณาเปลี่ยน ‘โมเดล AI’",
  "chat.conversation_image_unlock_popup_message": "ปลดล็อกรูปภาพใหม่สำเร็จ!",
  "chat.conversation_delete_alert_message": "ต้องการลบข้อความนี้ใช่หรือไม่?",
  "chat.conversation_delete_alert_message_cancel": "ยกเลิก",
  "chat.conversation_delete_alert_message_delete": "ลบ",
  "chat.conversation_delete_message": "ข้อความถูกลบแล้ว",
  "chat.conversation_text_input_limit_message": "ข้อความมีความยาวสูงสุดได้ 2000 ตัวอักษร",
  "chat.conversation_send_message_fail_message": "การส่งข้อความล้มเหลว",
  "chat.conversation_edit_message_fail_message": "การแก้ไขข้อความล้มเหลว",
  "chat.conversation_delete_message_fail_message": "การลบข้อความล้มเหลว",
  "chat.conversation_send_message_fallback_message": "การรับข้อความล้มเหลว <br/> โปรดกลับเข้าห้องแชตอีกครั้ง",
  "chat.conversation_edit_message_latest_message": "สามารถแก้ไขได้แค่ข้อความสุดท้ายเท่านั้น",
  "chat.conversation_delete_message_latest_message": "สามารถลบได้แค่ข้อความสุดท้ายเท่านั้น",
  "chat.conversation_reroll_message_latest_message": "สามารถรีโรลได้แค่ข้อความสุดท้ายเท่านั้น",
  "chat.conversation_new_chat_deleted_character": "ไม่สามารถแชตกับตัวละครที่ถูกลบได้",
  "chat.conversation_new_chat_deleted_universe": "ไม่สามารถแชตในจักรวาลที่ถูกลบได้",
  "chat.conversation_new_chat_deleted_scene": "ไม่สามารถแชตในฉากที่ถูกลบได้",
  "chat.conversation_load_fail_message": "การโหลดบทสนทนาล้มเหลว",
  "chat.conversation_action": "บทบรรยาย",
  "chat.conversation_image_alert_deleted": "รูปภาพที่ถูกลบ",
  "chat.conversation_image_alert_failed_pin": "ปักรูปภาพไม่สำเร็จ",
  "chat.conversation_select_model": "กรุณาเลือกโมเดล",
  "chat.conversation_chat_title": "หน้าต่างแชต",
  "chat.conversation_alert_animated_image": "ไม่รองรับการเล่นภาพเคลื่อนไหวในเบราว์เซอร์นี้",
  "chat.conversation_alert_load_persona_failed": "เรียกข้อมูลตัวตนไม่สำเร็จ",
  "chat.conversation_select_persona": "กรุณาเลือกตัวตน",
  "chat.conversation_failed_load_message": "การโหลดข้อความล้มเหลว",
  "chat.conversation_copied_toast": "คัดลอกสำเร็จ",
  "chat.conversation_sidebar_ai_model": "โมเดล AI ",
  "chat.conversation_sidebar_my_persona": "ตัวตนของฉัน",
  "chat.conversation_sidebar_character": "ตัวละคร",
  "chat.conversation_sidebar_universe": "จักรวาล",
  "chat.conversation_sidebar_scene": "ฉาก",
  "chat.conversation_sidebar_bubbles": "บับเบิล",
  "chat.conversation_sidebar_free_charging_station": "ฟรีบับเบิล",
  "chat.conversation_sidebar_next_refill": "รีฟิลต่อไป",
  "chat.conversation_sidebar_full_refill": "รีฟิลทั้งหมด",
  "chat.conversation_sidebar_memory": "ความจำ",
  "chat.conversation_sidebar_settings": "ตั้งค่า",
  "chat.conversation_sidebar_output_settings": "ตั้งค่าการแสดงผล",
  "chat.conversation_modal_shampoo_refill_regular_description": "เพียงคุณอัปเกรดเป็นซูเปอร์แชมพูก็สามารถรีฟีลได้เร็วกว่าและเพิ่มปริมาณได้มากกว่าถึง 10 เท่า! ",
  "chat.conversation_modal_shampoo_refill_title": "ถึงเวลารีฟิล",
  "chat.conversation_modal_shampoo_refill_count": "เวลาคงเหลือ",
  "chat.conversation_modal_shampoo_refill_count_day": "{{int_numbers}}วัน",
  "chat.conversation_modal_shampoo_refill_count_hour": "{{int_numbers}}ชั่วโมง",
  "chat.conversation_modal_shampoo_refill_count_minute": "{{int_numbers}}นาที",
  "chat.conversation_modal_shampoo_refill_count_second": "{{int_numbers}}วินาที",
  "chat.conversation_modal_tag_first_buy": "ซื้อได้ 1 ครั้ง",
  "chat.conversation_modal_tag_n_buy": "{{int_numbers}} ครั้ง",
  "chat.conversation_modal_topup_button": "ไปสถานีเติมเงิน",
  "chat.conversation_modal_Hold_on": "กรุณารอสักครู่",
  "chat.conversation_sidebar_long_term_memory": "ทักษะความทรงจำระยะยาว",
  "chat.conversation_long_term_memory_title": "ทักษะความทรงจำระยะยาว",
  "chat.conversation_long_term_memory_auto_summary": "สรุปอัตโนมัติ",
  "chat.conversation_long_term_memory_content_label": "เนื้อหา",
  "chat.conversation_long_term_memory_content_placeholder": "กรุณาระบุสิ่งที่ต้องการให้ตัวละครจดจำ",
  "chat.conversation_long_term_memory_history_button": "ประวัติ",
  "chat.conversation_long_term_memory_ok_button": "ตกลง",
  "chat.conversation_long_term_memory_history_title": "ตรวจสอบและเรียกคืนความจำก่อนหน้าได้",
  "chat.conversation_long_term_memory_history_latest": "ล่าสุด",
  "chat.conversation_long_term_memory_history_earliest": "เก่าที่สุด",
  "chat.conversation_long_term_memory_history_back": "ออก",
  "chat.conversation_long_term_memory_history_save": "บันทึก",
  "chat.conversation_long_term_memory_history_empty": "ไม่มีประวัติความทรงจำที่ถูกบันทึก",
  "chat.conversation_long_term_memory_edit_content": "เนื้อหา",
  "chat.conversation_long_term_memory_failed_delete": "ลบไม่สำเร็จ กรุณาลองใหม่อีกครั้งภายหลัง",
  "chat.conversation_long_term_memory_delete": "ลบ",
  "chat.conversation_long_term_memory_cancel": "ยกเลิก",
  "chat.conversation_long_term_memory_edit_title": "แก้ไขความทรงจำระยะยาว",
  "chat.conversation_long_term_memory_failed_save": "บันทึกไม่สำเร็จ",
  "chat.conversation_long_term_memory_select_history": "เลือกประวัติ",
  "chat.conversation_long_term_memory_setting": "ตั้งค่า",
  "chat.conversation_long_term_memory_next_summary_in": "สรุปครั้งถัดไป",
  "chat.conversation_long_term_memory_turn_zero": "เทิร์น",
  "chat.conversation_long_term_memory_turn_one": "เทิร์น",
  "chat.conversation_long_term_memory_turn_other": "เทิร์น",
  "chat.conversation_long_term_memory_summary_settings": "ตั้งค่าการสรุป",
  "chat.conversation_long_term_memory_summary_frequency": "รอบการสรุป",
  "chat.conversation_long_term_memory_character_limit": "จำกัดจำนวนตัวอักษร",
  "chat.conversation_long_term_memory_characters": "ตัวอักษร",
  "chat.conversation_long_term_memory_character_limit_description": "เมื่อเนื้อหาที่สรุปถึงขีดจำกัดตัวอักษร ระบบจะบีบอัดความจำทั้งหมด บันทึก และสร้างประวัติขึ้นมา",
  "chat.conversation_long_term_memory_summary_prompt_title": "พรอมต์สรุป",
  "chat.conversation_long_term_memory_character_auto_button": "อัตโนมัติ",
  "chat.conversation_long_term_memory_character_custom_button": "กำหนดเอง",
  "chat.conversation_long_term_memory_character_custom_description": "*การตั้งค่านี้จะใช้กับทุกห้องแชต",
  "chat.conversation_long_term_memory_auto_summary_toast": "เนื้อหาที่สรุปจะสะสม และจะถูกบีบอัดอัตโนมัติเมื่อถึงจำนวนที่กำหนด",
  "chat.conversation_long_term_memory_replace_history_alert": "เนื้อหาที่มีอยู่จะถูกเปลี่ยนตามประวัติที่เลือกไว้ คุณต้องการเปลี่ยนหรือไม่?",
  "chat.conversation_long_term_memory_apply_button": "เปลี่ยน",
  "chat.conversation_long_term_memory_unsaved_alert_message": "มีการแก้ไขที่ยังไม่ถูกบันทึก คุณต้องการออกจากหน้านี้หรือไม่?",
  "chat.conversation_long_term_memory_apply_failed_toast": "เกิดข้อผิดพลาดขณะใช้งาน กรุณาลองใหม่อีกครั้ง ",
  "chat.conversation_output_environment_title": "ตั้งค่าการแสดงผล",
  "chat.conversation_output_environment_control_memory_title": "ปรับระดับความจำ",
  "chat.conversation_output_environment_control_max_output_title": "ปรับปริมาณการแสดงผล",
  "chat.conversation_output_environment_description1": "ตั้งค่าความจำสูงขึ้น จะใช้พอยต์มากขึ้น",
  "chat.conversation_output_environment_description2": "หากตั้งค่าความจำต่ำกว่ารอบสรุปความจำระยะยาว ระบบอาจลืมบทสนทนาสำคัญ แนะนำให้ตั้งค่าเท่ากันหรือยาวกว่า",
  "chat.conversation_output_environment_description3": "การแสดงผลมากขึ้น จะใช้พอยต์มากขึ้น",
  "chat.conversation_output_environment_description4": "การเปลี่ยนการตั้งค่า มีผลตั้งแต่การแสดงผลครั้งถัดไป",
  "chat.conversation_output_environment_description5": "การตั้งค่านี้มีผลกับทุกห้องแชต",
  "chat.conversation_output_environment_save_modal_title": "บันทึกการเปลี่ยนแปลงหรือไม่?",
  "chat.conversation_output_environment_save_modal_description": "การตั้งค่านี้มีผลกับทุกห้องแชต",
  "chat.conversation_chat_settings_image_display": "แสดงรูปภาพ",
  "chat.conversation_chat_settings_image_display_text": "ข้อความ",
  "chat.conversation_image_unlock_locked_image": "รูปภาพนี้ตั้งค่าเป็นส่วนตัว",
  "chat.conversation_image_unlock_with_bubbles": "ใช้บับเบิลเพื่อปลดล็อก",
  "chat.conversation_image_unlock_no_with_bubbles": "ไม่สามารถใช้บับเบิลปลดล็อกได้",
  "chat.conversation_image_unlock_image_title": "ปลดล็อกรูปภาพ",
  "chat.conversation_image_unlock_your_bubbles": "บับเบิลของฉัน",
  "chat.conversation_image_unlock_unlocked_image": "รูปภาพที่ปลดล็อก",
  "chat.conversation_image_unlock_unlockable_image": "สามารถปลดล็อกได้",
  "chat.conversation_image_unlock_no_bubble_unlock": "ไม่สามารถปลดล็อกได้",
  "chat.conversation_image_unlock_selected_image": "ภาพที่เลือก",
  "chat.conversation_image_unlock_all_unlockable_image": "รูปภาพที่สามารถปลดล็อกได้ทั้งหมด",
  "chat.conversation_image_unlock_refund_bubble_description": "บับเบิลที่ใช้ปลดล็อกรูปภาพไปแล้วไม่สามารถขอคืนได้",
  "chat.conversation_image_unlock_not_enough_bubbles": "บับเบิลไม่เพียงพอ <br/> ไม่สามารถปลดล็อกรูปภาพได้",
  "chat.conversation_image_unlock_top_up_bubbles": "ลองปลดล็อกรูปภาพอีกครั้งหลังจากเติมบับเบิลดูสิ",
  "chat.conversation_image_unlock_current_bubbles": "บับเบิลปัจจุบัน",
  "chat.conversation_image_unlock_required_bubbles": "จำนวนบับเบิลที่ใช้ปลดล็อก",
  "chat.conversation_image_unlock_missing_bubbles": "บับเบิลไม่เพียงพอ",
  "chat.conversation_image_unlock_cancel_button": "ปิด",
  "chat.conversation_image_unlock_top_up_button": "เติมบับเบิล",
  "chat.conversation_image_unlock_failed": "ปลดล็อกรูปภาพไม่สำเร็จ",
  "chat.conversation_image_unlock_failed_description": "กรุณาลองใหม่อีกครั้ง",
  "chat.conversation_image_unlock_failed_button": "ตกลง",
  "chat.conversation_image_unlock_already_unlocked": "รูปภาพนี้ถูกปลดล็อกแล้ว",
  "chat.conversation_image_unlock_already_unlocked_button": "ตกลง",
  "chat.conversation_streaming_mode_off_alert_toast": "ขณะนี้การสนทนาให้บริการในโหมดแชตทั่วไป<br/>โหมดพิมพ์กำลังอยู่ระหว่างการกู้คืน",
  "chat.conversation_streaming_mode_on_alert_toast": "โหมดพิมพ์กลับมาใช้งานได้แล้ว",
  "chat.conversation_markdown_mode_on_alert_toast": "เปิดใช้งาน Markdown แล้ว",
  "chat.conversation_markdown_mode_off_alert_toast": "Markdown ถูกปิดการใช้งาน และอยู่ระหว่างการกู้คืน",
  "chat.conversation_message_send_error_alert_toast": "ไม่สามารถรับข้อความได้<br/>บับเบิลของคุณไม่ได้ถูกหักออก",
  "chat.conversation_streaming_message_error_alert_toast": "การดำเนินการร้องขอเกิดข้อผิดพลาด<br/>กรุณาลองใหม่อีกครั้งในภายหลัง",
  "chat.conversation_prohibited_content_error_toast": "โมเดล AI ไม่สามารถตอบกลับข้อความนี้ได้<br/>หากมีข้อสงสัยเกี่ยวกับแชตหรือการขอคืนเงิน กรุณาติดต่อฝ่ายบริการลูกค้า",
  "chat.conversation_prohibited_content_no_charge_toast": "การรับข้อความล้มเหลวเนื่องจากตัวกรองเนื้อหา AI บับเบิล/แชมพูยังไม่ถูกหัก",
  "chat.conversation_chat_new_conversation_button": "เริ่มแซตใหม่",
  "chat.conversation_chat_new_conversation_modal_select_title": "เลือกคำพูดแรก",
  "chat.conversation_chat_new_conversation_modal_start_conversation_button": "เริ่มการสนทนา",
  "chat.conversation_chat_copy_button": "คัดลอกห้องแชต",
  "chat.conversation_chat_copied_toast": "คัดลอกห้องแชตไปยังรายการแชตล่าสุดแล้ว",
  "chat.conversation_chat_copied_failed_toast": "คัดลอกห้องแชตไม่สำเร็จ",
  "chat.conversation_reconnect_toast": "หากไม่พบการตอบกลับ โปรดตรวจสอบการเชื่อมต่อเครือข่าย และเข้าใหม่อีกครั้ง",
  "chat.conversation_limit_toast": "แชมพูหมดแล้ว การใช้งานโน้ตของผู้ใช้และเพอร์โซนาอาจถูกจำกัด",
  "chat.conversation_usernote_limit_toast": "แชมพูหมดแล้ว การใช้งานโน้ตของผู้ใช้ถูกจำกัด (สูงสุด 500 ตัวอักษร)",
  "chat.conversation_persona_limit_toast": "แชมพูหมดแล้ว การใช้งานเพอร์โซน่าถูกจำกัด (สูงสุด 250 ตัวอักษร)",
  "chat.conversation_bookmark": "บุ๊กมาร์ก",
  "chat.conversation_bookmark_number": "บุ๊กมาร์ก {{int_numbers}}",
  "chat.conversation_bookmark_button": "ไปยังแชต",
  "chat.conversation_bookmark_add_title": "เพิ่มบุ๊กมาร์ก",
  "chat.conversation_bookmark_edit_title": "แก้ไขบุ๊กมาร์ก",
  "chat.conversation_bookmark_note": "โน้ต",
  "chat.conversation_bookmark_note_placeholder": "ใส่ข้อความของคุณ",
  "chat.conversation_bookmark_note_description": "*ข้อความที่พิมพ์จะไม่ส่งผลต่อการสนทนา",
  "chat.conversation_bookmark_empty": "ไม่มีบุ๊กมาร์กที่บันทึก",
  "chat.conversation_bookmark_no_content": "ไม่พบเนื้อหา เนื่องจากรีโรลหรือถูกลบ",
  "chat.conversation_bookmark_delete_success": "ลบบุ๊กมาร์กเรียบร้อยแล้ว",
  "chat.conversation_bookmark_delete_failed": "ลบบุ๊กมาร์กล้มเหลว",
  "chat.conversation_bookmark_edit_success": "แก้ไขบุ๊กมาร์กเรียบร้อยแล้ว",
  "chat.conversation_bookmark_edit_failed": "แก้ไขบุ๊กมาร์กล้มเหลว",
  "chat.conversation_export_as_txt": "ส่งออกเป็นไฟล์ TXT",
  "chat.conversation_export_as_txt_modal_description": "ส่งออกบทสนทนาทั้งหมดเป็นไฟล์ข้อความหรือไม่?",
  "chat.conversation_sidebar_extra_settings": "การตั้งค่าเพิ่มเติม",
  "chat.conversation_extra_settings_mask_my_name": "ซ่อนชื่อของฉัน",
  "chat.conversation_mask_my_name_user": "ผู้ใช้",
  "chat.custom_modal_preview_character_dialogue": "บทพูดตัวละคร",
  "chat.custom_modal_preview_character_dialogue_mask_on": "กำลังเรียกคุณว่า \"User\"",
  "chat.custom_modal_preview_character_dialogue_mask_off": "กำลังเรียกคุณว่า \"{{user}}\"",
  "chat.custom_modal_preview_character_narration": "คำบรรยายตัวละคร",
  "chat.custom_modal_preview_user_dialogue": "บทพูดผู้ใช้",
  "chat.custom_modal_preview_user_narration": "คำบรรยายผู้ใช้",
  "chat.custom_modal_viewer_settings": "ตั้งค่าการแสดงผล",
  "chat.custom_modal_viewer": "การแสดงผล",
  "chat.custom_modal_viewer_background": "พื้นหลัง",
  "chat.custom_modal_transparency": "ความโปร่งใส",
  "chat.custom_modal_text_settings": "ตั้งค่าข้อความ",
  "chat.custom_modal_text_size": "ขนาด",
  "chat.custom_modal_color_settings": "การตั้งค่าสี",
  "chat.custom_modal_color_settings_reset_button": "รีเซ็ต",
  "chat.custom_modal_preset_button": "พรีเซ็ต",
  "chat.custom_modal_custom_button": "กำหนดเอง",
  "chat.custom_modal_theme_dark": "มืด",
  "chat.custom_modal_theme_light": "สว่าง",
  "chat.custom_modal_theme_default": "Bubble",
  "chat.custom_modal_label_character_dialogue": "บทพูดตัวละคร",
  "chat.custom_modal_label_user_dialogue": "บทพูดผู้ใช้",
  "chat.custom_modal_label_character_narration": "คำบรรยายตัวละคร",
  "chat.custom_modal_label_user_narration": "คำบรรยายผู้ใช้",
  "chat.custom_modal_label_character_bubble": "บับเบิลคำพูดตัวละคร",
  "chat.custom_modal_label_user_bubble": "บับเบิลคำพูดผู้ใช้",
  "chat.custom_modal_color_picker_recent_colors": "สีล่าสุด",
  "chat.custom_modal_color_picker_default_custom_button": "ค่าเริ่มต้น",
  "chat.custom_modal_color_picker_custom_button": "กำหนดเอง",
  "chat.custom_modal_apply_chat_all_alert_title": "การเปลี่ยนแปลงจะมีผลกับห้องแชตแบบแชตเท่านั้น",
  "chat.custom_modal_apply_story_all_alert_title": "การเปลี่ยนแปลงจะมีผลกับห้องแชตแบบเนื้อเรื่องเท่านั้น",
  "chat.custom_modal_apply_all_alert_description": "ต้องการบันทึกหรือไม่?",
  "chat.custom_modal_unsaved_alert_title": "มีการแก้ไขที่ยังไม่ได้บันทึก",
  "chat.custom_modal_unsaved_alert_description": "ต้องการออกหรือไม่?",
  "chat.custom_modal_reset_alert_title": "ค่าสีทั้งหมดจะถูกรีเซ็ตเป็นค่าเริ่มต้น",
  "chat.custom_modal_reset_alert_description": "ต้องการดำเนินการต่อหรือไม่?",
  "chat.conversation_suggested_messages_title": "ข้อความแนะนำ",
  "chat.conversation_suggested_messages_description": "เลือกข้อความที่อยากส่งให้ตัวละคร",
  "chat.message_card_title": "การ์ดข้อความ",
  "chat.message_card_select_message_deselect": "ยกเลิกเลือก",
  "chat.message_export_title": "ส่งออกแชต",
  "chat.message_card_select_message": "เลือกข้อความ",
  "chat.message_card_private_unavailable": "ไม่สามารถสร้างการ์ดข้อความในห้องแชตที่ตั้งค่าตัวละครเป็นส่วนตัว",
  "chat.message_card_select_text_guide": "กรุณาเลือกข้อความที่จะใส่ในการ์ด",
  "chat.message_card_edit": "แก้ไขการ์ดข้อความ",
  "chat.message_card_card_design": "ดีไซน์การ์ด",
  "chat.message_card_style": "สไตล์",
  "chat.message_card_bg_background": "พื้นหลัง",
  "chat.message_card_bg_cutscene": "ฉากประกอบ",
  "chat.message_card_bg_text": "ข้อความ",
  "chat.message_card_ratio": "สัดส่วน",
  "chat.message_card_ratio_portrait": "แนวตั้ง",
  "chat.message_card_ratio_landscape": "แนวนอน",
  "chat.message_card_ratio_square": "จัตุรัส",
  "chat.message_card_image": "ภาพที่เลือก",
  "chat.message_card_edit_text": "แก้ไขข้อความ",
  "chat.message_card_save_success": "บันทึกการ์ดข้อความลงในอุปกรณ์เรียบร้อยแล้ว",
  "chat.message_card_save_failed": "บันทึกการ์ดข้อความล้มเหลว กรุณาลองใหม่อีกครั้ง",
  "chat.nsfw_character_not_available_toast_message": "ตัวละครโหมดตื่นเต้น ใช้งานบนแอปไม่ได้",
  "chat.nsfw_universe_not_available_toast_message": "จักรวาลของโหมดตื่นเต้น ใช้งานบนแอปไม่ได้",
  "chat.nsfw_scene_not_available_toast_message": "ฉากของโหมดตื่นเต้น ใช้งานบนแอปไม่ได้",
  "payment.charging_station_title": "สถานีเติมเงิน",
  "payment.charging_station_shampoo": "สถานีเติมแชมพู",
  "payment.charging_station_paid_bubble": "สถานีเติมบับเบิล",
  "payment.charging_station_free_bubble": "รับพอยต์ฟรี",
  "payment.charging_station_pass": "แพ็กเกจ",
  "payment.page_topup": "เติม",
  "payment.page_history": "ประวัติการใช้งาน",
  "payment.page_topup_history": "ประวัติการเติม",
  "payment.page_topup_history_earned": "เติม/รับเงิน",
  "payment.page_topup_history_used": "การใช้งาน",
  "payment.page_topup_balance": "ยอดคงเหลือ",
  "payment.page_topup_expiry_date": "วันหมดอายุ",
  "payment.page_topup_remaining": "บับเบิลคงเหลือ",
  "payment.charging_station_toast_success": "ซื้อสำเร็จ",
  "payment.charging_station_toast_failed": "ชำระเงินไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
  "payment.charging_station_shampoo_purchase_modal": "ยืนยันการซื้อ<br/>ซูเปอร์แชมพูใช่หรือไม่?",
  "payment.charging_station_super_shampoo_menu_title": "ซื้อซูเปอร์แชมพู",
  "payment.charging_station_hyper_shampoo_menu_title": "ซื้อไฮเปอร์แชมพู",
  "payment.charging_station_shampoo_menu_your_bubbles": "บับเบิลของฉัน",
  "payment.charging_station_shampoo_super_shampoo": "ซูเปอร์แชมพู",
  "payment.charging_station_shampoo_days_zero": "{{int_days}}วัน",
  "payment.charging_station_shampoo_days_one": "{{int_days}}วัน",
  "payment.charging_station_shampoo_days_other": "{{int_days}}วัน",
  "payment.charging_station_shampoo_hours_zero": "{{int_hours}}ชั่วโมง",
  "payment.charging_station_shampoo_hours_one": "{{int_hours}}ชั่วโมง",
  "payment.charging_station_shampoo_hours_other": "{{int_hours}}ชั่วโมง",
  "payment.charging_station_shampoo_purchase_complete": "ซื้อสำเร็จ!",
  "payment.charging_station_shampoo_purchase_ok": "ตกลง",
  "payment.charging_station_shampoo_not_enough_bubbles_title": "ไม่สามารถซื้อแชมพูได้<br/>เนื่องจากบับเบิลของคุณไม่เพียงพอ",
  "payment.charging_station_shampoo_not_enough_bubbles_description": "คุณสามารถซื้อแชมพูได้หลังจากเติมบับเบิล",
  "payment.charging_station_shampoo_modal_your_bubbles": "บับเบิลปัจจุบัน",
  "payment.charging_station_shampoo_modal_required": "บับเบิลที่จำเป็นในการซื้อ",
  "payment.charging_station_shampoo_modal_missing": "บับเบิลไม่เพียงพอ",
  "payment.charging_station_shampoo_modal_cancel": "ปิด",
  "payment.charging_station_shampoo_modal_topup": "เติมบับเบิล",
  "payment.charging_station_shampoo_purchase_failed_title": "ซื้อไม่สำเร็จ",
  "payment.charging_station_shampoo_purchase_failed_description": "กรุณาลองใหม่อีกครั้ง",
  "payment.charging_station_shampoo_modal_account_verification": "คุณจะซื้อสินค้านี้ได้<br/>หลังจากยืนยันตัวตน",
  "payment.charging_station_shampoo_modal_verify": "ยืนยันตัวตน",
  "payment.charging_station_shampoo_modal_already_in_use": "คุณกำลังใช้แชมพูอยู่!",
  "payment.charging_station_shampoo_modal_already_in_use_description1": "คุณสามารถเติมแชมพูจนเต็มได้<br/>ในขณะที่คุณกำลังใช้งานอยู่<br/>ต้องการเติมหรือไม่?",
  "payment.charging_station_shampoo_modal_already_in_use_description2": "*แชมพูที่คุณเลือกเติม<br/>อาจขอคืนไม่ได้ในภายหลัง",
  "payment.charging_station_shampoo_modal_already_in_use_cancel": "ไม่",
  "payment.charging_station_shampoo_modal_already_in_use_recharge": "เติม",
  "payment.charging_station_shampoo_pass_info": "ข้อมูลการใช้งานปัจจุบัน",
  "payment.charging_station_shampoo_purchase_pass": "ซื้อแพ็กเกจ",
  "payment.charging_station_shampoo_pass_description1": "ปริมาณ {{int_value}} เท่าของแชมพูทั่วไป",
  "payment.charging_station_shampoo_pass_description2": "เพอร์โซนา {{string_textCount}} ตัวอักษร",
  "payment.charging_station_shampoo_pass_description3": "โน้ตผู้ใช้ {{string_textCount}} ตัวอักษร",
  "payment.charging_station_shampoo_tooltip_title1": "✅ แชมพูคืออะไร?",
  "payment.charging_station_shampoo_tooltip_description1": "BubbleChat มอบปริมาณแชตฟรีให้ทุกวัน",
  "payment.charging_station_shampoo_tooltip_description2": "ไอคอนที่แสดงปริมาณแชตฟรีเรียกว่า 'แชมพู'",
  "payment.charging_station_shampoo_tooltip_description3": "ระบบจะชาร์จกลับ 25% ทุกq 6 ชั่วโมง นับจากเวลาที่เริ่มแชตครั้งแรก",
  "payment.charging_station_shampoo_tooltip_title2": "📌 โปรดทราบ!",
  "payment.charging_station_shampoo_tooltip_description4": "ความเร็วในการใช้แชมพูจะแตกต่างกันไปตามประเภทของแชมพู",
  "payment.charging_station_shampoo_tooltip_description5": "อัตราการใช้แชมพูอาจต่างกันตามโหมดของห้องแชตและโมเดล AI",
  "payment.charging_station_shampoo_tooltip_description6": "ปริมาณที่ถูกหักจะขึ้นอยู่กับความยาวของพรอมต์ ปริมาณข้อความที่ส่งและตอบกลับ",
  "payment.charging_station_shampoo_tooltip_title3": "✅ ข้อมูลแพ็กเกจการใช้งาน",
  "payment.charging_station_shampoo_tooltip_description7": "ซูเปอร์แชมพู",
  "payment.charging_station_shampoo_tooltip_description8": "ซูเปอร์แชมพู คือแพ็กเกจที่ให้ปริมาณการแชตมากกว่าโพชั่นทั่วไปถึง {{int_value}} เท่า",
  "payment.charging_station_shampoo_tooltip_description9": "ระหว่างใช้งานซูเปอร์แชมพู จะสามารถซื้อรีฟีล และใช้ฟังก์ชันเพิ่มโน้ตของผู้ใช้, เพอร์โซนาได้",
  "payment.charging_station_shampoo_tooltip_description10": "ไฮเปอร์แชมพู",
  "payment.charging_station_shampoo_tooltip_description11": "ไฮเปอร์แชมพู คือแพ็กเกจที่ให้ปริมาณการแชตมากกว่าโพชั่นทั่วไปถึง {{int_value}} เท่า",
  "payment.charging_station_shampoo_tooltip_description12": "ระหว่างใช้งานไฮเปอร์แชมพู จะสามารถซื้อรีฟีล และใช้ฟังก์ชันเพิ่มโน้ตของผู้ใช้และโปรไฟล์ที่อัปเกรดมากขึ้น",
  "payment.charging_station_shampoo_tooltip_description13": "เมื่อซื้อแพ็กเกจใหม่ ปริมาณที่เหลืออยู่ของแพ็กเกจเดิมจะไม่ได้เพิ่มขึ้น",
  "payment.charging_station_shampoo_tooltip_description14": "หากต้องการเติมปริมาณให้เต็ม กรุณาซื้อแพ็กเกจรีฟีล",
  "payment.charging_station_shampoo_tooltip_description15": "แพ็กเกจรีฟีลจะแสดงในสถานีเติมเงิน หรือห้องแชต เมื่อแชมพูเหลือต่ำกว่า {{int_number}}%",
  "payment.footer_msg_0": "ข้อมูลการบริการ",
  "payment.footer_msg_1": "บับเบิลมีอายุการใช้งาน 2 ปีนับจากวันที่เติม",
  "payment.footer_msg_2": "สำหรับบับเบิลที่ไม่ถูกใช้ คุณสามารถขอคืนได้ภายใน 7 วันนับจากวันที่ซื้อ",
  "payment.footer_msg_3": "ไม่สามารถขอคืนบับเบิลที่ถูกใช้แล้วได้ หากสมาชิกได้รับเงินคืนโดยจงใจฉ้อโกง สินค้าใดที่สมาชิกถืออยู่อาจถูกยึดคืนโดยไม่ได้รับความยินยอมล่วงหน้าและถูกระงับบัญชี",
  "payment.footer_msg_4": "เงินหรือไอเท็มฟรีที่ได้รับจากกิจกรรมหรือโปรโมชันไม่สามารถขอคืนได้และมีอายุการใช้งานภายใน 6 เดือนนับจากวันที่ได้รับ",
  "payment.footer_msg_5": "ของรางวัลที่ได้รับจากกิจกรรมหรือโปรโมชันไม่สามารถขอคืนได้",
  "payment.footer_msg_6": "สินค้าโปรโมชันอาจไม่สามารถซื้อคืนได้หากมีการขอคืนสินค้า",
  "payment.footer_msg_7": "สำหรับรายละเอียดเพิ่มเติม คุณสามารถเข้าไปตรวจสอบได้ในข้อกำหนดการให้บริการของบับเบิลแท็บ",
  "payment.footer_msg_8": "หากมีข้อสงสัยกรุณาติดต่อเราที่ </link1>ฝ่ายบริการลูกค้า</link1>",
  "payment.footer_msg_9": "การชำระเงินผ่านมือถือ สามารถยกเลิกและคืนเงินได้เฉพาะภายในเดือนเดียวกัน และคืนเงินเข้าบัญชีผู้ชำระเท่านั้น",
  "payment.footer_exchange_rate_msg_bt_6_7_except_kr": "ราคาสินค้าดังกล่าวอาจมีการปรับเปลี่ยนตามอัตราแลกเปลี่ยน",
  "payment.shampoo_footer_msg_0": "",
  "payment.shampoo_footer_msg_1": "ข้อมูลสินค้า",
  "payment.shampoo_footer_msg_2": "ซูเปอร์แชมพูเป็นสินค้าดิจิทัลที่สามารถใช้งานได้ทันทีหลังซื้อ โดยมีอายุการใช้งานตามแพ็กเกจ 3 วัน / 7 วัน",
  "payment.shampoo_footer_msg_3": "การใช้งานตั๋วจะเริ่มต้นอัตโนมัติเมื่อมีการชำระเงินเรียบร้อยแล้วและสามารถใช้งานได้ภายในระยะเวลาที่กำหนด",
  "payment.shampoo_footer_msg_4": "คุณสามารถซื้อตั๋วครั้งแรกผ่านบัญชีที่ได้รับการยืนยันแล้วเท่านั้นและสามารถซื้อได้เพียง 1 ครั้งต่อบัญชี ",
  "payment.shampoo_footer_msg_5": "นโยบายการคืนสินค้า",
  "payment.shampoo_footer_msg_6": "สามารถขอคืนเงินได้กรณีที่ Super Shampoo ที่ซื้อไปนั้นยังไม่มีการใช้งานหรือถูกหักยอดคงเหลือออกไปเท่านั้น",
  "payment.shampoo_footer_msg_7": "สำหรับสิทธิ์ใช้งานที่ซื้อเพิ่มเติมระหว่างใช้งาน Super Shampoo สามารถขอคืนเงินได้ก่อนที่ระยะเวลาของสิทธิ์ที่ซื้อเพิ่มนั้นจะเริ่มถูกใช้งาน",
  "payment.shampoo_footer_msg_8": "ในกรณีที่ไม่สามารถใช้บริการได้เนื่องจากข้อผิดพลาดของระบบ คุณสามารถแก้ไขปัญหาและรับการชดเชยได้ผ่านฝ่ายบริการลูกค้าของเรา",
  "payment.shampoo_footer_msg_9": "หมายเหตุเพิ่มเติม",
  "payment.shampoo_footer_msg_10": "ตั๋วที่ได้ฟรีและสินค้าลดราคาตามโปรโมชันผ่านกิจกรรมใดๆ ก็ตามจะไม่สามารถขอคืนได้",
  "payment.shampoo_footer_msg_11": "หากคุณพยายามขอคืนสินค้าโดยละเมิดเงื่อนไขการใช้งาน หรือใช้สิทธิ์การใช้งานในทางที่ผิด ระบบอาจเรียกคืนสินค้าและจำกัดการใช้งานบัญชีโดยไม่ต้องแจ้งให้ทราบล่วงหน้า",
  "payment.shampoo_footer_msg_12": "สินค้าราคาโปรโมชันอาจไม่สามารถซื้อซ้ำภายใต้เงื่อนไขเดิมได้หลังจากทำการขอคืนสินค้า กรุณาตัดสินใจให้รอบคอบก่อนซื้อ",
  "payment.shampoo_footer_msg_13": "หากตรวจพบรูปแบบการซื้อ - ขอคืนสินค้าซ้ำๆ ระบบจะถือว่าเป็นการใช้งานที่ไม่เหมาะสมและอาจจำกัดการใช้งานบัญชีของคุณได้",
  "payment.shampoo_footer_msg_14": "การรับสิทธิประโยชน์ซ้ำโดยการยกเลิกสมาชิกแล้วสมัครใหม่จะถูกระบบตรวจจับได้ และอาจมีการจำกัดการใช้งานบัญชีของคุณได้",
  "payment.shampoo_footer_msg_15": "รีฟิลซูเปอร์แชมพูเป็นสินค้าที่เติมได้ทันทีโดยไม่ขยายระยะเวลาการใช้งานของสินค้า",
  "payment.shampoo_footer_msg_16": "ขณะอยู่ในสถานะซูเปอร์แชมพู หากซื้อซูเปอร์แชมพูเพิ่มเติม จะมีการขยายระยะเวลาใช้งานเท่านั้นโดยไม่เติมปริมาณคงเหลือ",
  "payment.shampoo_footer_msg_17": "เมื่ออัปเกรดจากซูเปอร์แชมพูเป็นไฮเปอร์แชมพู ระยะเวลาที่เหลือจะถูกแปลงเป็นเวลาเพิ่มในอัตรา 5:1",
  "payment.shampoo_footer_msg_18": "สินค้ารีฟิลสามารถซื้อได้เฉพาะผู้ใช้ที่ซื้อซูเปอร์แชมพูเท่านั้น",
  "payment.shampoo_footer_msg_19": "หากมีข้อสงสัยเพิ่มเติม กรุณาติดต่อฝ่ายบริการลูกค้า",
  "payment.shampoo_footer_msg_20": "หากซูเปอร์แชมพูต่ำกว่า 0% จะจำกัดจำนวนตัวอักษร โปรไฟล์ 250 ตัวอักษร / โน้ตของผู้ใช้ 500 ตัวอักษร",
  "payment.history_bubblechat": "บับเบิลแชต",
  "payment.history_unlock_image": "ปลดล็อกรูปภาพ",
  "payment.history_payment": "การชำระเงิน",
  "payment.history_referrer_registration": "ลงทะเบียนผู้แนะนำ",
  "payment.history_payment_no_record": "ไม่มีประวัติการซื้อแบบชำระเงิน",
  "payment.history_used_no_record": "ไม่พบประวัติการใช้งาน",
  "payment.failed_button_description": "กลับไปหน้าการชำระเงิน",
  "payment.super_shampoo_refill_expired_message_modal": "ไม่สามารถรีฟิลได้ เนื่องจากระยะเวลาการใช้งานซูเปอร์แชมพูหมดอายุ",
  "payment.super_shampoo_refill_expired_description_modal": "ลองซื้อซูเปอร์แชมพูดูสิ",
  "payment.super_shampoo_refill_expired_message_modal_button": "ซื้อซูเปอร์แชมพู",
  "payment.super_shampoo_refill_message_modal": "รีฟิลซูเปอร์แชมพู",
  "payment.super_shampoo_refill_description1_modal": "หากซูเปอร์แชมพูหมดอายุแล้ว ปริมาณที่เหลือจะหายไปด้วยอัตโนมัติ",
  "payment.super_shampoo_refill_description2_modal": "ถึงอย่างนั้นคุณยังจะรีฟิลอยู่ไหม?",
  "payment.hyper_shampoo_refill_expired_message_modal": "หมดอายุการใช้งานไฮเปอร์แชมพู<br/>รีฟิลไม่สำเร็จ",
  "payment.hyper_shampoo_refill_expired_description_modal": "ซื้อไฮเปอร์แชมพู",
  "payment.hyper_shampoo_refill_expired_message_modal_button": "ซื้อไฮเปอร์แชมพู",
  "payment.hyper_shampoo_refill_message_modal": "รีฟิลไฮเปอร์แชมพู",
  "payment.hyper_shampoo_refill_description1_modal": "เมื่อไฮเปอร์แชมพูหมดอายุ<br/>ปริมาณที่เหลือจะหายไป",
  "payment.shampoo_refill_message_modal_button": "รีฟิลแชมพู",
  "payment.shampoo_refill_complete_message_modal": "รีฟิลแชมพูสำเร็จ!",
  "payment.shampoo_refill_complete_description1_modal": "คุณรีฟิลแชมพูจนเต็มแล้ว ไปแชตต่อกันเลย!",
  "payment.shampoo_refill_failed_message_modal": "คุณไม่สามารถรีฟิลได้เนื่องจากบับเบิลไม่เพียงพอ",
  "payment.shampoo_refill_failed_description1_modal": "บับเบิลที่จำเป็นในการรีฟิล",
  "payment.payletter_modal_title": "การชำระเงิน",
  "payment.payletter_modal_selected_item": "สินค้าที่เลือก",
  "payment.payletter_modal_payment_method": "ช่องทางการชำระเงิน",
  "payment.payletter_modal_card_button": "บัตรเครดิต / เดบิต",
  "payment.payletter_modal_transfer_button": "ชำระผ่านบัญชีแบบเรียลไทม์",
  "payment.payletter_modal_billing_button": "ชำระผ่านมือถือ",
  "payment.payletter_modal_pay_button": "ชำระเงิน",
  "payment.payletter_modal_success_title": "ชำระเงินสำเร็จ",
  "payment.payletter_modal_success_description": "คุณชำระเงินเรียบร้อยแล้ว",
  "payment.payletter_modal_fail_title": "ชำระเงินไม่สำเร็จ",
  "payment.payletter_modal_fail_description": "การชำระเงินล้มเหลว",
  "payment.payletter_modal_fail_description_sub": "กรุณาลองใหม่อีกครั้ง",
  "payment.ad_free_modal_title": "ไม่มีโฆษณาคั่น ดื่มด่ำกับเรื่องราวได้อย่างเต็มที่",
  "payment.ad_free_product_name": "Weave Plus",
  "payment.ad_free_product_price_subscription": "เดือน / {{string_N}}",
  "payment.ad_free_product_price_1day": "1 วัน / {{string_N}}",
  "payment.ad_free_product_price_30days": "30 วัน / {{string_N}}",
  "payment.ad_free_modal_description1": "ไม่มีโฆษณา",
  "payment.ad_free_modal_description2": "ตอบกลับเร็วขึ้น",
  "payment.ad_free_modal_description3": "ส่งข้อความได้ยาวขึ้น",
  "payment.ad_free_modal_description4": "ใช้งานโน้ตผู้ใช้",
  "payment.ad_free_modal_description5": "รับ {{int_number}} บับเบิล",
  "payment.ad_free_modal_description_inactived": "การชำระเงินผ่านเว็บยังไม่พร้อมให้บริการ<br/>ขณะนี้สามารถซื้อได้ผ่านแอป<br/>แอป → สถานีเติมบับเบิล→ แพ็กเกจ",
  "payment.ad_free_modal_description_inactived_button": "ซื้อผ่านแอป",
  "payment.ad_free_product_name_subscription": "สมัครสมาชิกรายเดือน",
  "payment.ad_free_product_name_day": "1 วัน",
  "payment.ad_free_product_recommended_web_top_up_title": "สมัครสมาชิกผ่านเว็บ เพียง {{int_number}} / เดือน",
  "payment.ad_free_product_recommended_web_top_up_title2": "เติมผ่านเว็บคุ้มกว่า เริ่มต้นเพียง ₩1,500",
  "payment.ad_free_product_recommended_web_top_up_button": "ดูรายละเอียด",
  "payment.ad_free_product_purchase": "ซื้อเลย",
  "payment.ad_free_product_price_day2": "ทดลองใช้ Weave Plus 1 วัน เพียง {{int_number}} บับเบิล",
  "payment.ad_free_modal_description6": "แพ็กเกจ 1 วันจะไม่ได้รับบับเบิล",
  "payment.ad_free_urchase_modal_title1": "ต้องการซื้อ {{string_productName}} หรือไม่?",
  "payment.ad_free_urchase_modal_title_completed": "ซื้อ {{string_productName}} สำเร็จ",
  "payment.ad_free_urchase_modal_title_failed": "ซื้อ {{string_productName}} ไม่สำเร็จ",
  "payment.ad_free_chatroom_banner_title": "อยากคุยเพลินแบบไม่มีอะไรคั่น?",
  "payment.ad_free_chatroom_banner_remove_Ads": "ลบโฆษณา",
  "payment.ad_free_product_infomation_subscription_date": "วันต่ออายุครั้งถัดไป",
  "payment.ad_free_product_infomation_subscription": "สมัครสมาชิกแล้ว",
  "payment.ad_free_product_infomation_subscribe": "สมัครสมาชิก",
  "payment.ad_free_product_infomation_cancellation_date": "วันสิ้นสุดการใช้งาน",
  "payment.ad_free_product_infomation_cancellation": "กำหนดยกเลิกสมาชิก",
  "payment.ad_free_product_infomation_undo_cancellation": "ใช้งานสมาชิกต่อ",
  "payment.ad_free_product_infomation_cancel_Subscription": "ยกเลิกสมาชิก",
  "payment.ad_free_product_infomation_expiration_date": "ระยะเวลาใช้งาน",
  "payment.ad_free_product_infomation_Inactive_pass": "คุณยังไม่มีแพ็กเกจ",
  "payment.ad_free_cancel_subscription_error_title1": "สามารถยกเลิกสมาชิกได้ที่หน้าเว็บไซต์",
  "payment.ad_free_cancel_subscription_error_description1": "เว็บ: สถานีเติมเงิน > แพ็กเกจ > ข้อมูลแพ็กเกจปัจจุบัน > ยกเลิกสมาชิก",
  "payment.ad_free_cancel_subscription_error_title2": "สามารถยกเลิกสมาชิกได้ที่ Google Play Store",
  "payment.ad_free_cancel_subscription_error_description2": "AOS: Play Store > โปรไฟล์ > การชำระเงินและสมัครรับข้อมูล > การสมัครรับข้อมูล > เลือกแอป > ยกเลิกสมาชิก",
  "payment.ad_free_cancel_subscription_error_title3": "สามารถยกเลิกสมาชิกได้ที่ App Store",
  "payment.ad_free_cancel_subscription_error_description3": "iOS: การตั้งค่า > Apple ID > การสมัครรับข้อมูล > เลือกแอป > ยกเลิกสมาชิก",
  "payment.ad_free_resubscribe_error_title1": "หากต้องการต่ออายุสมาชิก กรุณาดำเนินการผ่านเว็บไซต์",
  "payment.ad_free_resubscribe_error_title2": "หากต้องการต่ออายุสมาชิก กรุณาดำเนินการผ่าน App Store",
  "payment.ad_free_resubscribe_error_title3": "หากต้องการต่ออายุสมาชิก กรุณาดำเนินการผ่าน Google Play",
  "payment.ad_free_perchase_error_title": "คุณมีแพ็กเกจที่กำลังใช้งานอยู่แล้ว",
  "payment.ad_free_perchase_error_description": "สามารถซื้อได้หลังจาก {{string_productName}} หมดอายุ",
  "payment.ad_free_chatroom_sidemenu_active": "กำลังใช้งาน",
  "payment.ad_free_footer_msg_1": "ข้อมูลบริการ - สิทธิ์ใช้งาน Weave Plus",
  "payment.ad_free_footer_msg_2": "รายละเอียดสินค้า",
  "payment.ad_free_footer_msg_3": "สิทธิ์ใช้งาน Weave Plus เป็นสินค้าดิจิทัลที่สามารถใช้งานได้ทันทีหลังชำระเงิน โดยมีระยะเวลาการใช้งานตามประเภทที่เลือก ได้แก่ แพ็กเกจ 1 วัน/ 30 วัน จะมีระยะเวลาหมดอายุ (ระยะเวลาสิทธิพิเศษ) แตกต่างกันไป",
  "payment.ad_free_footer_msg_4": "สิทธิ์ใช้งาน Weave Plus เป็นสินค้าดิจิทัลที่สามารถใช้งานได้ทันทีหลังชำระเงิน โดยมีระยะเวลาการใช้งานตามประเภทที่เลือก ได้แก่ แพ็กเกจ 1 วัน/แบบสมัครสมาชิก (1เดือน) จะมีระยะเวลาหมดอายุ (ระยะเวลาสิทธิพิเศษ) แตกต่างกันไป",
  "payment.ad_free_footer_msg_5": "สิทธิประโยชน์จะเริ่มใช้งานโดยอัตโนมัติทันทีหลังชำระเงินสำเร็จ เมื่อใช้งานโมเดลฟรี Weave ภายในระยะเวลาที่กำหนด จะได้รับสิทธิประโยชน์ต่างๆ ดังนี้: ไม่มีโฆษณา, ความเร็วในการตอบกลับเพิ่มขึ้น, เพิ่มปริมาณการแสดงผล และใช้งานฟีเจอร์โน้ตผู้ใช้",
  "payment.ad_free_footer_msg_6": "โบนัสบับเบิลจะได้รับเมื่อซื้อแพ็กเกจ 30 วันเท่านั้น โดยแพ็กเกจ 1 วันจะไม่ได้รับโบนัสบับเบิล",
  "payment.ad_free_footer_msg_7": "โบนัสบับเบิลจะได้รับเมื่อซื้อแพ็กเกจ 30 วัน หรือแบบสมัครสมาชิกเท่านั้น โดยแพ็กเกจ 1 วันจะไม่ได้รับโบนัสบับเบิล",
  "payment.ad_free_footer_msg_8": "ไม่สามารถซื้อสิทธิ์การใช้งานซ้ำซ้อนกันได้ โดยจะสามารถซื้อแพ็กเกจใหม่ได้หลังจากสิทธิ์การใช้งานปัจจุบันหมดอายุแล้วเท่านั้น",
  "payment.ad_free_footer_msg_9": "สินค้าสำหรับการซื้อครั้งแรก จำกัดการซื้อ 1 ครั้งต่อบัญชีที่ผ่านการยืนยันตัวตนแล้วเท่านั้น",
  "payment.ad_free_footer_msg_10": "ข้อมูลการสมัครสมาชิก (1 เดือน)",
  "payment.ad_free_footer_msg_11": "ค่าบริการ: {{int_number}} บาท/เดือน (รวมภาษีมูลค่าเพิ่ม VAT แล้ว)",
  "payment.ad_free_footer_msg_12": "Weave Plus แบบ 1 เดือน เป็นบริการสมัครสมาชิกที่ต่ออายุอัตโนมัติทุก 30 วันระบบจะหักค่าบริการอัตโนมัติผ่านช่องทางชำระเงินที่คุณลงทะเบียนไว้ในทุกวันครบกำหนดรอบบิล จนกว่าจะมีการยกเลิกบริการ",
  "payment.ad_free_footer_msg_13": "ผู้ใช้สามารถยกเลิกการต่ออายุสมาชิกได้ตลอดเวลาก่อนถึงกำหนดชำระเงินรอบถัดไป โดยสิทธิพิเศษจะยังคงใช้งานได้จนกว่าจะสิ้นสุดระยะเวลาสมาชิกที่เหลืออยู่",
  "payment.ad_free_footer_msg_14": "สำหรับการซื้อภายในแอป หากไม่ยกเลิกอย่างน้อย 24 ชั่วโมงก่อนสิ้นสุดรอบบิลปัจจุบัน ระบบจะต่ออายุและหักค่าบริการอัตโนมัติในราคาเดิม",
  "payment.ad_free_footer_msg_14_1": "วิธีจัดการหรือยกเลิกบริการ: iOS — การตั้งค่า > [ชื่อของคุณ] > การสมัครใช้บริการ / Android — Play Store > การชำระเงินและการสมัครใช้บริการ > การสมัครใช้บริการ",
  "payment.ad_free_footer_msg_15": "นโยบายการคืนเงิน",
  "payment.ad_free_footer_msg_16": "สิทธิ์ใช้งาน Weave Plus เป็นคอนเทนต์ดิจิทัลที่ได้รับสิทธิประโยชน์ทันทีหลังชำระเงิน จึงอาจไม่สามารถขอคืนเงินได้ตามกฎหมายคุ้มครองผู้บริโภคที่ใช้การพาณิชย์อิเล็กทรอนิกส์",
  "payment.ad_free_footer_msg_17": "หากหลังการชำระเงินยังไม่ได้ใช้งานสิทธิประโยชน์ใด ๆ เลย กล่าวคือ (1) ไม่เคยใช้งานโมเดลฟรีเลยแม้แต่ครั้งเดียว ไม่เคยได้รับสิทธิ์การลบโฆษณาคั่น (2) ยังไม่เคยใช้โบนัสบับเบิลที่ได้รับ สามารถยื่นเรื่องขอคืนเงินและยกเลิกสัญญาได้ภายใน 7 วันนับจากวันที่ชำระเงิน หากมีการเริ่มใช้สิทธิพิเศษข้อใดข้อหนึ่งข้างต้น จะถือว่าใช้คอนเทนต์ดิจิทัลแล้ว และจะไม่สามารถขอคืนเงินได้",
  "payment.ad_free_footer_msg_18": "สำหรับการซื้อภายในแอป การคืนเงินจะเป็นไปตามนโยบายของแต่ละสโตร์ (App Store, Google Play)",
  "payment.ad_free_footer_msg_19": "หากไม่สามารถใช้งานบริการได้ตามปกติเนื่องจากข้อผิดพลาดของระบบ กรุณาติดต่อศูนย์บริการลูกค้า เพื่อรับความช่วยเหลือ",
  "payment.ad_free_footer_msg_20": "ข้อควรทราบ",
  "payment.ad_free_footer_msg_21": "สิทธิ์ใช้งานฟรีที่ได้รับจากกิจกรรม และสินค้าราคาพิเศษจากโปรโมชัน ไม่สามารถขอคืนเงินได้",
  "payment.ad_free_footer_msg_22": "หากตรวจพบการขอคืนเงินโดยมิชอบ หรือมีการใช้งานสิทธิ์ในทางที่ผิด บริษัทอาจเรียกคืนสิทธิที่ได้รับ และจำกัดการใช้งานบัญชีโดยไม่ต้องแจ้งให้ทราบล่วงหน้า",
  "payment.ad_free_footer_msg_23": "สินค้าโปรโมชั่นอาจไม่สามารถซื้อซ้ำภายใต้เงื่อนไขเดิมได้หลังจากมีการคืนเงิน กรุณาพิจารณาก่อนทำการสั่งซื้อ",
  "payment.ad_free_footer_msg_24": "หากตรวจพบพฤติกรรมการซื้อและขอคืนเงินซ้ำ ๆ อาจถูกพิจารณาว่าเป็นการใช้งานที่ไม่เหมาะสม และอาจถูกจำกัดการใช้งานบัญชี",
  "payment.ad_free_footer_msg_25": "การสมัครสมาชิกใหม่หลังจากลบบัญชีเพื่อรับสิทธิประโยชน์ซ้ำ ระบบสามารถตรวจสอบได้ และอาจมีการดำเนินการจำกัดการใช้งาน",
  "payment.ad_free_footer_msg_26": "หากมีข้อสงสัยหรือสอบถามเพิ่มเติม กรุณาติดต่อศูนย์บริการลูกค้า",
  "payment.ad_watch_incomplete_toast": "รับชมโฆษณาไม่สำเร็จ กรุณาส่งข้อความอีกครั้ง",
  "payment.app_only_guide_title": "ชำระเงินได้เฉพาะบนแอปเท่านั้น",
  "payment.app_only_guide_description": "เร็ว ๆ นี้จะรองรับการชำระเงินบนเว็บไซต์",
  "chat.profile_my_title": "หน้าของฉัน",
  "chat.profile_other_title": "โปรไฟล์",
  "chat.profile_writername": "ชื่อเล่น",
  "chat.profile_username": "ยูเซอร์โคด",
  "chat.profile_followers_zero": "ผู้ติดตาม",
  "chat.profile_followers_one": "ผู้ติดตาม",
  "chat.profile_followers_other": "ผู้ติดตาม",
  "chat.profile_my_following": "กำลังติดตาม",
  "chat.profile_my_following_modal_title": "กำลังติดตาม",
  "chat.profile_my_following_modal_description": "ลองติดตาม",
  "chat.profile_others_follow_button": "ติดตาม",
  "chat.profile_others_following_button": "ติดตามแล้ว",
  "chat.profile_introduction": "แนะนำตัว",
  "chat.profile_my_introduction_empty": "เขียนแนะนำเกี่ยวกับคุณ",
  "chat.profile_other_introduction_empty": "ยังไม่มีคำแนะนำ",
  "chat.profile_username_copy_message": "คัดลอกยูเซอร์โคดสำเร็จ",
  "chat.profile_my_personas": "ตัวตน",
  "chat.profile_my_personas_my_personas_zero": "ตัวตนของฉัน",
  "chat.profile_my_personas_my_personas_one": "ตัวตนของฉัน",
  "chat.profile_my_personas_my_personas_other": "ตัวตนของฉัน",
  "chat.profile_my_personas_empty": "ไม่พบตัวตนที่คุณสร้าง",
  "chat.profile_character": "ตัวละคร",
  "chat.profile_my_characters_my_characters_zero": "ตัวละครของฉัน",
  "chat.profile_my_characters_my_characters_one": "ตัวละครของฉัน",
  "chat.profile_my_characters_my_characters_other": "ตัวละครของฉัน",
  "chat.profile_my_characters_empty": "ไม่พบตัวละครที่คุณสร้าง",
  "chat.profile_others_characters_empty": "ไม่พบตัวละคร",
  "chat.profile_universe": "จักรวาล",
  "chat.profile_my_universes_my_universes_zero": "จักรวาลของฉัน",
  "chat.profile_my_universes_my_universes_one": "จักรวาลของฉัน",
  "chat.profile_my_universes_my_universes_other": "จักรวาลของฉัน",
  "chat.profile_my_universes_empty": "ไม่พบจักรวาลที่คุณสร้าง",
  "chat.profile_others_universes_empty": "ไม่พบจักรวาล",
  "chat.profile_scene": "ฉาก",
  "chat.profile_my_scenes_my_scenes_zero": "ฉากของฉัน",
  "chat.profile_my_scenes_my_scenes_one": "ฉากของฉัน",
  "chat.profile_my_scenes_my_scenes_other": "ฉากของฉัน",
  "chat.profile_my_scenes_empty": "ไม่พบฉากที่คุณสร้าง",
  "chat.profile_others_scenes_empty": "ไม่พบฉาก",
  "chat.profile_assets_count_zero": "แอสเซต",
  "chat.profile_assets_count_one": "แอสเซต",
  "chat.profile_assets_count_other": "แอสเซต",
  "chat.profile_my_rewards": "รางวัล",
  "chat.profile_my_shampoo": "แชมพู",
  "chat.profile_others_nsfw_toggle": "โหมดตื่นเต้น",
  "chat.profile_my_edit_title": "แก้ไขโปรไฟล์",
  "chat.profile_my_edit_modal_edit_writername": "แก้ไขชื่อเล่น",
  "chat.profile_my_edit_modal_profile_introduction": "แนะนำโปรไฟล์",
  "chat.profile_my_edit_writername": "ชื่อเล่น",
  "chat.profile_my_edit_username": "ยูเซอร์โคด",
  "chat.profile_my_edit_introduction": "แนะนำ",
  "chat.profile_my_edit_introduction_empty": "เขียนแนะนำเกี่ยวกับคุณ",
  "chat.profile_my_edit_email": "อีเมล",
  "chat.profile_my_edit_email_verify_message": "โปรดยืนยันอีเมล",
  "chat.profile_my_edit_password": "รหัส",
  "chat.profile_my_edit_password_set_message": "ตั้งค่ารหัส",
  "chat.profile_my_edit_password_completed_message": "ตั้งค่ารหัสเรียบร้อย",
  "chat.profile_my_edit_identify_verification": "ยืนยันตัวตน",
  "chat.profile_my_edit_verify_identity": "โปรดยืนยันตัวตน",
  "chat.profile_my_edit_identify_verification_completed_message": "ยืนยันตัวตนสำเร็จ",
  "chat.profile_my_edit_edit_button": "แก้ไข",
  "chat.profile_my_edit_edit_verify_button": "ยืนยัน",
  "chat.profile_my_edit_edit_verify_completed_button": "ยืนยันสำเร็จ",
  "chat.profile_my_edit_country_content_options_change_toast": "เปลี่ยนประเทศสำเร็จ",
  "chat.profile_my_edit_content_display_settings_change_toast": "เปลี่ยนการตั้งค่าการดูคอนเทนต์แล้ว",
  "chat.profile_my_edit_country_content_options": "ประเทศและคอนเทนต์",
  "chat.profile_my_edit_view_content_other_languages": "ดูคอนเทนต์ในรูปแบบภาษาอื่น",
  "chat.profile_my_edit_view_content_other_languages_thai": "ภาษาไทย",
  "chat.profile_my_edit_view_content_other_languages_korean": "ภาษาเกาหลี",
  "chat.profile_my_edit_view_content_other_languages_taiwanese": "ภาษาไต้หวัน",
  "chat.profile_my_edit_view_content_other_languages_japanese": "ภาษาญี่ปุ่น",
  "chat.profile_my_edit_view_content_display_settings": "ตั้งค่าการดูคอนเทนต์",
  "chat.profile_my_edit_view_content_current_country": "ประเทศปัจจุบัน",
  "chat.profile_my_edit_view_content_all_countries": "ทุกประเทศ",
  "chat.profile_my_edit_country_settings": "ตั้งค่าประเทศ",
  "chat.profile_my_edit_language_settings": "ตั้งค่าภาษา",
  "chat.profile_my_edit_language_settings_popup_title": "ตั้งค่าภาษา",
  "chat.profile_my_edit_language_settings_popup_subtitle": "เลือกภาษา",
  "chat.profile_no_exist": "ไม่พบผู้ใช้",
  "chat.profile_number_of_people": "{{int_numbers}}คน",
  "chat.profile_my_create_no_personas": "ไม่มีตัวตนที่คุณสร้าง",
  "chat.profile_my_create_no_scenes": "ไม่มีฉากที่คุณสร้าง",
  "chat.profile_my_create_no_universes": "ไม่มีจักรวาลที่คุณสร้าง",
  "chat.profile_my_create_no_characters": "ไม่มีตัวละครที่คุณสร้าง",
  "chat.profile_my_favorite_no_scenes": "ไม่มีฉากในรายการโปรด",
  "chat.profile_my_favorite_no_universes": "ไม่มีจักรวาลในรายการโปรด",
  "chat.profile_my_favorite_no_characters": "ไม่มีตัวละครในรายการโปรด",
  "chat.profile_my_recently_played_no_scenes": "ไม่มีฉากที่เล่นล่าสุด",
  "chat.profile_my_recently_played_no_universes": "ไม่มีจักรวาลที่เล่นล่าสุด",
  "chat.profile_my_recently_played_no_characters": "ไม่มีตัวละครที่เล่นล่าสุด",
  "chat.profile_my_like_find_scenes": "หาฉากที่คุณชอบ",
  "chat.profile_my_like_find_universes": "หาจักรวาลที่คุณชอบ",
  "chat.profile_my_like_find_characters": "หาตัวละครที่คุณชอบ",
  "chat.profile_my_contest_tab_title": "การประกวด",
  "chat.profile_my_contest_tab_ongoing": "กำลังดำเนินการ",
  "chat.profile_my_contest_tab_past_entries": "ผลงานที่ผ่านมา",
  "chat.profile_my_contest_participate_button": "เข้าร่วม",
  "chat.profile_my_contest_badge_button": "อยู่ระหว่างการตัดสิน",
  "chat.profile_my_contest_view_button": "ดูข้อมูลการประกวด",
  "chat.profile_my_contest_view_results_button": "ดูผลการประกวด",
  "chat.profile_my_contest_no_ongoing_contests": "ไม่มีการประกวดที่กำลังดำเนินการ",
  "chat.profile_my_contest_ongoing_contests": "การประกวดกำลังเปิดรับสมัคร!<br/>สร้างตัวละครแล้วเข้าร่วมการประกวดเลย",
  "chat.profile_my_contest_entered_null": "คุณยังไม่ได้เข้าร่วมการประกวด",
  "chat.profile_my_set_password": "ตั้งค่ารหัส",
  "chat.profile_my_same_verified_email": "อีเมลซ้ำกับอีเมลที่ใช้ยืนยันไปแล้วก่อนหน้านี้",
  "chat.profile_my_already_verified": "ตัวตนนี้เคยได้รับการยืนยันแล้ว",
  "chat.profile_my_verify_adult_verification_toast_title": "Adult verification required.",
  "chat.profile_my_verify_adult_reverification_toast_title": "ระยะเวลาการยืนยันอายุ<br/>หมดอายุแล้ว",
  "chat.profile_my_verify_adult_reverification_toast_description": "การยืนยันตัวตนเป็น กระบวนการทางกฎหมาย ตามมาตรา 17 วรรค 2 ของพระราชกฤษฎีกาการคุ้มครองเยาวชน ซึ่งหลังจากยืนยันตัวตนครั้งแรกครบ 1 ปี จะต้องยืนยันตัวตนอีกครั้ง",
  "chat.profile_my_verify_youth_protection_toast_title": "เนื้อหาจำกัดอายุ",
  "chat.profile_my_verify_adult_verification_identity_verification": "ยืนยันตัวตน",
  "chat.profile_my_verify_adult_verification_identity_reverification": "ยืนยันอีกครั้ง",
  "chat.profile_my_verify_youth_protection_toast": "เนื้อหานี้เป็นเนื้อหาที่ไม่เหมาะสมกับเยาวชน<br/>ภายใต้กฎหมายการคุ้มครองเด็กและเยาวชน<br/>ภายใต้นโยบายการเผยแพร่สื่อสารสนเทศ<br/><br/>เยาวชนที่มีอายุต่ำกว่า 19 ปีไม่สามารถใช้ได้",
  "chat.profile_my_edit_verify_modal_personal_information": "ฉันยินยอมให้<link1> รวบรวมและใช้ข้อมูลส่วนบุคคลของฉัน </link1>",
  "chat.profile_my_edit_verify_modal_personal_information_transfer": "ฉันยอมรับว่าข้อมูลส่วนบุคคลที่รวบรวมจะถูกถ่ายโอนไปยัง Korea Internet & Security Agency e-Privacy Clean Service เพื่อจุดประสงค์ในการป้องกันการโจรกรรม",
  "chat.profile_my_edit_verify_modal_legally_responsible": "ฉันตกลงที่จะรับผิดทางกฎหมายหากฉันใช้ชื่อของบุคคลอื่นหรือใช้ข้อมูลส่วนบุคคลที่ไม่ใช่ของตนเอง",
  "chat.profile_my_edit_verify_modal_termination_suspension": "ฉันรับทราบว่าการให้ข้อมูลที่เป็นเท็จหรือฉ้อโกงอาจส่งผลให้มีการยกเลิกบริการและถูกระงับบัญชีได้",
  "chat.profile_my_edit_verify_modal_one_identify": "คุณสามารถยืนยันตัวตนได้เพียง 1ชื่อต่อ 1 บัญชีเท่านั้น",
  "chat.profile_my_edit_verify_modal_adult_content": "หากคุณได้รับการยืนยันว่าบรรลุนิติภาวะจาการยืนยันตัวตนแล้ว คุณสามารถสร้างหรือใช้เนื้อหาสำหรับผู้ใหญ่ได้",
  "chat.profile_my_edit_verify_modal_valid": "ข้อมูลการยืนยันตัวตนจะมีผลใช้งานได้ 1 ปี",
  "chat.profile_my_edit_verify_modal_penalties": "หากคุณใช้ชื่อของผู้อื่นยืนยันตัวตน คุณอาจเผชิญกับข้อเสีย เช่น ถูกลงโทษทางกฎหมายและถูกจำกัดการใช้งาน",
  "chat.profile_delete_account_rewards": "หากคุณยกเลิกสมาชิก รางวัลที่เคยได้รับทั้งหมดจะสูญหายและไม่สามารถกู้คืนได้",
  "chat.profile_delete_account_delete_assets": "ตัวละคร จักรวาล ฉาก และเนื้อหาอื่น ๆ ที่คุณสร้างขึ้นจะไม่หายไปเมื่อคุณยกเลิกสมาชิก กรุณาลบเนื้อหาดังกล่าวก่อนยกเลิกสมาชิก",
  "chat.profile_delete_account_personal_info": "แม้ว่าคุณจะยกเลิกสมาชิกสำเร็จแต่ข้อมูลส่วนบุคคลจะถูกเก็บไว้ระยะเวลาหนึ่งก่อนจะถูกทำลายตามนโยบายการประมวลผลข้อมูลส่วนบุคคลของบริษัทบับเบิลแท็บ",
  "chat.profile_delete_account_verification": "หากคุณยกเลิกการเป็นสมาชิกหลังจากการยืนยันตัวตน คุณจะไม่สามารถยืนยันตัวตนของคุณอีกครั้งภายใต้ชื่อนั้นได้เป็นเวลา 7 วัน",
  "chat.profile_delete_account_benefits": "หากคุณยกเลิกสมาชิกหลังจากได้รับสิทธิประโยชน์ \"ซูเปอร์ แชมพู\" ในฐานะสมาชิกใหม่ คุณจะไม่สามารถรับสิทธิประโยชน์นั้นได้อีกภายใต้ชื่อนั้น",
  "chat.profile_delete_account_enter_password": "กรุณากรอกรหัสผ่านเพื่อยืนยันตัวตน",
  "chat.profile_delete_account_current_password": "กรุณากรอกรหัสผ่านปัจจุบัน",
  "chat.profile_delete_account_password_combination": "กรุณากรอกตัวอักษรภาษาอังกฤษ, ตัวเลขและอักขระพิเศษ 8~25 ตัว ",
  "chat.profile_delete_account_agree_all": "กรุณายอมรับทั้งหมด",
  "chat.profile_delete_account_agree_all_delete": "คุณจะสามารถลบบัญชีได้หลังจากยอมรับทั้งหมด",
  "chat.profile_delete_account_password_incorrect": "รหัสผ่านไม่ถูกต้อง",
  "chat.profile_delete_account_set_password": "กรุณาตั้งค่ารหัสก่อนดำเนินการต่อ",
  "chat.profile_delete_account_delete_success": "บัญชีถูกลบสำเร็จ",
  "chat.profile_my_purchased_stories_title": "สตอรีที่ซื้อ",
  "chat.profile_my_purchased_stories_count_zero": "สตอรี",
  "chat.profile_my_purchased_stories_count_one": "สตอรี",
  "chat.profile_my_purchased_stories_count_other": "สตอรี",
  "chat.profile_my_upload_image_button": "อัปโหลดรูปภาพ",
  "chat.profile_my_decorate_profile_button": "ตกแต่งโปรไฟล์",
  "chat.profile_my_decorater_profile_edit_message": "เมื่อเปลี่ยนรูปโปรไฟล์ กรอบโปรไฟล์ที่ใช้งานอยู่จะถูกยกเลิก",
  "chat.profile_my_decorater_upload_profile_message": "กรุณาตั้งรูปโปรไฟล์ก่อนใช้งาน",
  "chat.profile_my_edit_referrer_title": "ผู้แนะนำ",
  "chat.profile_my_edit_referrer_register_code_title": "ลงทะเบียนโค้ด",
  "chat.profile_my_edit_referrer_register_code_button": "ลงทะเบียน",
  "chat.profile_my_edit_referrer_copy_code_title": "คัดลอกโค้ด",
  "chat.profile_my_edit_referrer_register_code_description": "กรอกโค้ดแนะนำ<br/><bold>รับเลย</bold> <highlight>{{int_numbers}} บับเบิล</highlight>",
  "chat.profile_my_edit_referrer_register_code_input_placeholder": "กรอกโค้ดผู้แนะนำ",
  "chat.profile_my_edit_referrer_register_code_remaining_time_label": "ระยะเวลาที่เหลือในการลงทะเบียน",
  "chat.profile_my_edit_referrer_register_code_remaining_time_format": "{{int_day}}วัน {{int_time}}:{{int_minute}}:{{int_second}}",
  "chat.profile_my_edit_referrer_notice_title": "ข้อควรทราบ",
  "chat.profile_my_edit_referrer_notice_description1": "เฉพาะบัญชีที่ยืนยันตัวตนแล้วเท่านั้นที่สามารถเป็นผู้แนะนำได้",
  "chat.profile_my_edit_referrer_notice_description2": "เฉพาะบัญชีที่ยืนยันตัวตนแล้วเท่านั้นที่สามารถลงทะเบียนผู้แนะนำได้",
  "chat.profile_my_edit_referrer_notice_description3": "เมื่อลงทะเบียนโค้ดแนะนำ ผู้ที่ลงทะเบียนจะได้รับ {{int_refereeAmount}} บับเบิล และผู้แนะนำจะได้รับ {{int_referrerAmount}} บับเบิล",
  "chat.profile_my_edit_referrer_copy_code_description": "เมื่อมีผู้ใช้ลงทะเบียนโค้ดแนะนำของคุณ<br/>คุณจะได้รับ {{int_referrerAmount}} บับเบิล และผู้ลงทะเบียนจะได้รับ {{int_refereeAmount}} บับเบิลทันที",
  "chat.profile_my_edit_referrer_register_code_completed_prefix": "ลงทะเบียนสำเร็จ : ",
  "chat.profile_my_edit_referrer_verification_required_description": "ลงทะเบียนผู้แนะนำได้หลังยืนยันตัวตน",
  "chat.profile_my_edit_referrer_copy_code_toast": "คัดลอกโค้ดผู้แนะนำเรียบร้อยแล้ว",
  "chat.profile_my_edit_referrer_register_code_expired": "หมดเวลาลงทะเบียน",
  "chat.profile_my_edit_referrer_error_unverified_account": "ไม่สามารถลงทะเบียนโค้ดผู้แนะนำของบัญชีที่ยังไม่ได้ยืนยันตัวตนเป็นผู้แนะนำได้",
  "chat.profile_my_edit_referrer_error_user_not_found": "ไม่พบข้อมูลผู้ใช้",
  "chat.profile_my_edit_referrer_error_self_register": "ไม่สามารถใช้บัญชีของตนเองเป็นผู้แนะนำได้",
  "chat.profile_my_edit_referrer_error_period_expired": "หมดระยะเวลาในการกรอกข้อมูล",
  "chat.profile_my_edit_referrer_registration_error_other_country": "ไม่สามารถลงทะเบียนโค้ดแนะนำของผู้ใช้จากประเทศอื่นเป็นผู้แนะนำได้",
  "chat.profile_my_edit_referrer_registration_completed": "ลงทะเบียนผู้แนะนำเรียบร้อย",
  "chat.profile_my_edit_referrer_registered_referrer": "ผู้แนะนำที่ลงทะเบียน",
  "chat.profile_my_edit_referrer_registration_period_expired": "ลงทะเบียนผู้แนะนำ สามารถทำได้ภายใน {{deadline_time}} วันหลังจากยืนยันตัวตนเท่านั้น",
  "chat.profile_my_edit_referrer_benefit_title": "สิทธิประโยชน์",
  "chat.profile_my_edit_referrer_benefit_registration": "ลงทะเบียนผู้แนะนำได้",
  "chat.profile_my_edit_referrer_benefit_condition": "เมื่อลงทะเบียน",
  "chat.profile_my_edit_referrer_benefit_reward": "รับ 3,000 บับเบิล",
  "chat.profile_setting_account_settings": "ตั้งค่าบัญชี",
  "chat.profile_setting_service_settings": "ตั้งค่าบริการ",
  "chat.profile_setting_country_content_settings": "ตั้งค่าประเทศและคอนเทนต์",
  "chat.profile_setting_blocked_list": "จัดการรายการที่บล็อก",
  "chat.profile_setting_creator_support": "สนับสนุนครีเอเตอร์",
  "chat.profile_setting_account": "บัญชี",
  "chat.profile_setting_service_support": "ฝ่ายบริการ",
  "chat.profile_my_mileage_convert_menu_title": "ไมล์",
  "chat.profile_my_mileage_convert_sheet_title": "แลกไมล์",
  "chat.profile_my_mileage_convert_sheet_description": "ไมล์ 1 คะแนน แลกได้ 1 บับเบิล",
  "chat.profile_my_mileage_convert_balance_label": "ไมล์ที่มี",
  "chat.profile_my_mileage_convert_input_label": "ไมล์ที่ต้องการแลก",
  "chat.profile_my_mileage_convert_input_max": "สูงสุด",
  "chat.profile_my_mileage_convert_input_placeholder": "แลกได้ทีละ {{int_numbers}} ไมล์",
  "chat.profile_my_mileage_convert_input_error_unit": "*แลกได้ทีละ {{int_numbers}} ไมล์เท่านั้น",
  "chat.profile_my_mileage_convert_info_title": "ไมล์คืออะไร?",
  "chat.profile_my_mileage_convert_info_description_1": "สามารถแลกเป็นบับเบิลได้ตั้งแต่ {{int_numbers}} ไมล์ขึ้นไป โดยบับเบิลที่แลกมาจะสามารถใช้งานได้เช่นเดียวกับบับเบิลปกติ",
  "chat.profile_my_mileage_convert_info_description_2": "บับเบิลที่แลกจากไมล์มีอายุการใช้งาน 1 ปี",
  "chat.profile_my_mileage_convert_info_description_3": "ไมล์ไม่สามารถเปลี่ยนหรือขอคืนได้",
  "chat.profile_my_mileage_convert_submit_button": "แลกเป็นบับเบิล",
  "chat.profile_my_mileage_convert_confirm_modal_title": "ต้องการแลกไมล์หรือไม่?",
  "chat.profile_my_mileage_convert_confirm_modal_description": "เมื่อแลกเป็นบับเบิลแล้ว จะไม่สามารถเปลี่ยนกลับเป็นไมล์ได้ และมีอายุการใช้งาน 1 ปี",
  "chat.profile_my_mileage_convert_confirm_modal_submit": "ยืนยันการแลก",
  "chat.profile_my_mileage_convert_complete_modal_title": "แลกสำเร็จ",
  "chat.profile_my_mileage_convert_complete_modal_description": "ได้รับ {{int_numbers}} บับเบิลแล้ว",
  "chat.profile_my_mileage_convert_my_bubble_label": "บับเบิลของฉัน",
  "chat.profile_my_mileage_convert_remaining_label": "ไมล์คงเหลือ",
  "chat.profile_my_mileage_load_failed": "โหลดไม่สำเร็จ",
  "chat.profile_my_mileage_reward_view": "ดู",
  "chat.studio_create_image": "สร้างรูปภาพ",
  "chat.studio_create_story": "สร้างสตอรี",
  "chat.create_create_preset_create_description": "สร้างได้ตั้งแต่ตัวละครไปจนถึงจักรวาลในครั้งเดียว",
  "chat.create_create_custom_create_description": "สร้างตัวละครที่สามารถใช้กับจักรวาล และฉากต่างๆ ได้",
  "chat.create_create_universe_create_description": "กำหนดพื้นหลังและสภาพแวดล้อมที่เกิดการสนทนา",
  "chat.create_create_scene_create_description": "กำหนดสถานการณ์เฉพาะที่กำลังเกิดบทสนทนานั้นๆ",
  "chat.create_create_preset": "แบบสร้างพร้อมกัน",
  "chat.create_create_preset_title": "ตัวละคร×จักรวาล×ฉาก",
  "chat.create_create_custom": "แบบสร้างแยก",
  "chat.create_create_preset_tooltip_title": "✅ แบบสร้างพร้อมกันคืออะไร?",
  "chat.create_create_preset_tooltip_description1": "การสร้างตัวละคร จักรวาล และฉากพร้อมกัน",
  "chat.create_create_preset_tooltip_description2": "ใช้คำสั่งและฟีเจอร์หลากหลายเพื่อสร้างตัวละครได้อย่างรวดเร็ว",
  "chat.create_create_preset_tooltip_description3": "แอสเซตแบบสร้างพร้อมกัน ใช้ร่วมกับแอสเซตแบบสร้างแยกไม่ได้",
  "chat.create_create_preset_tooltip_description4": "เมื่อสร้างแบบพร้อมกันแล้ว ไม่สามารถเปลี่ยนเป็นแบบแยกส่วนได้",
  "chat.create_create_custom_tooltip_title": "✅ แบบสร้างแยกคืออะไร?",
  "chat.create_create_custom_tooltip_description1": "การสร้างตัวละคร จักรวาล และฉากแยกกัน แล้วนำมารวมกัน",
  "chat.create_create_custom_tooltip_description2": "สร้างและแก้ไขแต่ละส่วนแยกกันได้ สามารถเพิ่ม และสร้างซ้ำได้ง่าย",
  "chat.create_create_custom_tooltip_description3": "แอสเซตแบบสร้างแยก ใช้ร่วมกับแอสเซตแบบสร้างแยกเท่านั้น",
  "chat.create_create_custom_tooltip_description4": "แอสเซตแบบสร้างพร้อมกัน ใช้ร่วมกับแอสเซตแบบสร้างแยกไม่ได้",
  "chat.create_preset_lorebook_placeholder": "จำนวนตัวอักษรไม่รวมชื่อเรื่อง",
  "chat.create_preset_character_details": "ข้อมูลตัวละคร",
  "chat.create_preset_character_details_placeholder": "ระบุข้อมูลตัวละครที่ไม่ต้องการเปิดเผยที่นี่",
  "chat.create_preset_background_details": "ข้อมูลฉากหลัง",
  "chat.create_preset_background_details_public_placeholder": "โปรดระบุรายละเอียดของเรื่องราวที่คุณต้องการ<br/><br/>เช่น)<br/>นี่คือยุคสมัยที่เรื่องราวของเวทมนตร์เป็นเรื่องปกติของทุกคน<br/> โลกเต็มไปด้วยสัตว์ประหลาดและสิ่งผิดปกติมากมาย",
  "chat.create_preset_background_details_private_placeholder": "ระบุข้อมูลฉากหลังที่ไม่ต้องการเปิดเผยที่นี่",
  "chat.create_asset_relationship_placeholder": "กรุณากรอกข้อมูลความสัมพันธ์ที่ไม่ต้องการเปิดเผยในช่องนี้",
  "chat.create_asset_details_placeholder": "กรุณากรอกรายละเอียดเพิ่มเติมที่ไม่ต้องการเปิดเผยในช่องนี้",
  "chat.create_asset_lorebook_placeholder": "กรุณากรอกข้อมูลเนื้อเรื่องที่ไม่ต้องการเปิดเผยในช่องนี้",
  "chat.create_create_button": "สร้าง",
  "chat.create_character_profile_img": "รูปโปรไฟล์",
  "chat.create_character_name_placeholder1": "อีฮวาน",
  "chat.create_character_name_placeholder2": "คิมอูบิน",
  "chat.create_character_name_placeholder3": "จองฮานา",
  "chat.create_introduction_label": "แนะนำสั้นๆ",
  "chat.create_character_introduction_placeholder1": "นักศึกษามหาวิทยาลัยผู้ไม่ค่อยมาเรียน",
  "chat.create_character_introduction_placeholder2": "เพื่อนชายสุดเนิร์ดขี้อายแต่โหยหาความรัก",
  "chat.create_character_introduction_placeholder3": "หุ่นยนต์แม่บ้าน",
  "chat.create_character_introduction_help_text": "*ข้อมูลแนะนำสั้นๆไม่ส่งผลต่อการสนทนาของตัวละคร",
  "chat.create_tags_label": "แท็ก",
  "chat.create_character_tags_description": "โปรดเลือกแท็กที่สอดคล้องกับตัวละคร",
  "chat.create_tags_placeholder": "ค้นหาแท็ก",
  "chat.create_tags_add": "เพิ่มแท็ก",
  "chat.create_tags_minimum_fail_message": "เลือกอย่างน้อย 1 แท็ก",
  "chat.create_tags_repeated_fail_message": "แต่ละแท็กสามารถเลือกได้ครั้งเดียวเท่านั้น",
  "chat.create_tags_maximum_fail_message": "เลือกสูงสุดได้ 5 แท็ก",
  "chat.create_tags_maximum_fail_message_a": "คุณสามารถเลือกแท็กได้สูงสุด{{int_tagNumbers}}แท็ก",
  "chat.create_tags_no_match_scenes": "ไม่มีแท็กที่ตรงกับฉาก",
  "chat.create_tags_no_match_universes": "ไม่มีแท็กที่ตรงกับจักรวาล",
  "chat.create_tags_no_match_characters": "ไม่มีแท็กที่ตรงกับตัวละคร",
  "chat.create_sharing_option_label": "เปิดเผยหรือไม่",
  "chat.create_sharing_option_private_title": "ไม่เปิดเผย",
  "chat.create_sharing_option_private_description": "การใช้งานเป็นส่วนตัว",
  "chat.create_sharing_option_public_title": "เปิดเป็นสาธารณะ",
  "chat.create_sharing_option_public_description": "ผู้ใช้ทุกคนสามารถใช้งานได้",
  "chat.create_tap_specifics": "ข้อมูลจำเพาะ",
  "chat.create_age_minimum_fail_message": "อายุต้องไม่ต่ำกว่า -1พันล้านปี",
  "chat.create_age_maximum_fail_message": "อายุต้องไม่เกิน 1 พันล้านปี",
  "chat.create_character_job_placeholder1": "นักศึกษามหาวิทยาลัย",
  "chat.create_character_job_placeholder2": "เป็นเฟรชชีปี 1 ของมหาวิทยาลัยบับเบิล",
  "chat.create_character_job_placeholder3": "แม่บ้าน ",
  "chat.create_character_character_placeholder1": "ใจดี, อบอุ่น, สดใส",
  "chat.create_character_character_placeholder2": "ระมัดระวัง, ขี้อาย, เอาใจใส่, โหยหาความรัก",
  "chat.create_character_character_placeholder3": "สุภาพ, เข้มงวด, บางครั้งก็ทำอะไรเกิดคาดเดา",
  "chat.create_character_speaking_style_placeholder1": "\"ฉันอยากเป็นแค่นักเรียนทั่วไปเมื่ออยู่ที่โรงเรียน\"",
  "chat.create_character_speaking_style_placeholder2": "\"วะ..หวัดดี\", \"จะมีใคร..รักฉันไหมนะ?\", \"ฉันคิดถึงเธอมาก \"",
  "chat.create_character_speaking_style_placeholder3": "\"จะให้เริ่มทำความสะอาดตรงไหนดีคะ?\"",
  "chat.create_character_interests_placeholder1": "ซ้อมร้องเพลง, กังวลเกี่ยวกับคอนเสิร์ตที่จะมาถึง",
  "chat.create_character_interests_placeholder2": "อ่านหนังสือ, เข้ายิม, เดต, ความรัก",
  "chat.create_character_interests_placeholder3": "ดอกไฮเดรนเยีย, งานบ้าน, ไก่ทอด",
  "chat.create_details_help_text": "{{assistant}} จะถูกแทนที่ด้วยชื่อตัวละครของคุณ {{user}}จะถูกแทนที่ด้วยชื่อของผู้ใช้ที่กำลังแชตด้วย",
  "chat.create_global_availability_title": "การเปิดใช้งานประเทศอื่น",
  "chat.create_global_availability_global": "โกลบอล",
  "chat.create_global_availability_global_description": "สามารถรับความคิดเห็นจากทุกประเทศได้",
  "chat.create_global_availability_domestic": "ภายในประเทศ",
  "chat.create_global_availability_domestic_description": "สามารถรับความคิดเห็นได้เฉพาะจากประเทศปัจจุบัน",
  "chat.create_global_availability_help_text": "*เมื่อเปิดใช้งานแบบโกลบอล การตั้งค่าในชุดข้อมูลจะไม่ถูกใช้ในประเทศอื่น",
  "chat.create_global_availability_auto_translation_help_text": "*แปลโดยระบบอัตโนมัติ",
  "chat.create_character_failed_domestic_universe_scene": "ไม่สามารถสร้างตัวละครแบบโกลบอลได้ เนื่องจากจักรวาล/ฉากถูกตั้งค่าเป็นภายในประเทศ<br/>กรุณาเลือกจักรวาล/ฉากแบบโกลบอล",
  "chat.modify_character_failed_domestic_universe_scene": "ไม่สามารถสร้างตัวละครแบบโกลบอลได้ เนื่องจากจักรวาล/ฉากถูกตั้งค่าเป็นภายในประเทศ<br/>กรุณาเลือกจักรวาล/ฉากแบบโกลบอล",
  "chat.modify_character_alert_domestic_universe": "หากตั้งค่าเป็นภายในประเทศ จักรวาลนี้จะถูกนำออกจากตัวละครที่ตั้งค่าเป็นค่าเริ่มต้นในประเทศอื่น<br/>คุณต้องการดำเนินการต่อหรือไม่?",
  "chat.modify_character_alert_domestic_scene": "หากตั้งค่าเป็นภายในประเทศ ฉากนี้จะถูกนำออกจากตัวละครที่ตั้งค่าเป็นค่าเริ่มต้นในประเทศอื่น<br/>คุณต้องการดำเนินการต่อหรือไม่?",
  "chat.create_tap_background": "พื้นหลัง",
  "chat.create_tooltip_title": "Tip",
  "chat.create_tooltip_universe_description": "สร้าง' หรือ 'เพิ่ม' จักรวาลที่เหมาะสมเพื่อตั้งค่าเริ่มต้นให้กับตัวละครของคุณ",
  "chat.create_tooltip_scene_description": "สร้าง' หรือ 'เพิ่ม' ฉากที่เหมาะสมเพื่อตั้งค่าเริ่มต้นให้กับตัวละครของคุณ",
  "chat.create_first_sentence_description": "นี่คือคำพูดแรกที่ตัวละครจะใช้เมื่อเริ่มการสนทนา",
  "chat.create_first_sentence_placeholder1": "*อีฮวานที่ไม่ได้มาโรงเรียนสักพักแล้วเข้ามาคุยกับคุณ* ฉันขอดูหนังสือเรียนหน่อยได้ไหม? พอดีว่าลืมเอามาน่ะ",
  "chat.create_first_sentence_placeholder2": "ทำไมเพิ่งมา..? ฉันรออยู่นะ..",
  "chat.create_first_sentence_placeholder3": "มีอะไรอยากให้ฉันช่วยไหมคะ?",
  "chat.create_first_sentence_int_numbers": "คำพูดแรก {{int_numbers}}",
  "chat.create_first_sentence_add_button": "เพิ่มคำพูดแรก",
  "chat.create_first_sentence_title": "หัวข้อ",
  "chat.create_first_sentence_description1": "* สามารถเพิ่มได้สูงสุด 3 รายการ",
  "chat.create_first_sentence_description2": "* คำพูดแรกจะไม่นับรวมในจำนวนตัวอักษรของพรอมต์",
  "chat.create_first_sentence_delete_confirm_message": "ต้องการลบคำพูดแรกหรือไม่?",
  "chat.create_creator_comment_label": "ความคิดเห็นจากครีเอเตอร์",
  "chat.create_creator_comment_placeholder": "กรุณากรอกข้อความที่คุณต้องการส่งถึงผู้เล่น",
  "chat.create_prompt_label": "พรอมต์",
  "chat.create_basic_info_label": "ข้อมูลจำเป็น",
  "chat.create_media_label": "มีเดีย",
  "chat.create_extra_info_label": "ข้อมูลเพิ่มเติม",
  "chat.create_prompt_characters_toast": "กรุณาใส่พรอมต์ไม่เกิน {{int_characters}} ตัวอักษร",
  "chat.create_creator_comment_characters_toast": "กรุณาใส่ความคิดเห็นจากครีเอเตอร์ไม่เกิน {{int_characters}} ตัวอักษร",
  "chat.create_creator_first_sentence_characters_toast": "กรุณากรอกข้อความแรกไม่เกิน {{int_characters}} ตัวอักษร",
  "chat.create_creator_lorebook_characters_toast": "กรุณากรอกข้อมูลตัวละครไม่เกิน {{int_characters}} ตัวอักษร",
  "chat.create_creator_keywordbook_characters_toast": "กรุณากรอกเนื้อหาคีย์เวิร์ดบุ๊ก {{int_keywordbookNumbers}} ไม่เกิน {{int_characters}} ตัวอักษร",
  "chat.create_creator_description_characters_toast": "กรุณาระบุสถานการณ์ไม่เกิน {{int_characters}} ตัวอักษร",
  "chat.create_character_create_fail_message": "การสร้างตัวละครล้มเหลว <br/>โปรดลองใหม่อีกครั้ง",
  "chat.create_alert_message_name": "กรุณาใส่ชื่อ",
  "chat.create_alert_message_image": "กรุณาแนบรูปภาพ",
  "chat.create_modal_gif_description": "ไม่สามารถแก้ไขรูปภาพ GIF ได้",
  "chat.create_alert_message_tags": "เลือกอย่างน้อย 1 แท็ก",
  "chat.create_alert_message_introduction": "โปรดระบุคำแนะนำสั้นๆ เกี่ยวกับตัวละคร",
  "chat.create_alert_message_age": "กรุณาใส่อายุ",
  "chat.create_alert_message_nsfw": "จักรวาล/ฉากโหมดตื่นเต้น สามารถเลือกใช้กับตัวละครที่จัดอยู่ในโหมดตื่นเต้นเท่านั้น",
  "chat.create_alert_message_private": "จักรวาล/ฉากนี้ถูกตั้งค่าเป็นส่วนตัวคุณไม่สามารถสร้างตัวละครได้ คุณต้องการสร้างตัวละครแบบส่วนตัวหรือไม่?",
  "chat.create_alert_message_cancel": "ยกเลิก",
  "chat.create_private_character": "สร้างแบบส่วนตัว",
  "chat.create_universe_name_help_text": "*ห้ามสร้างจักรวาลที่ละเมิดทรัพย์สินทางปัญญาของผู้อื่น",
  "chat.create_universe_details_placeholder": "โปรดระบุรายละเอียดของจักรวาลที่คุณต้องการ<br/><br/>เช่น)<br/>นี่คือยุคสมัยที่เรื่องราวของเวทมนตร์เป็นเรื่องปกติของทุกคน<br/> โลกเต็มไปด้วยสัตว์ประหลาดและสิ่งผิดปกติมากมาย",
  "chat.create_universe_create_fail_message": "การสร้างจักรวาลล้มเหลว <br/>โปรดลองใหม่อีกครั้ง",
  "chat.create_scene_name_help_text": "*ห้ามสร้างฉากที่ละเมิดทรัพย์สินทางปัญญาของผู้อื่น",
  "chat.create_setup_label": "Setup",
  "chat.create_scene_create_fail_message": "การสร้างฉากล้มเหลว <br/>โปรดลองใหม่อีกครั้ง",
  "chat.create_draft_button": "บันทึกฉบับร่าง",
  "chat.create_draft_asset_in_progress_modal_title": "มีแอสเซตที่กำลังสร้างอยู่",
  "chat.create_draft_asset_in_progress_modal_description": "ต้องการทำต่อหรือไม่?",
  "chat.create_draft_save_fail_storage_full_modal_title": "แอสเซตปัจจุบันไม่สามารถบันทึกฉบับร่างได้",
  "chat.create_draft_save_fail_storage_full_modal_description": "พื้นที่จัดเก็บเต็ม สามารถสร้างได้เท่านั้น<br/>กรุณาจัดการแอสเซตที่บันทึกฉบับร่าง หรือสร้างให้เสร็จก่อนใช้งานต่อ",
  "chat.create_draft_save_fail_storage_full_modal_manage_drafts_button": "จัดการบันทึกฉบับร่าง",
  "chat.create_draft_save_modal_title": "ต้องการบันทึกแอสเซตที่สร้างเป็นฉบับร่างหรือไม่?",
  "chat.create_draft_save_modal_description": "บันทึกฉบับร่างได้สูงสุด {{count}} รายการ ข้อมูลที่ไม่ได้บันทึกจะถูกลบ",
  "chat.create_draft_save_fail_maximum_limit_modal_title": "บันทึกฉบับร่างได้สูงสุด {{count}} รายการ",
  "chat.create_draft_save_success_toast": "บันทึกฉบับร่างสำเร็จ",
  "chat.create_draft_save_fail_toast": "บันทึกฉบับร่างล้มเหลว กรุณาลองใหม่อีกครั้ง",
  "chat.create_draft_edit_option": "ทำต่อ",
  "chat.create_draft_delete_success_toast": "ลบแอสเซตที่บันทึกฉบับร่างแล้ว",
  "chat.create_draft_delete_fail_toast": "ลบแอสเซตที่บันทึกฉบับร่างล้มเหลว กรุณาลองใหม่อีกครั้ง",
  "chat.create_draft_empty": "ไม่มีแอสเซตที่กำลังสร้างอยู่",
  "chat.create_draft_noname": "No name",
  "chat.create_create_title": "สร้าง",
  "chat.create_create_character": "ตัวละคร",
  "chat.create_create_universe": "จักรวาล",
  "chat.create_create_scene": "ฉาก",
  "chat.create_create_character_header": "สร้างตัวละคร",
  "chat.create_create_universe_header": "สร้างจักรวาล",
  "chat.create_create_scene_header": "สร้างฉาก",
  "chat.create_add_image_help_text_square": "ดิสเพลย์จะแสดงได้ดีที่สุดเมื่อแก้ในรูปแบบสี่เหลี่ยมจตุรัส",
  "chat.create_create_character_create": "สร้างตัวละคร",
  "chat.create_create_character_create_description": "กำหนดบุคลิกภาพและลักษณะของตัวละคร AI",
  "chat.create_create_character_my_characters": "ตัวละครของฉัน",
  "chat.create_create_character_my_characters_empty": "สร้างตัวละครในแบบของคุณ",
  "chat.create_create_universe_create": "สร้างจักรวาล",
  "chat.create_create_universe_my_universes": "จักรวาลของฉัน",
  "chat.create_create_universe_my_universes_empty": "สร้างจักรวาลในแบบของคุณ",
  "chat.create_create_scene_create": "สร้างฉาก",
  "chat.create_create_scene_my_scenes": "ฉากของฉัน",
  "chat.create_create_scene_my_scenes_empty": "สร้างฉากในแบบของคุณ",
  "chat.create_character_creation_guide": "โปรดอ่านคู่มือการสร้างตัวละคร!",
  "chat.create_character_add_thumbnail_image_button": "เพิ่มรูปภาพ",
  "chat.create_add_image_failed": "เพิ่มรูปภาพไม่สำเร็จ",
  "chat.create_character_basics_label": "ข้อมูลพื้นฐาน",
  "chat.create_character_basics_name": "ชื่อ",
  "chat.create_character_basics_name_help_text": "*ห้ามสร้างตัวละครที่ละเมิดทรัพย์สินทางปัญญาของผู้อื่น โปรดตรวจสอบนโยบายการดำเนินงานสำหรับข้อมูลเพิ่มเติม",
  "chat.create_character_basics_gender_label": "เพศ",
  "chat.create_character_basics_gender_male": "ชาย",
  "chat.create_character_basics_gender_female": "หญิง",
  "chat.create_character_basics_gender_other": "อื่นๆ",
  "chat.create_character_basics_age_rating_label": "เรทอายุ",
  "chat.create_character_basics_age_rating_normal_mode": "โหมดทั่วไป",
  "chat.create_character_basics_age_verification": "ตัวละครโหมดตื่นเต้นสามารถสร้างได้หลังจากยืนยันอายุแล้วเท่านั้น",
  "chat.create_character_basics_age_rating_normal_mode_description": "ผู้ใช้ทุกคนสามารถใช้งานได้",
  "chat.create_character_basics_age_rating_nsfw_mode": "โหมดตื่นเต้น",
  "chat.create_character_basics_age_rating_nsfw_mode_description": "สำหรับผู้ใช้ที่บรรลุนิติภาวะแล้วเท่านั้น",
  "chat.create_character_basics_age_rating_nsfw_mode_toast": "ตัวละครอายุต่ำกว่า 19 ปี ไม่สามารถสร้างเป็นตัวละครโหมดตื่นเต้นได้",
  "chat.create_character_basics_age_rating_help_text": "*เมื่อเลือกโหมดทั่วไป จักรวาล/ฉากโหมดตื่นเต้นจะไม่สามารถใช้งานได้ในระหว่างกระบวนการสร้าง",
  "chat.create_character_Information_label": "รายละเอียด",
  "chat.create_character_Information_optional": "เลือก",
  "chat.create_character_Information_description": "คุณสามารถระบุข้อมูลเกี่ยวกับตัวละครได้อย่างละเอียด",
  "chat.create_character_Information_age": "อายุ",
  "chat.create_character_Information_job": "อาชีพ",
  "chat.create_character_Information_character": "นิสัย",
  "chat.create_character_Information_speaking_style": "สไตล์คำพูด",
  "chat.create_character_Information_interests": "ความสนใจ",
  "chat.create_character_details_label": "รายละเอียดเพิ่มเติม",
  "chat.create_character_details_toast": "ใส่คำอธิบายเพิ่มเติมโดยที่ตัวอักษรต้องไม่เกิน{{int_characters}}อักษร",
  "chat.create_character_details_public": "รายละเอียดเป็นสาธารณะ",
  "chat.create_character_details_placeholder": "โปรดอธิบายบุคลิกของตัวละครหรือตั้งค่าโดยละเอียด <br/>หลีกเลี่ยงการรวมข้อมูลที่เกี่ยวข้องกับผู้ใช้ในคำอธิบาย <br/><br/>เช่น)<br/>ตัวละครเป็นเด็กฝึกเล่นเกมระดับโปรเกมเมอร์ <br/>ตัวละครเป็นคนไม่สนใจใคร <br/>ตัวละครมีจิตวิญญาณนักแข่งที่แข็งแกร่ง",
  "chat.create_character_details_private": "รายละเอียดที่ไม่เปิดเผย",
  "chat.create_character_details_character_button": "ตัวละคร",
  "chat.create_character_details_user_button": "ฉัน",
  "chat.create_character_multi_images_title": "หลายภาพ",
  "chat.create_character_image_name_title": "ชื่อภาพ {{int_imageNumbers}}",
  "chat.create_character_image_name_placeholder1": "บับบลีที่ไม่ยอมนอน",
  "chat.create_character_image_name_placeholder2": "ช่วงบ่ายที่แสนน่าเบื่อ",
  "chat.create_character_image_name_placeholder3": "ระหว่างทางไปออกกำลัง",
  "chat.create_character_image_name_placeholder4": "นักวิทยาศาสตร์เสียสติ",
  "chat.create_character_image_name_placeholder5": "บับบลีที่กำลังเล่นแชตบอท",
  "chat.create_character_add_multi_image_button": "เพิ่มรูปภาพ",
  "chat.create_character_delete_multi_image_button": "ลบรูปภาพ",
  "chat.create_character_context_title": "ระบุสถานการณ์",
  "chat.create_character_context_tooltip_message": "ยิ่งคุณระบุ ชื่อ, สีหน้า, อารมณ์, สถานที่, เสื้อผ้าและการกระทำละเอียดมากเท่าไรรูปภาพที่ออกมาก็จะคุณภาพสูงมากเท่านั้น, <br/>ตามตัวอย่างด้านล่าง<br/>- บับบลี, ตาปรือ, รู้สึกเพลีย, ที่โต๊ะหนังสือ, สวมฮู้ด, ลูบผม<br/>- มิรุ, สีหน้าไร้อารมณ์, รู้สึกเบื่อ, โรงเรียน, ชุดนักเรียน, นอนฟุบโต๊ะ <br/>- ยูแชวอน, ยิ้มเขินอาย, รู้สึกประหม่า, กำลังไปพิลาทิส, เลกกิ้ง, ท่าทางยั่วยวน",
  "chat.create_character_context_placeholder1": "บับบลี, ตาปรือ, รู้สึกเพลีย, ที่โต๊ะหนังสือ, สวมฮู้ด, ลูบผม",
  "chat.create_character_context_placeholder2": "มิรุ, สีหน้าไร้อารมณ์, รู้สึกเบื่อ, โรงเรียน, ชุดนักเรียน, นอนฟุบโต๊ะ",
  "chat.create_character_context_placeholder3": "ยูแชวอน, ยิ้มเขินอาย, รู้สึกประหม่า, กำลังไปพิลาทิส, เลกกิ้ง, ท่าทางยั่วยวน",
  "chat.create_character_context_placeholder4": "เสื้อกาวน์และถุงมือแล็บฉีกขาด, อันนา เฟาสท์, ตาบ้าคลั่ง, ห้องแล็บ, อยากรู้อยากเห็น, ทดลองสารเคมี",
  "chat.create_character_context_placeholder5": "โต๊ะหนังสือ, บับบลี, หน้าแดง, ตื่นเต้น, สวมฮู้ดสบายๆ, กำลังแชต",
  "chat.create_character_multi_images_help_text": "หลังจากตรวจสอบภาพที่อัปโหลดแล้ว ตัวละครอาจถูกเปลี่ยนเป็นโหมดตื่นเต้นหรือถูกตั้งค่าให้เป็นส่วนตัวตามข้อบังคับ",
  "chat.create_character_add_multi_images_button": "เพิ่มหลายภาพ",
  "chat.create_character_multi_images_modal_title": "เพิ่มรูปภาพ",
  "chat.create_character_multi_images_modal_my_ai_images": "รูป AI ของฉัน",
  "chat.create_character_multi_images_modal_upload_images": "อัปโหลดรูปจากอุปกรณ์ของฉัน",
  "chat.create_character_multi_images_modal_help_text": "รูปภาพจะแสดงได้ดีที่สุดเมื่อแก้ไขให้อยู่ในรูปแบบแนวนอน (16:9)",
  "chat.create_character_multi_images_modal_edit": "แก้ไข",
  "chat.create_character_multi_images_modal_edit_done": "สำเร็จ",
  "chat.create_character_multi_images_modal_edit_zoom": "ซูม",
  "chat.create_character_multi_images_modal_edit_reset": "รีเซ็ต",
  "chat.create_character_multi_images_modal_edit_square": "สี่เหลี่ยม",
  "chat.create_character_multi_images_modal_edit_landscape": "แนวนอน",
  "chat.create_character_multi_images_modal_edit_portrait": "แนวตั้ง",
  "chat.create_character_multi_images_context_error_msg_a": "*โปรดระบุบริบทสำหรับภาพ {{int_imageNumbers}}",
  "chat.create_character_multi_images_context_error_msg_b": "*โปรดตรวจสอบให้แน่ใจว่าบริบทของ ภาพ {{int_imageNumbers}} ไม่ซ้ำกัน",
  "chat.create_character_multi_images_main_image_badge": "รูปภาพที่แสดง",
  "chat.create_character_multi_images_main_image_description": "กรุณาตั้งค่ารูปภาพที่แสดง",
  "chat.create_character_multi_images_image_title_description": "กรุณาใส่ชื่อรูปภาพ",
  "chat.create_character_multi_images_describe_image": "กรุณาอธิบายรูปภาพ",
  "chat.create_character_multi_images_edit_info_button": "แก้ไขข้อมูล",
  "chat.create_character_multi_images_edit_info_modal_title": "แก้ไขข้อมูล",
  "chat.create_character_multi_images_delete_image_button": "ลบรูปภาพ",
  "chat.create_character_multi_images_max_size": "ใหญ่ที่สุด {{int_size}}",
  "chat.create_character_multi_images_edit_info_modal_public_toggle": "รูปสาธารณะ",
  "chat.create_character_multi_images_edit_info_modal_main_image_description": "สามารถอัปโหลดรูปที่แสดงได้ 1 รูป",
  "chat.create_character_multi_images_edit_info_modal_save_button": "บันทึก",
  "chat.create_character_context_placeholder6": "ยิ่งอธิบายรูปภาพไม่ซับซ้อนมากเท่าไรการเปิดภาพก็จะง่ายขึ้นเท่านั้น และยิ่งซับซ้อนมากเท่าไรการเปิดภาพก็จะยากมากขึ้นเท่านั้น<br/><br/>ตัวอย่างที่ไม่ซับซ้อน) บับเบิลที่ดูเหนื่อยล้า<br/>ตัวอย่างที่ซับซ้อน) บับเบิ้ลดูเหนื่อยล้ากำลังนั่งอยู่ที่โต๊ะทำงานด้วยตาที่ง่วงนอน ลูบผมตัวเองและแชตตลอดทั้งคืน",
  "chat.create_character_multi_images_set_public": "ตั้งค่าภาพเป็นสาธารณะ",
  "chat.create_character_multi_images_modal_delete_description": "ข้อมูลและรูปภาพทั้งหมดจะถูกลบออก",
  "chat.create_character_multi_images_modal_delete_cancel": "ยกเลิก",
  "chat.create_character_multi_images_modal_delete_delete": "ลบ",
  "chat.create_character_multi_images_modal_set_unlock_bubbles": "แก้ไขบับเบิลปลดล็อก",
  "chat.create_character_multi_images_modal_unlock_available_images": "แก้ไขได้เฉพาะรูปภาพที่ถูกล็อกเท่านั้น",
  "chat.create_character_multi_images_modal_set_unlock_bubbles_alert1": "กรุณาตั้งค่าบับเบิลปลดล็อก",
  "chat.create_character_multi_images_modal_set_unlock_bubbles_alert2": "ระบุได้แค่หน่วย 100 บับเบิลเท่านั้น",
  "chat.create_character_multi_images_modal_set_unlock_bubbles_alert": "กรุณาตั้งค่าบับเบิลปลดล็อก<br/>ระบุได้แค่หน่วย 100 บับเบิลเท่านั้น",
  "chat.create_character_multi_images_modal_unlock_bubbles": "บับเบิล",
  "chat.create_character_multi_images_no_unlock_bubble_set": "ยังไม่ได้ตั้งค่าบับเบิลปลดล็อก",
  "chat.create_character_multi_images_tooltip_title1": "อะไรคือ 'Multi Images' ?",
  "chat.create_character_multi_images_tooltip_description1": "ฟีเจอร์ภาพ Multi Image คือฟีเจอร์ที่จะแสดงภาพที่เหมาะสมโดยอัตโนมัติ เมื่อตรวจพบคำสำคัญหรือสถานการณ์เฉพาะระหว่างการสนทนา",
  "chat.create_character_multi_images_tooltip_description2": "ยิ่งตั้งค่าสถานการณ์ง่ายเท่าไร ภาพก็จะขึ้นแสดงได้ง่ายขึ้นเท่านั้น",
  "chat.create_character_multi_images_tooltip_title2": "โปรดทราบ!",
  "chat.create_character_multi_images_tooltip_description3": "รูปภาพที่ถูกล็อกจะสามารถเปิดดูได้ก็ต่อเมื่อเกิดสถานการณ์ที่ตั้งค่าไว้ระหว่างการสนทนาเท่านั้น",
  "chat.create_character_multi_images_tooltip_description4": "บับเบิลปลดล็อกสามารถตั้งค่าได้ตั้งแต่ขั้นต่ำ 100 บับเบิลขึ้นไป และจะถูกรวมอยู่ในรายได้รางวัลของตัวละครด้วย",
  "chat.create_character_multi_images_tooltip_description5": "อัตราการแบ่งรายได้จากภาพที่ถูกล็อกคือ 50%",
  "chat.create_character_multi_images_title_placeholder": "กรุณากรอกชื่อรูปภาพ (ไม่บังคับ)",
  "chat.create_character_multi_images_upload_title": "อัปโหลดรูปภาพ",
  "chat.create_character_multi_images_add_title1": "เพิ่มรูปภาพ",
  "chat.create_character_multi_images_add_title2": "({{int_numbers}}/200)",
  "chat.create_character_multi_images_add_description1": "คลิกหรือ ลาก & วาง เพื่ออัปโหลดรูปภาพ",
  "chat.create_character_multi_images_add_description2": "อัปโหลดได้สูงสุด {{int_numbers}} รูปพร้อมกัน",
  "chat.create_character_multi_images_add_description3": "รูปภาพ 1 รูป อัปโหลดได้ไม่เกิน 15MB",
  "chat.create_character_multi_images_upload_fail_size_toast": "ขนาดไฟล์เกินกำหนด อัปโหลดรูป {{int_numbers}} รูปไม่สำเร็จ",
  "chat.create_character_multi_images_upload_fail_toast": "อัปโหลดรูป {{int_numbers}} รูปไม่สำเร็จ",
  "chat.create_character_multi_images_upload_fail_size": "• ขนาดไฟล์เกินกำหนด",
  "chat.create_character_multi_images_upload_fail_format": "• รูปแบบไฟล์ที่ไม่รองรับ",
  "chat.create_character_multi_images_upload_fail_limit": "• จำนวนอัปโหลดเกินกำหนด",
  "chat.create_character_multi_images_upload_limit_toast": "สามารถอัปโหลดรูปภาพได้สูงสุด {{int_numbers}} รูปต่อครั้ง",
  "chat.create_character_multi_images_uploading": "กำลังอัปโหลดรูปภาพ…",
  "chat.create_character_multi_images_bulk_edit_modal_title": "แก้ไขแบบกลุ่ม",
  "chat.create_character_multi_images_bulk_edit_modal_image_settings_title": "ตั้งค่ารูปภาพ",
  "chat.create_character_multi_images_bulk_edit_modal_privacy_settings_title": "ตั้งค่าความเป็นส่วนตัว",
  "chat.create_character_multi_images_bulk_edit_modal_bubble_unit_placeholder": "กรุณากรอกเป็นหน่วยหน่วยละ 100 บับเบิล",
  "chat.create_character_multi_images_bulk_edit_modal_description": "ไม่สามารถตั้งรูปหลักเป็นสาธารณะได้",
  "chat.create_character_multi_images_bulk_edit_modal_delete_alert_description": "รูปภาพที่ลบไปแล้วไม่สามารถกู้คืนได้",
  "chat.create_character_multi_images_bulk_edit_modal_selected": "เลือกแล้ว {{count}} รายการ",
  "chat.create_character_multi_images_bulk_edit_modal_select_all": "เลือกทั้งหมด",
  "chat.create_character_multi_images_bulk_edit_modal_deselect": "ล้างการเลือก",
  "chat.create_character_multi_images_bulk_edit_unable_to_set": "ไม่สามารถตั้งค่าได้",
  "chat.create_character_multi_images_upload_progress": "กำลังอัปโหลด {{int_current}}/{{int_total}} รูป",
  "chat.create_character_multi_images_upload_cancel": "ยกเลิก",
  "chat.create_character_multi_images_upload_cancel_confirm_title": "ต้องการยกเลิกการอัปโหลดไหม?",
  "chat.create_character_multi_images_upload_cancel_confirm": "รูปที่อัปโหลดเสร็จแล้วจะยังคงอยู่",
  "chat.create_character_multi_images_upload_failed_label": "อัปโหลดไม่สำเร็จ",
  "chat.create_character_multi_images_upload_retry": "ลองอีกครั้ง",
  "chat.create_character_multi_images_upload_retry_all": "ลองอัปโหลด {{int_numbers}} รูปที่ไม่สำเร็จอีกครั้ง",
  "chat.create_character_multi_images_upload_partial_toast": "เพิ่มได้เพียง {{int_numbers}} รูปตามช่องที่เหลือ",
  "chat.create_character_multi_images_upload_slot_full_toast": "ช่องเต็มแล้ว จึงเพิ่มอีก {{int_numbers}} รูปไม่ได้",
  "chat.create_character_multi_images_upload_in_progress_block": "บันทึกได้หลังจากอัปโหลดรูปเสร็จแล้ว",
  "chat.create_character_multi_images_error_nav_prev": "รูปที่ผิดพลาดก่อนหน้า",
  "chat.create_character_multi_images_error_nav_next": "รูปที่ผิดพลาดถัดไป",
  "chat.create_character_select_universe": "เลือกจักรวาล",
  "chat.create_character_select_universe_optional": "เลือก",
  "chat.create_character_select_universe_add": "เพิ่มจักรวาล",
  "chat.create_character_select_universe_create": "สร้างจักรวาล",
  "chat.create_character_select_universe_change": "เปลี่ยนจักรวาล",
  "chat.create_character_select_scene": "เลือกฉาก",
  "chat.create_character_select_scene_optional": "เลือก",
  "chat.create_character_select_scene_add": "เพิ่มฉาก",
  "chat.create_character_select_scene_create": "สร้างฉาก",
  "chat.create_character_select_scene_change": "เปลี่ยนฉาก",
  "chat.create_character_first_sentence": "คำพูดแรก",
  "chat.create_character_first_sentence_optional": "เลือก",
  "chat.create_character_first_sentence_description": "นี่คือคำพูดแรกที่ตัวละครจะใช้เมื่อเริ่มการสนทนา",
  "chat.create_character_create_character": "สร้างตัวละคร",
  "chat.create_character_link_only": "ลิงก์",
  "chat.create_character_link_only_help_text": "ลิงก์ตัวละครนี้ไม่สามารถแก้ไขเป็นสาธารณะหรือส่วนตัวได้",
  "chat.create_character_link_only_description": "เฉพาะผู้ใช้ที่มีลิงก์เท่านั้นที่เข้าใช้ได้",
  "chat.create_character_link_only_copied": "คัดลอกลิงก์สำเร็จ",
  "chat.create_character_link_only_copied_failed": "คัดลอกลิงก์ไม่สำเร็จ",
  "chat.create_character_keyword_book_title": "คีย์เวิร์ดบุ๊ก",
  "chat.create_character_keyword_book_number": "คีย์เวิร์ดบุ๊ก {{int_numbers}}",
  "chat.create_character_keyword_book_keyword": "คีย์เวิร์ด",
  "chat.create_character_keyword_book_keyword_placeholder": "กด ENTER หลังจากใส่คีย์เวิร์ด (เช่น: ย้ายโรงเรียน)",
  "chat.create_character_keyword_book_keyword_description": "คุณสามารถใส่คีย์เวิร์ดได้ 5 อันต่อหนึ่งคีย์เวิร์ดบุ๊ก",
  "chat.create_character_keyword_book_max_toast": "คุณสามารถใส่คีย์เวิร์ดได้สูงสุด 5 อัน",
  "chat.create_character_keyword_book_keyword_alert": "กรุณากด ENTER หลังจากใส่คีย์เวิร์ด",
  "chat.create_character_keyword_book_content": "เนื้อหา",
  "chat.create_character_keyword_book_content_placeholder": "กรุณาใส่เนื้อหาที่จะแสดงเมื่อคีย์เวิร์ดนั้นได้ถูกกล่าวถึง<br/>(ตัวอย่าง: ซอจินอูย้ายโรงเรียนในช่วงมัธยมต้นเพราะเขามีส่วนเกี่ยวข้องกับเหตุการณ์การใช้ความรุนแรง)",
  "chat.create_character_keyword_book_content_alert": "กรุณาใส่เนื้อหา",
  "chat.create_character_keyword_book_add_keyword_book": "เพิ่มคีย์เวิร์ดบุ๊ก",
  "chat.create_character_keyword_book_incomplete_toast": "กรุณาระบุรายการในคีย์เวิร์ดบุ๊กให้ครบ",
  "chat.create_character_keyword_book_edit_modal_title": "ชื่อคีย์เวิร์ดบุ๊ก",
  "chat.create_character_keyword_book_edit_modal_cancel": "ยกเลิก",
  "chat.create_character_keyword_book_edit_modal_done": "แก้ไข",
  "chat.create_character_keyword_book_delete_modal_title": "คุณต้องการลบคีย์เวิร์ดบุ๊กใช่หรือไม่?",
  "chat.create_character_keyword_book_delete_modal_cancel": "ยกเลิก",
  "chat.create_character_keyword_book_delete_modal_delete": "ลบ",
  "chat.create_character_keyword_book_tooltip_title1": "คีย์เวิร์ดบุ๊กคืออะไร?",
  "chat.create_character_keyword_book_tooltip_description1": "คีย์เวิร์ดบุ๊กคือฟังก์ชันที่แสดงเนื้อหาที่เขียนไว้ล่วงหน้าเกี่ยวกับคีย์เวิร์ด เมื่อผู้ใช้กล่าวถึงคีย์เวิร์ดนั้นๆ ในระหว่างการสนทนา",
  "chat.create_character_keyword_book_tooltip_description2": "หากคีย์เวิร์ดไม่ตรงกันก็จะไม่สามารถแสดงเนื้อหาได้",
  "chat.create_character_keyword_book_tooltip_title2": "สิ่งที่ควรรู้!",
  "chat.create_character_keyword_book_tooltip_description3": "กรุณาลากคีย์เวิร์ดบุ๊กที่สำคัญไปอยู่ด้านบน",
  "chat.create_character_keyword_book_tooltip_description4": "หากใช้คีย์เวิร์ดเดียวกัน ในคีย์เวิร์ดบุ๊กหลายรายการ เมื่อมีการกล่าวถึงคีย์เวิร์ด ระบบจะใช้เฉพาะคีย์เวิร์ดบุ๊ก 10 รายการแรก เท่านั้น",
  "chat.create_character_keyword_book_tooltip_description5": "เมื่อผู้ใช้กล่าวถึงคีย์เวิร์ดหลายคำ คีย์เวิร์ดบุ๊กที่มีคีย์เวิร์ดที่ตรงกันมากที่สุดจะถูกแสดงก่อน",
  "chat.create_character_keyword_book_tooltip_description6": "คีย์เวิร์ดบุ๊กจะตระหนักได้ถึงข้อความของตัวละครและข้อความของยูเซอร์",
  "chat.create_universe_creation_guide": "โปรดอ่านคู่มือการสร้างจักรวาล!",
  "chat.create_universe_profile_img": "รูปปก",
  "chat.create_universe_basics_label": "ข้อมูลพื้นฐาน",
  "chat.create_universe_add_thumbnail_image_button": "เพิ่มรูปภาพ",
  "chat.create_universe_basics_name": "ชื่อ",
  "chat.create_universe_basics_name_placeholder1": "การคุยกับคนดังครั้งแรก",
  "chat.create_universe_basics_name_placeholder2": "เมืองวิทยาศาสตร์แห่งอนาคต",
  "chat.create_universe_basics_name_placeholder3": "การพบกันโดยบังเอิญ",
  "chat.create_universe_introduction": "แนะนำสั้นๆ",
  "chat.create_universe_introduction_help_text": "*ข้อมูลแนะนำไม่ส่งผลต่อการสนทนาของตัวละคร",
  "chat.create_universe_introduction_placeholder1": "ตัวละครที่ไม่คาดว่าจะมีปฏิสัมพันธ์เข้ามาชวนคุณสนทนา",
  "chat.create_universe_introduction_placeholder2": "อนาคตอันใกล้ที่วิทยาศาสตร์จะมีความก้าวหน้าอย่างน่าทึ่ง",
  "chat.create_universe_introduction_placeholder3": "คุณได้พบกับตัวละครที่สามารถจัดการผู้ร้ายจี้รถบัสได้อย่างง่ายดายโดยบังเอิญ",
  "chat.create_universe_tags_label": "แท็ก",
  "chat.create_universe_tags_description": "โปรดเลือกแท็กที่สอดคล้องกับจักรวาล",
  "chat.create_universe_tags_placeholder": "ค้นหาแท็ก",
  "chat.create_universe_sharing_options_label": "เปิดเผยหรือไม่",
  "chat.create_universe_sharing_options_private": "ไม่เปิดเผย",
  "chat.create_universe_sharing_options_private_description": "การใช้งานเป็นส่วนตัว",
  "chat.create_universe_sharing_options_public": "เปิดเผยเป็นสาธารณะ",
  "chat.create_universe_sharing_options_public_description": "ผู้ใช้อื่นสามารถใช้งานได้",
  "chat.create_universe_age_rating_label": "เรทอายุ",
  "chat.create_universe_age_rating_normal_mode": "โหมดทั่วไป",
  "chat.create_universe_age_verification": "จักรวาลโหมดตื่นเต้นสามารถสร้างได้หลังจากยืนยันอายุแล้วเท่านั้น",
  "chat.create_universe_age_rating_normal_mode_description": "ผู้ใช้ทุกคนสามารถใช้งานได้",
  "chat.create_universe_age_rating_nsfw_mode": "โหมดตื่นเต้น",
  "chat.create_universe_age_rating_nsfw_mode_description": "สำหรับผู้ใช้ที่บรรลุนิติภาวะแล้วเท่านั้น",
  "chat.create_universe_relationship_label": "ความสัมพันธ์ระหว่างฉันและตัวละคร",
  "chat.create_universe_relationship_label2": "ความสัมพันธ์",
  "chat.information_universe_relationship_toast_characters": "ระบุความสัมพันธ์ระหว่างคุณและตัวครโดยใช้ตัวอักษรไม่เกิน{{int_characters}}อักษร",
  "chat.create_universe_relationship_public": "ความสัมพันธ์เป็นสาธารณะ",
  "chat.create_universe_relationship_private": "รายละเอียดที่ไม่เปิดเผย",
  "chat.create_universe_relationship_character_button": "ตัวละคร",
  "chat.create_universe_relationship_user_button": "ฉัน",
  "chat.create_universe_relationship_placeholder": "โปรดอธิบายความสัมพันธ์ระหว่างตัวละครและ 'ฉัน' <br/>ไม่ต้องระบุถึงบุคลิกหรือนิสัยของตัวละคร <br/><br/>เช่น)<br/>ตัวละครและฉันอาศัยอยุ่ร่วมกัน <br/>ตัวละครเป็นคู่แข่งกับฉัน <br/>ตัวละครกำลังจีบฉันอยู่",
  "chat.create_universe_details_label": "รายละเอียดเพิ่มเติม",
  "chat.create_universe_details_public": "รายละเอียดเป็นสาธารณะ",
  "chat.create_universe_details_private": "รายละเอียดที่ไม่เปิดเผย",
  "chat.create_universe_details_character_button": "ตัวละคร",
  "chat.create_universe_details_user_button": "ฉัน",
  "chat.create_universe_create_universe": "สร้างจักรวาล",
  "chat.create_universe_lorebook_label": "ข้อมูลเนื้อเรื่อง",
  "chat.create_universe_lorebook_description1": "ตีความสิ่งที่คุณระบุมาเพื่ออ้างอิงและสะท้อนให้เห็นตามบริบทอย่างเป็นธรรมชาติในระหว่างการแชต",
  "chat.create_universe_lorebook_title": "ชื่อ",
  "chat.create_universe_lorebook_title_placeholder": "ชุดรวมข้อมูลโลกแฟนตาซีต่างโลก เวอร์ชัน 0.1.0",
  "chat.create_universe_lorebook_content": "เนื้อหา",
  "chat.create_universe_lorebook_content_placeholder": "โลกใบนี้ถูกสร้างขึ้นโดยมี ‘เวลลาโนเต’ ซึ่งเป็นจุดตัดของมิติทั้ง 7 เป็นศูนย์กลาง แต่ละมิติมีกฎของเวลา กฎฟิสิกส์ และรูปร่างของสิ่งมีชีวิตที่แตกต่างกันอย่างสิ้นเชิง<br/>ในเวลลาโนเตเหล่าผู้คนและสิ่งมีชีวิตจากมิติต่าง ๆ ที่แปลกแยกกันจะมาหลอมรวมและใช้ชีวิตอยู่ร่วมกัน",
  "chat.create_universe_lorebook_description2": "ไม่ว่าจะเป็นการเพิ่ม, การเปลี่ยนแปลงและการลบข้อมูลเนื้อเรื่อง ล้วนส่งผลต่อห้องแชตที่กำลังใช้งานอยู่",
  "chat.create_universe_lorebook_description3": "ชื่อของข้อมูลเนื้อเรื่องไม่มีผลต่อการใช้งานจักรวาล",
  "chat.create_universe_lorebook_incomplete_title_alert": "กรุณาใส่ชื่อ",
  "chat.create_universe_lorebook_incomplete_content_alert": "กรุณาใส่เนื้อหา",
  "chat.create_universe_lorebook_incomplete_toast": "กรุณาใส่ข้อมูลเนื้อเรื่องให้ครบถ้วน",
  "chat.create_scene_creation_guide": "โปรดอ่านคู่มือการสร้างฉาก!",
  "chat.create_scene_basics_label": "ข้อมูลพื้นฐาน",
  "chat.create_scene_add_thumbnail_image_button": "เพิ่มรูปภาพ",
  "chat.create_scene_basics_name": "ชื่อ",
  "chat.create_scene_basics_name_placeholder1": "คนที่นั่งข้างฉันคือคนดัง",
  "chat.create_scene_basics_name_placeholder2": "การเข้าเยี่ยมในโรงพยาบาล",
  "chat.create_scene_basics_name_placeholder3": "รถบัสที่ถูกจี้",
  "chat.create_scene_introduction_placeholder1": "เวลา 9:00 น. มองสบตากับตัวละครที่นั่งอยู่แถวหน้าห้องเรียน",
  "chat.create_scene_introduction_placeholder2": "เวลา 14:00 น. ตัวละครมาเยี่ยมไข้",
  "chat.create_scene_introduction_placeholder3": "เลิกงานดึก รถบัสถูกจี้ทั้งคัน",
  "chat.create_scene_introduction_help_text": "ข้อความแนะนำตัวไม่ได้มีผลต่อการทำงานของฉาก",
  "chat.create_scene_tags_label": "แท็ก",
  "chat.create_scene_tags_description": "โปรดเลือกแท็กที่สอดคล้องกับฉาก",
  "chat.create_scene_tags_placeholder": "ค้นหาแท็ก",
  "chat.create_scene_sharing_options_label": "เปิดเผยหรือไม่",
  "chat.create_scene_sharing_options_private": "ไม่เปิดเผย",
  "chat.create_scene_sharing_options_private_description": "การใช้งานเป็นส่วนตัว",
  "chat.create_scene_sharing_options_public": "เปิดเผยเป็นสาธารณะ",
  "chat.create_scene_sharing_options_public_description": "ผู้ใช้อื่นสามารถใช้งานได้",
  "chat.create_scene_age_rating_label": "เรทอายุ",
  "chat.create_scene_age_rating_normal_mode": "โหมดทั่วไป",
  "chat.create_scene_age_verification": "ฉากโหมดตื่นเต้นสามารถสร้างได้หลังจากยืนยันอายุแล้วเท่านั้น",
  "chat.create_scene_age_rating_normal_mode_description": "ผู้ใช้ทุกคนสามารถใช้งานได้",
  "chat.create_scene_age_rating_nsfw_mode": "โหมดตื่นเต้น",
  "chat.create_scene_age_rating_nsfw_mode_description": "สำหรับผู้ใช้ที่บรรลุนิติภาวะแล้วเท่านั้น",
  "chat.create_scene_time": "เวลา",
  "chat.create_scene_place": "สถานที่",
  "chat.create_scene_place_placeholder1": "ห้องเรียน",
  "chat.create_scene_place_placeholder2": "ห้องผู้ป่วยในโรงพยาบาลบับเบิล",
  "chat.create_scene_place_placeholder3": "ในรถบัส",
  "chat.create_scene_time_placeholder1": "9 โมงเช้า",
  "chat.create_scene_time_placeholder2": "วันเสาร์, บ่าย 2 โมง ",
  "chat.create_scene_time_placeholder3": "เวลาเลิกงาน",
  "chat.create_scene_optional": "เลือก",
  "chat.create_scene_details_label": "รายละเอียดเพิ่มเติม",
  "chat.create_scene_details_public": "รายละเอียดเป็นสาธารณะ",
  "chat.create_scene_details_private": "รายละเอียดที่ไม่เปิดเผย",
  "chat.create_scene_details_character_button": "ตัวละคร",
  "chat.create_scene_details_user_button": "ฉัน",
  "chat.create_scene_details_placeholder": "โปรดอธิบายฉากเริ่มต้นของการสนทนา <br/> ยิ่งใส่รายละเอียดมากเท่าไรบทสนทนาก็จะยิ่งหน้าสนใจมากขึ้นเท่านั้น! <br/><br/>เช่น)<br/> ตัวละครมาปลุกฉันให้ตื่น <br/> ตัวละครมาเยี่ยมฉันที่โรงพยาบาล",
  "chat.create_scene_create_universe": "สร้างฉาก",
  "chat.create_persona_title": "สร้างตัวตน",
  "chat.create_persona_placeholder1": "อีฮวาน, วัย 17, ชาย, นักเรียนมัธยมปลาย, ไอดอล, ใจดี, อบอุ่น, สดใส, ความสนใจ: ซ้อมร้องเพลง, กังวลเกี่ยวกับคอนเสิร์ตที่จะมาถึง",
  "chat.create_persona_placeholder2": "คิมอูบิน, วัย 20, ชาย, เป็นเฟรชชีปี 1 ของมหาวิทยาลัยบับเบิล, ระมัดระวัง, ขี้อาย, เอาใจใส่, โหยหาความรัก, ความสนใจ: อ่านหนังสือ, เข้ายิม, เดต, ความรัก",
  "chat.create_persona_placeholder3": "จองฮานา, วัย 18, หญิง, แม่บ้าน, สุภาพ, เข้มงวด, บางครั้งก็ทำอะไรเกิดคาดเดา, ความสนใจ: ดอกไฮเดรนเยีย, งานบ้าน, ไก่ทอด",
  "chat.create_persona_create_failed": "สร้างตัวตนไม่สำเร็จ โปรดลองใหม่อีกครั้ง",
  "chat.create_persona_done": "สำเร็จ",
  "chat.create_persona_create": "สร้างเอง",
  "chat.create_persona_add_image": "เพิ่มรูปภาพ",
  "chat.create_persona_optional": "เลือก",
  "chat.create_persona_name_label": "ชื่อ",
  "chat.create_persona_name_placeholder": "อีฮวาน",
  "chat.create_persona_name_help_text": "*ห้ามสร้างตัวตนที่ละเมิดทรัพย์สินทางปัญญาของผู้อื่น โปรดตรวจสอบนโยบายการดำเนินงานสำหรับข้อมูลเพิ่มเติม",
  "chat.create_persona_gender_label": "เพศ",
  "chat.create_persona_gender_male": "ชาย",
  "chat.create_persona_gender_female": "หญิง",
  "chat.create_persona_gender_other": "อื่นๆ",
  "chat.create_persona_age_label": "อายุ",
  "chat.create_persona_job_label": "อาชีพ",
  "chat.create_persona_job_placeholder": "นักเรียนมัธยมปลาย, ไอดอล",
  "chat.create_persona_character": "นิสัย",
  "chat.create_persona_personality_placeholder": "ใจดี, อบอุ่น, สดใส",
  "chat.create_persona_interests_label": "ความสนใจ",
  "chat.create_persona_interests_placeholder": "ซ้อมร้องเพลง, กังวลเกี่ยวกับคอนเสิร์ตที่จะมาถึง",
  "chat.create_persona_import": "สร้างจากตัวละคร",
  "chat.create_persona_search": "โปรดระบุคำค้นหา",
  "chat.create_persona_select_tags_button": "เลือกแท็ก",
  "chat.create_persona_select_tags_modal_title": "เลือกแท็ก",
  "chat.create_persona_select_tags_modal_search": "ค้นหาแท็ก",
  "chat.create_persona_select_tags_modal_trending_tags": "แท็กที่กำลังนิยม",
  "chat.create_persona_select_tags_modal_selected_tags": "แท็กที่เลือก",
  "chat.create_persona_select_tags_modal_reset_button": "รีเซ็ต",
  "chat.create_persona_select_tags_modal_apply_tags_button": "ใช้แท็ก",
  "chat.create_persona_select_tags_button_selected": "เลือก {{int_tagNumbers}} แท็ก",
  "chat.create_persona_chat_list_relevancy": "ที่เกี่ยวข้อง",
  "chat.create_persona_chat_list_order_recent": "ล่าสุด",
  "chat.create_persona_chat_list_order_liked": "ถูกใจมากที่สุด",
  "chat.create_persona_chat_list_order_played": "เล่นมากที่สุด",
  "chat.create_persona_create_toast": "สร้างตัวตนสำเร็จ",
  "chat.create_persona_age_limit": "อายุต้องไม่เกิน 1พันล้านปีและไม่ต่ำกว่า -1พันล้านปี",
  "chat.create_add_multiple_images_toast": "คุณสามารถเพิ่มรูปภาพได้หลายภาพหลังจากเติมสลอตจนเต็ม ",
  "chat.create_tags_characters_toast": "กรุณาป้อนแท็กไม่เกิน {{int_characters}} ตัวอักษร",
  "chat.modify_change_thumbnail_image_button": "เปลี่ยนรูปภาพ",
  "chat.modify_persona": "แก้ไขตัวตน",
  "chat.modify_persona_failed": "แก้ไขตัวตนไม่สำเร็จ โปรดลองใหม่อีกครั้ง",
  "chat.modify_character_modify_fail_message": "แก้ไขตัวละครไม่สำเร็จ <br/>โปรดลองใหม่อีกครั้ง",
  "chat.modify_universe_modify_fail_message": "แก้ไขจักรวาลไม่สำเร็จ <br/>โปรดลองใหม่อีกครั้ง",
  "chat.modify_scene_modify_fail_message": "แก้ไขฉากไม่สำเร็จ <br/>โปรดลองใหม่อีกครั้ง",
  "chat.general_connect_fail_message": "ไม่สามารถเชื่อมต่อกับการบริการได้ กรุณารีเฟรชหรือลองใหม่อีกครั้ง",
  "chat.modify_character_header": "บันทึกตัวละคร",
  "chat.modify_universe_header": "บันทึกจักรวาล",
  "chat.modify_scene_header": "บันทึกฉาก",
  "chat.modify_character_modify_save": "บันทึกตัวละคร",
  "chat.modify_universe_modify_save": "บันทึกจักรวาล",
  "chat.modify_scene_modify_save": "บันทึกฉาก",
  "chat.modify_modal_unsaved_changes_title": "มีการแก้ไขที่ยังไม่ถูกบันทึก",
  "chat.modify_modal_excluded_character_universe": "หากคุณตั้งค่าเป็นส่วนตัวจักรวาลนี้จะถูกแยกออกจากตัวละครทุกตัวที่คุณตั้งค่าไว้<br/>คุณยังคงต้องการแก้ไขหรือไม่",
  "chat.modify_modal_excluded_character_scene": "หากคุณตั้งค่าเป็นส่วนตัวฉากนี้จะถูกแยกออกจากตัวละครทุกตัวที่คุณตั้งค่าไว้<br/>คุณยังคงต้องการแก้ไขหรือไม่",
  "chat.modify_toast_blocked_universe": "จักรวาลที่ถูกปิดกั้นไม่สามารถแก้ไขกลับมาเป็นสาธารณะได้",
  "chat.modify_toast_blocked_scene": "ฉากที่ถูกปิดกั้นไม่สามารถแก้ไขกลับมาเป็นสาธารณะได้",
  "chat.modify_toast_created_only_character": "คุณสามารถแก้ไขได้เฉพาะตัวละครที่คุณสร้างเท่านั้น",
  "chat.modify_toast_created_only_universe": "คุณสามารถแก้ไขได้เฉพาะจักรวาลที่คุณสร้างเท่านั้น",
  "chat.modify_toast_created_only_scene": "คุณสามารถแก้ไขได้เฉพาะฉากที่คุณสร้างเท่านั้น",
  "chat.modify_toast_nsfw_character": "อายุของตัวละครโหมดตื่นเต้นไม่สามารถแก้ไขให้ต่ำกว่า 19 ปีได้",
  "chat.modify_modal_unsaved_changes_description": "ข้อมูลที่คุณสร้างยังไม่ถูกบันทึก ต้องการออกจากหน้านี้หรือไม่?",
  "chat.modify_modal_unsaved_changes_cancel_button": "ยกเลิก",
  "chat.modify_modal_unsaved_changes_leave_button": "ออก",
  "chat.modify_no_change_private_character": "ตัวละครถูกตั้งค่าให้เป็นส่วนตัวไม่สามารถแก้ไขเป็นสาธารณะได้",
  "chat.modify_persona_deleted": "ลบตัวตนสำเร็จ",
  "chat.modify_persona_deleted_failed": "ลบตัวตนไม่สำเร็จ",
  "chat.search_title": "คุณกำลังมองหาอะไรอยู่?",
  "chat.search_search_description_characters": "ค้นหาตัวละคร",
  "chat.search_search_description_universes": "ค้นหาจักรวาล",
  "chat.search_search_description_scenes": "ค้นหาฉาก",
  "chat.search_search_toggle_menu_characters": "ตัวละคร",
  "chat.search_search_toggle_menu_universes": "จักรวาล",
  "chat.search_search_toggle_menu_scenes": "ฉาก",
  "chat.search_search_modal_recent_searches": "ค้นหาล่าสุด",
  "chat.search_search_modal_delete_all": "ลบทั้งหมด",
  "chat.search_select_tags_button": "ลบแท็ก",
  "chat.search_select_tags_modal_title": "ลบแท็ก",
  "chat.search_select_tags_modal_search": "ค้นหาแท็ก",
  "chat.search_select_tags_modal_trending_tags": "แท็กที่กำลังนิยม",
  "chat.search_select_tags_modal_selected_tags": "แท็กที่เลือก",
  "chat.search_select_tags_modal_reset_button": "รีเซ็ต",
  "chat.search_select_tags_modal_apply_tags_button": "ใช้แท็ก",
  "chat.search_select_tags_button_selected": "เลือก {{int_tagNumbers}} แท็ก",
  "chat.search_nsfw_toggle": "โหมดตื่นเต้น",
  "chat.search_chat_list_relevancy": "ที่เกี่ยวข้อง",
  "chat.search_chat_list_order_recent": "ล่าสุด",
  "chat.search_chat_list_order_liked": "ถูกใจมากที่สุด",
  "chat.search_chat_list_order_played": "เล่นมากที่สุด",
  "chat.search_no_results": "ไม่พบผลการค้นหา",
  "chat.search_search_description_writername": "ค้นหาชื่อเล่น",
  "chat.search_search_toggle_menu_writername": "ชื่อเล่น",
  "chat.rewards_revenue_information": "ข้อมูลรายได้",
  "chat.rewards_revenue_information_total_revenue": "รายได้ทั้งหมด",
  "chat.rewards_revenue_information_total_withdrawals": "ยอดถอนสะสม",
  "chat.rewards_revenue_information_last months_withdrawal": "รายได้เดือนที่ผ่านมา",
  "chat.rewards_revenue_information_withdrawable_revenue": "รายได้ที่สามารถถอนออกได้",
  "chat.rewards_revenue_information_withdrawable_revenue_help_text": "นี่คือตัวเลขที่คำนวนจากกำไรสุทธิตามอัตราส่วนของส่วนแบ่งผลกำไร <br/>จะอัปเดตทุกวันที่ 15 ของเดือน",
  "chat.rewards_revenue_information_profit_sharing_rate": "อัตราส่วนแบ่งผลกำไร",
  "chat.rewards_revenue_information_request_a_withdrawal": "ขอถอนรายได้",
  "chat.rewards_revenue_converted_amount_help_text": "หากมีการแปลงสกุลเงินแล้ว ยอดที่หักไปจะไม่สามารถขอยกเลิกได้",
  "chat.rewards_creator_information": "ข้อมูลครีเอเตอร์",
  "chat.rewards_creator_information_username": "ยูเซอร์โคด",
  "chat.rewards_creator_information_identity_verification": "ยืนยันตัวตน",
  "chat.rewards_creator_information_completed_button": "ยืนยันสำเร็จ",
  "chat.rewards_creator_information_email": "อีเมล",
  "chat.rewards_creator_information_edit": "แก้ไข",
  "chat.rewards_creator_information_account_verification": "ยืนยันบัญชี",
  "chat.rewards_creator_information_verify": "ยืนยัน",
  "chat.rewards_tracking_revenue": "ติดตามรายได้",
  "chat.rewards_tracking_revenue_total": "ทั้งหมด",
  "chat.rewards_tracking_revenue_characters": "ตัวละคร",
  "chat.rewards_tracking_revenue_universes": "จักรวาล",
  "chat.rewards_tracking_revenue_scenes": "ฉาก",
  "chat.rewards_tracking_revenue_day_button": "รายวัน",
  "chat.rewards_tracking_revenue_week_button": "รายสัปดาห์",
  "chat.rewards_tracking_revenue_month_button": "รายเดือน",
  "chat.rewards_monthly_sales": "ยอดขายประจำเดือน {{int_month}}",
  "chat.rewards_monthly_sales_my_assets": "แอสเซต",
  "chat.rewards_monthly_sales_total": "ทั้งหมด",
  "chat.rewards_monthly_sales_characters_button": "ตัวละคร",
  "chat.rewards_monthly_sales_universes_button": "จักรวาล",
  "chat.rewards_monthly_sales_scenes_button": "ฉาก",
  "chat.home_require_alert_login_age_verification_character": "ตัวละครนี้ผู้ใช้ต้องล็อกอินและยืนยันอายุ",
  "chat.home_require_alert_login_age_verification_universe": "จักรวาลนี้ผู้ใช้ต้องล็อกอินและยืนยันอายุ",
  "chat.home_require_alert_login_age_verification_scene": "ฉากนี้ผู้ใช้ต้องล็อกอินและยืนยันอายุ",
  "chat.home_require_alert_age_verification_character": "ตัวละครนี้ผู้ใช้ต้องยืนยันอายุ",
  "chat.home_require_alert_age_verification_universe": "จักรวาลนี้ผู้ใช้ต้องยืนยันอายุ",
  "chat.home_require_alert_age_verification_scene": "ฉากนี้ผู้ใช้ต้องยืนยันอายุ",
  "chat.modify_modal_select_public_description": "จักรวาล/ฉากที่คุณเลือกถูกตั้งค่าเป็นส่วนตัวคุณไม่สามารถแก้ไขตัวละครเป็นสาธารณะได้<br/> โปรดเลือกจักรวาล/ฉากที่เป็นสาธารณะ",
  "chat.rewards_convert_bubbles_button": "การแปลงค่าบับเบิล",
  "chat.rewards_convert_bubbles_modal_title": "การแปลงค่าบับเบิล",
  "chat.rewards_convertible_bubbles": "บับเบิลที่สามารถแปลงค่าได้",
  "chat.rewards_bubbles_to_convert": "บับเบิลที่ยื่นขอแปลงค่า",
  "chat.rewards_convert_bubbles_description_calculated": "*บับเบิลที่สามารถแปลงได้จะมีมูลค่าที่คำนวณหลังจากหักภาษีแล้ว 3.3% จากรายได้ที่เบิกถอน",
  "chat.rewards_convert_bubbles_description_refund": "บับเบิลที่ถูกแปลงค่าและหักออกแล้วจะไม่สามารถยกเลิกคำขอหรือขอคืนได้",
  "chat.rewards_convert_bubbles_description_units": "การแปลงค่าบับเบิล สามารถแปลงได้โดยมีหลัก1,000 หน่วยบับเบิลและจะทำการหักออกทันทีหลังจากยื่นคำขอ",
  "chat.rewards_convert_bubbles_alert_units": "การแปลงค่าสามารถทำได้โดยมีหลัก 1,000 หน่วยบับเบิล",
  "chat.rewards_convert_bubbles_alert_limit": "การแปลงค่าสามารถทำได้สูงสุด 1.5 ล้านบับเบิลต่อครั้ง",
  "chat.rewards_notification_profit_application": "บันทึกการรับ-ถอนรายได้",
  "chat.rewards_notification_subtitle_first": "สวัสดีเหล่าครีเอเตอร์ เราคือบับเบิลแชต",
  "chat.rewards_notification_subtitle_second": "เราจะแจ้งผลการถอนรายได้ให้ทราบภายหลัง",
  "chat.rewards_notification_profit_application_description": "คุณได้รับการถอนรายได้ตามที่แสดงด้านล่าง",
  "chat.rewards_notification_request_amount": "จำนวนเงินที่ยื่นคำขอ",
  "chat.rewards_notification_request_date": "วันยื่นคำขอเบิกถอน",
  "chat.rewards_notification_withdrawal_date": "ถอนวันที่ (โดยประมาณ)",
  "chat.rewards_notification_status": "สถานะ",
  "chat.rewards_notification_pending": "รอ",
  "chat.rewards_notification_completed": "สำเร็จ",
  "chat.rewards_notification_rejected": "ปฏิเสธ",
  "chat.rewards_notification_hold": "เลื่อน",
  "chat.rewards_notification_deposit_amount": "จำนวนเงินฝาก",
  "chat.rewards_notification_note": "หมายถึง",
  "chat.rewards_notification_deposit_tax": "จำนวนเงินฝากคือจำนวนเงินหลังจากการหักรายได้จากธุรกิจ (3.3%) ",
  "chat.rewards_notification_contact_us": "หากคุณมีคำถามเพิ่มเติมเกี่ยวกับข้อมูลนี้ โปรดติดต่อเราเพื่อสอบถามเพิ่มเติมแบบตัวต่อตัวผ่านฝ่ายบริการลูกค้า ขอบคุณ",
  "chat.rewards_notification_profit_completion": "บันทึกการถอนรายได้ที่สำเร็จ",
  "chat.rewards_notification_profit_completion_description": "คุณถอนรายได้สำเร็จตามที่แสดงด้านล่าง",
  "chat.rewards_notification_profit_reject": "บันทึกการปฏิเสธการถอนรายได้",
  "chat.rewards_notification_profit_reject_description": "ขออภัยแต่การยื่นคำขอเบิกถอนนี้ถูกปฏิเสธ",
  "chat.rewards_notification_profit_reject_reasons": "การถอนเงินถูกปฏิเสธด้วยเหตุผลตามที่แสดงด้านล่าง",
  "chat.rewards_notification_profit_reject_reasons_copyright": "กรณีที่ตัวละคร/จักรวาล/ฉาก มีการละเมิดลิขสิทธิ์",
  "chat.rewards_notification_profit_reject_reasons_policy": "กรณีที่มีการละเมิดนโยบายใดๆ ของบับเบิลแชต",
  "chat.rewards_notification_profit_reject_amount": "จำนวนเงินที่ถูกปฏิเสธมีจำนวน{{int_amount}} วอน",
  "chat.rewards_notification_profit_reject_amount_description": "จำนวนเงินจะแสดงให้เห็นอีกครั้งในยอดที่สามารถถอนออกได้ คุณสามารถยื่นคำขอเบิกถอนได้อีกครั้งหลังจากปัญหาถูกแก้ไขแล้ว",
  "chat.rewards_notification_profit_hold": "บันทึกการเลื่อนถอนรายได้",
  "chat.rewards_notification_profit_hold_description": "ขออภัยแต่การยื่นคำขอเบิกถอนนี้ถูกเลื่อน",
  "chat.rewards_notification_profit_hold_reasons": "การถอนเงินถูกเลื่อนดำเนินการด้วยเหตุผลตามที่แสดงด้านล่าง",
  "chat.rewards_notification_profit_hold_amount": "จำนวนเงินที่ถููกเลื่อนดำเนินการมีจำนวน{{int_amount}} วอน",
  "chat.rewards_notification_conversion_completion": "บันทึกการแปลงค่าบับเบิลที่สำเร็จ",
  "chat.rewards_notification_conversion_completion_description": "คุณแปลงค่าบับเบิลได้สำเร็จตามที่แสดงด้านล่าง",
  "chat.rewards_notification_conversion_amount": "จำนวนเงินการแปลงค่าบับเบิลที่ยื่นคำขอ",
  "chat.rewards_notification_conversion_date": "วันที่แปลงค่าบับเบิล",
  "chat.rewards_notification_conversion_number": "จำนวนบับเบิลที่จ่ายออกไป",
  "chat.rewards_notification_conversion_tax": "บับเบิลจะจ่ายหลังจากหักจากหักรายได้จากธุรกิจ (3.3%) จากจำนวนเงินที่ยื่นคำขอ",
  "chat.rewards_top_sales_monthly": "ยอดขายสูงสุดประจำเดือน {{int_month}} ",
  "chat.rewards_profit_sharing_terms": "ข้อกำหนดและเงื่อนไขการใช้งานสำหรับครีเอเตอร์",
  "chat.rewards_terms_of_service": "ข้อกำหนดการให้บริการ",
  "chat.rewards_privacy_policy": "นโยบายความเป็นส่วนตัว",
  "chat.rewards_operational_policy": "นโยบายการดำเนินงาน",
  "chat.rewards_juvenile_protection_policy": "นโยบายการคุ้มครองเยาวชน",
  "chat.rewards_verify_identify_email_account": "เพื่อเป็นการยืนยันบัญชีกรุณายืนยันตัวตนและยืนยันอีเมลก่อนดำเนินการ",
  "charging_stn_free_modal_allow_web_tracking_title": "ยินยอมให้ติดตามเว็บไซต์",
  "charging_stn_free_modal_allow_web_tracking_description": "เพื่อการติดตามเว็บไซต์<br/>อนุญาตให้ใช้ตัวระบุโฆษณาด้วยหรือไม่?",
  "charging_stn_free_modal_allow_web_tracking_allow": "ยินยอม",
  "charging_stn_free_modal_allow_web_tracking_decline": "ปฏิเสธ",
  "chat.rewards_currency_krw": "(วอน)",
  "chat.rewards_confirmation_email": "ประวัติการแปลงค่าบับเบิลจะส่งไปให้ทางอีเมล",
  "chat.rewards_account_holder": "เจ้าของบัญชี",
  "chat.rewards_bank": "ธนาคาร",
  "chat.rewards_account_number": "เลขบัญชี",
  "chat.rewards_account_info_update": "แก้ไขข้อมูลบัญชี",
  "chat.rewards_legal_responsibility": "คุณยินยอมที่จะถูกดำเนินการทางกฎหมายหากคุณใช้ชื่อหรือข้อมูลส่วนบุคคลของผู้อื่น",
  "chat.rewards_real name_id": "กรุณาใส่ชื่อจริงที่แสดงตามบัตรประจำตัวประชาชนของคุณ",
  "chat.rewards_digit_number": "กรุณากรอกตัวเลข13หลักโดยไม่ต้องใส่ '-'",
  "chat.rewards_only_number": "กรุณากรอกตัวเลขโดยไม่ต้องใส่ '-'",
  "chat.rewards_account_holder_name_description": "ชื่อเจ้าของบัญชีต้องเป็นชื่อเดียวกับที่ใช้ลงทะเบียน",
  "chat.rewards_verify_button": "ตรวจสอบ",
  "chat.rewards_account_verification": "ตรวจสอบบัญชี",
  "chat.rewards_agree_personal_information": "ฉันยินยอมให้<link1> รวบรวมและใช้ข้อมูลส่วนบุคคลของฉัน </link1>",
  "chat.rewards_available_withdrawal_amount": "จำนวนเงินที่สามารถถอนได้",
  "chat.rewards_withdrawal_request_amount": "จำนวนเงินที่ต้องการเบิกถอน",
  "chat.rewards_withdrawal_amount_deduction": "*จำนวนเงินที่สามารถถอนได้คือตัวเลขที่ถูกหักภาษี 3.3% จากจำนวนเงินที่สามารถถอนได้เรียบร้อยแล้ว",
  "chat.rewards_withdrawal_increments": "ต้องถอนเงินในหลัก 10,000 วอนและจำนวนเงินจะถูกหักทันทีที่ทำการยื่นคำขอเบิกถอน",
  "chat.rewards_requests_made_date": "คำขอเบิกถอนที่ยื่นก่อนวันที่ 15 ของเดือนจะถูกดำเนินการภายในวันที่ 25 ของเดือนเดียวกัน, คำขอเบิกถอนที่ยื่นหลังวันที่ 15 ของเดือนจะถูกดำเนินการภายในวันที่ 25 ของเดือนถัดไป รวมถึงจะมีการส่งอีเมลยืนยันเมื่อโอนเงินเสร็จสมบูรณ์",
  "chat.rewards_withdrawal_request_cancel": "ยกเลิก",
  "chat.rewards_withdrawal_request_submit": "ส่ง",
  "chat.rewards_modal_reclaimed": "รายได้บางส่วนถูกเรียกคืนเนื่องจาก ตัวละคร/จักรวาล/ฉาก ถูกตั้งค่าเป็นส่วนตัว โปรดติดต่อสอบถามเราเพิ่มเติม<link1>ผ่านฝ่ายบริการลูกค้า</link1>",
  "chat.rewards_modal_reclaimed_button": "ตกลง",
  "chat.rewards_currency_bubbles_zero": "บับเบิล",
  "chat.rewards_currency_bubbles_one": "บับเบิล",
  "chat.rewards_currency_bubbles_other": "บับเบิล",
  "chat.rewards_withdrawal_title": "ยื่นขอเบิกถอน",
  "chat.rewards_withdrawal_currency_krw": "วอน",
  "chat.rewards_agree_legal_terms": "กรุณายอมรับข้อกำหนดและมีความรับผิดชอบต่อกฎหมาย",
  "chat.rewards_select_bank": "เลือกธนาคาร",
  "chat.rewards_correct_rrn": "กรุณาใส่เลขประจำตัวผู้เสียภาษี (เลขบัตรประชาชน)",
  "chat.rewards_consent_collect_personal_info": "กรุณายินยอมให้รวบรวมและใช้ข้อมูลส่วนบุคคลของคุณ",
  "chat.rewards_enter_bank_code": "กรุณากรอกหมายเลขบัญชี",
  "chat.rewards_bubble_conversion_verify_complete": "คุณสามารถยื่นคำขอแปลงบับเบิลได้หลังจาก ยืนยันตัวตน, ยืนยันอีเมล, ยืนยันบัญชีเป็นที่เรียบร้อยแล้ว",
  "chat.rewards_withdrawal_verify_complete": "คุณสามารถยื่นคำขอเบิกถอนหลังจาก ยืนยันตัวตน, ยืนยันอีเมล, ยืนยันบัญชีเป็นที่เรียบร้อยแล้ว",
  "chat.rewards_account_verification_help_text": "โปรดยืนยันตัวตนและที่อยู่อีเมลของคุณเพื่อทำการยืนยันบัญชี",
  "chat.rewards_modal_unsaved_content_title": "มีเนื้อหาที่ยังไม่ถูกบันทึก",
  "chat.rewards_modal_unsaved_content_description": "ข้อมูลทั้งหมดจะหายไป <br/> ยืนยันจะออกจากหน้านี้อยู่หรือไม่?",
  "chat.rewards_modal_unsaved_content_cancel": "ยกเลิก",
  "chat.rewards_modal_unsaved_content_back": "ออกจากหน้านี้",
  "chat.rewards_withdrawal_request_completed": "ยื่นขอเบิกถอนสำเร็จ",
  "chat.rewards_withdrawal_request_failed": "ยื่นขอเบิกถอนล้มเหลว",
  "chat.rewards_bubble_conversion_request_completed": "ยื่นขอแปลงบับเบิลสำเร็จ",
  "chat.rewards_bubble_conversion_request_failed": "ยื่นขอแปลงบับเบิลล้มเหลว",
  "chat.rewards_total_revenue_time_update_alert_title": "เปลี่ยนรอบระยะเวลาการอัปเดตรายได้สะสม",
  "chat.rewards_total_revenue_time_update_alert_description": "โปรดทราบ<br/><br/>เพื่อปรับปรุงระบบและให้การใช้งานเสถียรมากขึ้น ข้อมูลรายได้จะอัปเดตวันละ 1 ครั้ง ตามรอบเวลา 24 ชั่วโมง",
  "chat.rewards_total_revenue_time_update_alert_button1": "ไม่ต้องแสดงข้อมูลนี้อีก",
  "chat.rewards_total_revenue_time_update_alert_button2": "ตกลง",
  "chat.rewards_total_revenue_time_update_tooltip": "ยอดเงินจะอัปเดตวันละ 1 ครั้ง ตามรอบเวลา 24 ชั่วโมง",
  "chat.rewards_no_transferable_alert_title": "[9/26~9/30]<br/>ประกาศการระงับการแลกเปลี่ยนบับเบิลชั่วคราว",
  "chat.rewards_no_transferable_alert_description": "เพื่อให้การยื่นและการคำนวณภาษีเงินได้เป็นไปอย่างราบรื่นในต้นเดือนตุลาคม บริการแลกเปลี่ยน Bubble จะถูกระงับชั่วคราวตั้งแต่วันที่ 26 กันยายน เวลา 00:00 น. จนถึงวันที่ 30 กันยายน เวลา 23:59 น",
  "chat.rewards_no_transferable_alert_ok_button": "ตกลง",
  "chat.content_moderation_word_create_validation_message": "พบคำที่ไม่เหมาะสม {{string_words}}",
  "chat.content_moderation_word_create_failed_message": "พบคำที่ไม่เหมาะสม กรุณาแก้ไขแล้วลองใหม่อีกครั้ง",
  "chat.content_moderation_word_multi_image_error_message": "พบคำที่ไม่เหมาะสมในรูปภาพ {{int_imageNumbers}}",
  "chat.content_moderation_word_multi_image_validation_message": "พบคำที่ไม่เหมาะสม {{string_words}}",
  "chat.content_moderation_word_conversation_toast": "พบคำที่ไม่เหมาะสม {{string_words}}",
  "chat.content_moderation_word_create_failed_message_button": "ตกลง",
  "chat.content_moderation_word_keyword_book_error_message": "พบคำที่ไม่เหมาะสมในคีย์เวิร์ดบุ๊ก {{int_keywordbookNumbers}}",
  "chat.home_sidebar_support_center": "ฝ่ายบริการลูกค้า",
  "chat.support_center_top_title": "FAQ",
  "chat.support_center_unresolved_issues": "ยังมีปัญหาที่ไม่ได้รับการแก้ไขอยู่ใช่ไหม?",
  "chat.support_center_contact_button": "ติดต่อเรา",
  "chat.support_center_contact_history_button": "ประวัติการสอบถาม",
  "chat.support_center_contact_submit_alert": "รับคำร้องสำเร็จ",
  "chat.notification_contact_title": "ติดต่อเรา",
  "chat.notification_contact_reply": "เราได้ตอบกลับคำถามของคุณเรียบร้อยแล้ว หากไม่มีคำถามเพิ่มเติมภายใน 72 ชั่วโมง ระบบจะปิดการสอบถามนี้อัตโนมัติ",
  "chat.notification_contact_reply_additional_inquiry": "เราได้ตอบคำถามเพิ่มเติมของคุณเรียบร้อยแล้ว หากไม่มีคำถามเพิ่มเติมภายใน 72 ชั่วโมง ระบบจะปิดการสอบถามนี้อัตโนมัติ",
  "chat.support_center_contact_information_title": "ข้อมูลการติดต่อสอบถามแบบตัวต่อตัว",
  "chat.support_center_contact_information_description1": "ทางเราจะไล่ตอบกลับตามลำดับในวันทำการ เวลา 09:00~18:00 น.",
  "chat.support_center_contact_information_description2": "หากคุณมีคำถามเพิ่มเติมเกี่ยวกับข้อสงสัยเดิม กรุณาฝากคำถามผ่านช่องทาง 'สอบถามเพิ่มเติม'",
  "chat.support_center_contact_information_description3": "คำถามที่ชัดเจนและเฉพาะเจาะจงจะช่วยให้แนะนำข้อมูลได้ตรงจุดมากขึ้น",
  "chat.support_center_contact_information_description4": "คุณสามารถลงทะเบียนสอบถามเพิ่มเติมได้สูงสุด 4 ครั้ง และหากเป็นคำถามคนละประเภท กรุณาส่งเป็นคำถามใหม่",
  "chat.support_center_contact_category_title": "ประเภท",
  "chat.support_center_contact_category_placeholder": "เลือกประเภทคำถามที่ต้องการสอบถาม",
  "chat.support_center_contact_user_environment_title": "User Environment",
  "chat.support_center_contact_user_environment_app": "App",
  "chat.support_center_contact_user_environment_web": "Web",
  "chat.support_center_contact_user_environment_manual": "ใส่ข้อมูลด้วยตนเอง",
  "chat.support_center_contact_user_environment_placeholder": "กรุณาเลือก User Environment",
  "chat.support_center_contact_inquiry_title": "หัวข้อ",
  "chat.support_center_contact_inquiry_placeholder": "กรุณาใส่หัวข้อเรื่องที่ต้องการสอบถาม",
  "chat.support_center_contact_inquiry_detail": "เนื้อหาที่ต้องการสอบถาม",
  "chat.support_center_contact_inquiry_detail_placeholder": "สอบถามเรื่องที่ต้องการได้ตามสบายเลยค่ะ!",
  "chat.support_center_contact_add_image_optional": "แนบรูปภาพ (เลือก)",
  "chat.support_center_contact_add_image_format": "JPEG/PNG/WEBP/GIF",
  "chat.support_center_contact_add_image_size": "ขนาดสูงสุด 10MB",
  "chat.support_center_contact_input_category_alert": "กรุณาเลือกประเภท",
  "chat.support_center_contact_user_environment_input_alert": "กรุณาเลือก User Environment",
  "chat.support_center_contact_subject_title_input_alert": "กรุณาใส่หัวข้อ",
  "chat.support_center_contact_subject_detail_input_alert": "กรุณาใส่เนื้อหา",
  "chat.support_center_contact_status_inquiry_completed": "ลงทะเบียนสำเร็จ",
  "chat.support_center_contact_status_reply_completed": "ตอบกลับสำเร็จ",
  "chat.support_center_contact_status_reply_closed": "สิ้นสุดการสอบถาม",
  "chat.support_center_contact_view": "ดูรายละเอียด",
  "chat.support_center_contact_view_no_inquiry_history": "ไม่มีประวัติการสอบถาม",
  "chat.support_center_contact_view_success_inquiry_message": "คำถามของคุณลงทะเบียนสำเร็จแล้ว<br/>ขณะนี้กำลังตรวจสอบเนื้อหาที่คุณส่งมา และจะตอบกลับโดยเร็วที่สุด<br/>จะมีการตอบคำถามตามลำดับในวันทำการ เวลา 09:00–18:00 น.",
  "chat.support_center_contact_view_inquiry_delete_modal": "คุณต้องการยกเลิกการสอบถามหรือไม่?",
  "chat.support_center_contact_view_inquiry_delete_modal_description": "ข้อความที่คุณสอบถามไว้จะถูกลบ",
  "chat.support_center_contact_modify": "แก้ไขการสอบถาม",
  "chat.support_center_contact_unresolved_issue_alert_modal": "ปัญหาของคุณยังไม่ได้รับการแก้ไขใช่หรือไม่?",
  "chat.support_center_contact_unresolved_issue_alert_modal_description1": "หากคุณมีคำถามเพิ่มเติมสามารถสอบถามต่อได้เลย!",
  "chat.support_center_contact_unresolved_issue_alert_modal_description2": "คุณสามารถส่งคำถามเพิ่มเติมได้สูงสุด 4 ครั้ง! ",
  "chat.support_center_contact_unresolved_issue_alert_modal_description3": "หากเป็นคำถามประเภทอื่น กรุณาส่งคำถามใหม่เพื่อให้เราช่วยเหลือได้อย่างตรงจุด!",
  "chat.support_center_contact_unresolved_issue_alert_modal_button": "สอบถามเพิ่มเติม",
  "chat.support_center_contact_response_check_title": "คำตอบที่ได้รับมีประโยชน์สำหรับคุณหรือไม่?",
  "chat.support_center_contact_response_additional_inquiry_button": "สอบถามเพิ่มเติม",
  "chat.support_center_contact_response_closed_inquiry_button": "สิ้นสุดการสอบถาม",
  "chat.support_center_contact_previous_inquiry_title": "การสอบถามและการตอบกลับก่อนหน้า",
  "chat.support_center_contact_hide_button": "ย่อ",
  "chat.support_center_contact_see_more_button": "ดูเพิ่มเติม",
  "chat.support_center_contact_success_inquiry_closed_toast": "ปิดการสอบถามเรียบร้อย",
  "chat.support_center_contact_resolved_inquiry_message": "คำถามที่ได้รับการแก้ไขแล้ว",
  "chat.support_center_contact_fail_submit_toast": "ไม่สามารถลงทะเบียนคำถามได้ กรุณาลองใหม่อีกครั้ง",
  "chat.support_center_contact_fail_update_toast": "การแก้ไขคำถามล้มเหลว กรุณาลองใหม่อีกครั้ง",
  "chat.support_center_contact_fail_additional_submit_toast": "การลงทะเบียนคำถามเพิ่มเติมล้มเหลว คุณสามารถลงทะเบียนได้สูงสุด 4 ครั้งเท่านั้น",
  "chat.support_center_contact_fail_closed_toast": "การปิดการสอบถามล้มเหลว กรุณาลองใหม่อีกครั้ง",
  "chat.support_center_contact_fail_cancel_toast": "การยกเลิกการสอบถามล้มเหลว กรุณาลองใหม่อีกครั้ง",
  "chat.support_center_contact_user_environment_manual_placeholder": "กรุณากรอกสภาพแวดล้อมของผู้ใช้ด้วยตนเอง",
  "chat.support_center_contact_user_environment_manual_input_alert": "กรุณากรอกสภาพแวดล้อมของผู้ใช้ด้วยตนเอง",
  "chat.support_center_contact_cancel_success_toast": "การยกเลิกคำถามเสร็จสิ้นแล้ว",
  "chat.support_center_contact_inquiry_complete_success_toast": "คำถามของคุณสิ้นสุดลงเรียบร้อยแล้ว",
  "chat.support_center_contact_view_inquiry_support_team": "ฝ่ายบริการลูกค้า BubbleChat",
  "chat.support_center_contact_enter_title_input_alert": "กรุณากรอกหัวเรื่องไม่เกิน 50 ตัวอักษร",
  "chat.support_center_contact_view_inquiry_cancel_inquiry": "ยกเลิกคำถาม",
  "chat.support_center_contact_view_inquiry_attached_image": "รูปภาพที่แนบมา",
  "statistic_list_title": "สถิติ",
  "statistic_domestic": "ภายในประเทศ",
  "statistic_international": "ต่างประเทศ",
  "statistic_identity_verification_modal_title": "ท่านสามารถตรวจสอบสถิติได้หลังจากยืนยันตัวตน",
  "statistic_payment_history_rewards_button": "รางวัล",
  "statistic_period_record_title": "ในช่วง<span>{{string_time}} ที่ผ่านมา</span> {{string_name}} ได้พูดคุยกับ {{string_assets}} ไปทั้งหมด<span>'{{int_numbers}}'</span> แชตเลยนะ!",
  "statistic_all_record_title": "จำนวนบทสนทนาทั้งหมดระหว่าง {{string_name}} กับ {{string_assets}} คือ<span>' '{{int_numbers}}'</span>แชตเลยนะ! ",
  "statistic_help_information": "การนับข้อมูลจะอัปเดตทุกๆ 1 ชั่วโมง<br/>แอสเซตที่มีการแชตน้อยกว่า 100 ครั้งจะไม่ถูกนับรวม",
  "statistic_history_no_record": "จะแสดงเฉพาะ {{string_name}} ที่มีมากกว่า 100 แชทเท่านั้น",
  "manual_identity_verification": "ยืนยันตัวตน",
  "manual_identity_verification_notify1": "ข้าพเจ้ายินยอมให้มีการเก็บรวบรวมและใช้ข้อมูลส่วนบุคคล",
  "manual_identity_verification_notify2": "ข้าพเจ้ายินยอมรับผิดชอบตามกฎหมาย หากข้าพเจ้าแอบอ้างชื่อของบุคคลอื่น หรือใช้ข้อมูลส่วนบุคคลที่ไม่ใช่ของข้าพเจ้าเอง",
  "manual_identity_verification_id_card": "บัตรประจำตัวประชาชน",
  "manual_identity_verification_id_card_tooltip": "บัตรที่ใช้ยืนยันตัวตนต้องเป็นบัตรประชาชนที่ออกโดยรัฐบาลเท่านั้น",
  "manual_identity_verification_id_card_file_format": "JPEG/PNG/WEBP/GIF",
  "manual_identity_verification_id_card_file_size": "สูงสุดไม่เกิน 10MB",
  "manual_identity_verification_id_card_name_placeholder": "ชื่อ",
  "manual_identity_verification_id_card_name_guide_th": "โปรดใส่ชื่อเป็นภาษาไทยหรือภาษาอังกฤษ",
  "manual_identity_verification_id_card_number_placeholder": "หมายเลขประจำตัวประชาชน",
  "manual_identity_verification_id_card_address_placeholder": "ที่อยู่",
  "manual_identity_verification_id_card_address_guide": "หากที่อยู่ไม่ตรงกับที่อยู่ตามทะเบียนราษฎร์ อาจทำให้การยืนยันตัวตนล้มเหลวได้",
  "manual_identity_verification_id_card_email_placeholder": "อีเมล",
  "manual_identity_verification_id_card_birthdate_placeholder": "วันเดือนปีเกิด",
  "manual_identity_verification_submit_button": "ส่งลงทะเบียน",
  "manual_identity_verification_request_complete_title_modal": "ยืนยันตัวตนสำเร็จ",
  "manual_identity_verification_request_complete_description_modal": "ข้อมูลที่คุณส่งมาจะได้รับการตรวจสอบและดำเนินการ<br/>ภายใน 3 วันทำการ",
  "manual_identity_verification_ok_button": "ตกลง",
  "manual_identity_verification_pending_title_modal": "ระบบกำลังตรวจสอบการยืนยันตัวตน",
  "manual_identity_verification_pending_description_modal": "ทางเราได้รับข้อมูลของคุณเรียบร้อยแล้ว<br/>ระบบจะดำเนินการหลังทำการตรวจสอบภายใน 3 วัน ",
  "manual_identity_verification_verifying_description": "คุณได้ใช้ชื่อนี้ในการยืนยันตัวตนแล้ว",
  "manual_identity_verification_complete_title_modal": "ยืนยันตัวตนสำเร็จ",
  "manual_identity_verification_complete_description_modal": "การยืนยันตัวตนสำเร็จ<br/>เมื่อวันที่{{string_date}}",
  "manual_identity_verification_waiting_menu": "Waiting",
  "web_tracking_consent_alert_modal_title": "ยินยอมให้ติดตามเว็บ",
  "web_tracking_consent_alert_modal_description": "คุณอนุญาตให้ใช้รหัสโฆษณาเพื่อ<br/>การติดตามหรือไม่?",
  "web_tracking_consent_alert_modal_decline_button": "ปฏิเสธ",
  "web_tracking_consent_alert_modal_allow_button": "ยอมรับ",
  "chat.contest_page_submit_button": "ส่งตัวละครเข้าประกวด",
  "chat.contest_modal_title": "ส่งผลงานประกวด",
  "chat.contest_modal_description": "แสดงเฉพาะตัวละครที่ตรงตามเงื่อนไขการสมัครเท่านั้น",
  "chat.contest_modal_tooltip_title": "เงื่อนไขการเข้าร่วมกิจกรรม",
  "chat.contest_modal_tooltip_description1": "ตัวละครที่เปิดเผยครั้งแรกหลังวันที่ {{int_day}} เดือน {{int_month}} ปี {{int_year}} เวลา {{int_hour}} นาฬิกา {{int_minute}} นาที",
  "chat.contest_modal_tooltip_description2": "ตัวละครที่มีรูปภาพตั้งแต่ {{int_number}} รูปขึ้นไป",
  "chat.contest_modal_submitted_character": "ส่งเรียบร้อยแล้ว",
  "chat.contest_modal_character_empty": "ไม่มีตัวละครที่ตรงตามเงื่อนไข",
  "chat.contest_modal_production_grant_title": "สมัครรับเงินสนับสนุนการสร้างตัวละคร",
  "chat.contest_modal_production_grant_description1": "สามารถสมัครได้เมื่อส่งตัวละคร {{int_number}} ตัวขึ้นไป",
  "chat.contest_modal_production_grant_description2": "เมื่อส่งตัวละครจะถือว่าท่านยอมรับเงื่อนไขในการส่งผลงาน",
  "chat.contest_modal_submit_button": "ส่งผลงาน",
  "chat.contest_modal_production_grant_title_complete": "สมัครรับเงินสนับสนุนการสร้างตัวละครเรียบร้อยแล้ว",
  "chat.contest_modal_submit_alert_title": "ยืนยันการส่งตัวละครหรือไม่?",
  "chat.contest_modal_submit_alert_description": "ไม่สามารถยกเลิกได้หลังจากส่งผลงานแล้ว",
  "chat.contest_modal_submit_successful_title": "ส่งตัวละครเรียบร้อยแล้ว",
  "chat.contest_submission_period_ended_alert_title": "หมดเขตการส่งผลงาน",
  "chat.information_selected_persona_title": "ตัวตนปัจจุบัน",
  "chat.information_selected_persona_login_to_use": "เข้าสู่ระบบเพื่อใช้งาน",
  "chat.information_conversation_mode_title": "โหมดแชต",
  "chat.information_conversation_mode_messenger": "แบบแชต",
  "chat.information_persona_bottomsheet_title": "เลือกตัวตนที่ต้องการ?",
  "chat.information_persona_bottomsheet_description": "ไม่เลือกตัวตน ก็เริ่มแชตได้",
  "chat.information_conversation_mode_bottomsheet_title": "เลือกรูปแบบการแชต",
  "chat.information_conversation_mode_bottomsheet_description": "สนุกกับการแชตที่สมจริงในแบบนิยาย<br/>หรือการสนทนาที่ง่ายและเป็นกันเองในแบบแชต",
  "chat.information_conversation_mode_bottomsheet_example1": "ตัวละครทักทาย",
  "chat.information_conversation_mode_bottomsheet_example2": "สวัสดี",
  "chat.information_conversation_mode_bottomsheet_example3": "ผู้ใช้ตอบกลับ",
  "chat.conversation_menu_my_balance": "ไอเท็มของฉัน",
  "chat.conversation_long_term_memory_current_memory": "ความจำปัจจุบัน",
  "chat.conversation_long_term_memory_current_memory_title": "ความจำที่ใช้งานในห้องแชตนี้",
  "chat.conversation_long_term_memory_current_memory_description": "ระบบจะสรุปและอัปเดตบทสนทนาอัตโนมัติตามรอบที่ตั้งไว้",
  "chat.conversation_long_term_memory_current_memory_auto_update_toggle": "อัปเดตอัตโนมัติ",
  "chat.conversation_long_term_memory_current_memory_next_update_label": "อัปเดตครั้งถัดไป",
  "chat.conversation_long_term_memory_current_memory_turns_remaining": "เหลืออีก {{int_number}} เทิร์น",
  "chat.conversation_long_term_memory_history_description1": "เลือกความจำที่ต้องการเพื่อนำมาใช้ในความจำปัจจุบัน",
  "chat.conversation_long_term_memory_history_description2": "หากความจำเกิน 20 รายการ รายการเก่าที่สุดจะถูกลบออก ({{int_numbers}}/20)",
  "chat.conversation_long_term_memory_summary_settings_title": "ตั้งค่ารูปแบบการสรุปความจำของตัวละคร",
  "chat.conversation_long_term_memory_summary_settings_description": "สามารถตั้งค่าความถี่ ความยาว<br/>และรูปแบบการสรุปความจำของตัวละครได้",
  "chat.conversation_long_term_memory_summary_settings_interval_caption": "สรุปความจำทุก {{int_numbers}} เทิร์น",
  "chat.conversation_long_term_memory_summary_settings_length_caption": "สรุปความจำสูงสุด {{int_numbers}} ตัวอักษร",
  "chat.conversation_long_term_memory_summary_settings_summary_instructions": "คำสั่งในการสรุป",
  "chat.conversation_long_term_memory_summary_settings_guideline_placeholder": "กรุณากรอกคำสั่งในการสรุป",
  "chat.conversation_long_term_memory_summary_settings_auto_guideline_info": "ตั้งค่าคำสั่งในการสรุปความจำโดยอัตโนมัติ",
  "chat.conversation_output_environment_header_title": "ตั้งค่าคุณภาพและความยาวของข้อความตอบกลับ",
  "chat.conversation_output_environment_header_description": "ยิ่งตั้งค่าความจำและความยาวไว้สูง จะยิ่งใช้บับเบิลมากขึ้น",
  "chat.conversation_output_environment_memory_title": "ความจำ",
  "chat.conversation_output_environment_memory_description": "ตั้งค่าจำนวนบทสนทนาที่ตัวละครจะจดจำ",
  "chat.conversation_output_environment_memory_limit_caption": "จดจำได้สูงสุด {{int_numbers}} เทิร์น",
  "chat.conversation_output_environment_memory_warning_description": "ความจำสั้นกว่ารอบการสรุป อาจทำให้ตัวละครลืมเนื้อหาสำคัญได้",
  "chat.conversation_output_environment_response_length_title": "ปริมาณข้อความ",
  "chat.conversation_output_environment_response_length_description": "ตั้งค่าความยาวข้อความตอบกลับของตัวละคร",
  "chat.conversation_output_environment_response_length_short_button": "สั้น",
  "chat.conversation_output_environment_response_length_medium_button": "ปกติ",
  "chat.conversation_output_environment_response_length_long_button": "ยาว",
  "chat.conversation_output_environment_response_length_short_description": "บทบรรยายและบทสนทนาจะสั้นกระชับ เน้นเฉพาะใจความสำคัญ",
  "chat.conversation_output_environment_response_length_medium_description": "บทบรรยายและบทสนทนาจะมีความยาวที่เหมาะสมพอดี",
  "chat.conversation_output_environment_response_length_long_description": "บทบรรยายและบทสนทนาจะละเอียดและสมจริงมากขึ้น",
  "chat.conversation_free_limit_modal_title1": "โมเดลที่ดียิ่งขึ้น เพื่อประสบการณ์ที่สมจริงยิ่งกว่า",
  "chat.conversation_free_limit_modal_description1": "ดื่มด่ำไปกับเรื่องราวได้เต็มที่<br/>โดยไม่มีโฆษณาคั่น",
  "chat.conversation_free_limit_modal_miru_description": "โมเดลที่สร้างเรื่องราวสมจริงด้วยการวิเคราะห์ที่แม่นยำ",
  "chat.conversation_free_limit_modal_ads_title": "ลบโฆษณา",
  "chat.conversation_free_limit_modal_persona_title": "ขยายตัวตน",
  "chat.conversation_free_limit_modal_persona_description": "สูงสุด {{string_chars}} ตัวอักษร",
  "chat.conversation_free_limit_modal_usernote_title": "ขยายโน้ตของผู้ใช้",
  "chat.conversation_free_limit_modal_usernote_description": "สูงสุด {{string_chars}} ตัวอักษร",
  "chat.conversation_free_limit_modal_memory_title": "ขยายความทรงจำระยะยาว",
  "chat.conversation_free_limit_modal_memory_description": "สูงสุด {{string_chars}} ตัวอักษร, ปรับรอบการสรุปได้",
  "chat.conversation_free_limit_modal_output_title": "ปรับการตอบกลับ",
  "chat.conversation_free_limit_modal_output_description": "ปรับความจำ, ปริมาณข้อความตอบกลับ",
  "chat.conversation_free_limit_modal_upgrade_button": "เปลี่ยนเป็น{{string_signature}}",
  "chat.conversation_free_limit_modal_ad_button": "ดูโฆษณาเพื่อแชตฟรี",
  "chat.conversation_convert_to_free_modal_title_suffix": "แชตด้วย{{string_modelname}}",
  "chat.conversation_convert_to_free_modal_subtitle": "ฟังก์ชันบางส่วนจะถูกจำกัด",
  "chat.conversation_convert_to_free_modal_persona_from": "โปรไฟล์ {{string_chars}} ตัวอักษร",
  "chat.conversation_convert_to_free_modal_persona_to": "→ {{string_chars}} ตัวอักษร",
  "chat.conversation_convert_to_free_modal_usernote_from": "โน้ตของผู้ใช้ {{string_chars}} ตัวอักษร",
  "chat.conversation_convert_to_free_modal_usernote_to": "→ ไม่รองรับ",
  "chat.conversation_convert_to_free_modal_memory_from": "ความทรงจำระยะยาว {{string_chars}} ตัวอักษร ",
  "chat.conversation_convert_to_free_modal_memory_to": "→ {{string_chars}} ตัวอักษร",
  "chat.conversation_convert_to_free_modal_output_settings_from": "สามารถตั้งค่าการตอบกลับได้",
  "chat.conversation_convert_to_free_modal_output_settings_to": "→ ไม่สามารถเปลี่ยนได้",
  "chat.conversation_convert_to_free_modal_description1": "ข้อมูลโปรไฟล์และโน้ตของผู้ใช้จะไม่ถูกลบ แต่จะถูกนำมาใช้ในการสนทนาตามจำนวนตัวอักษรที่จำกัดไว้เท่านั้น",
  "chat.conversation_convert_to_free_modal_description2": "การตั้งค่าความจำระยะยาวจะมีผลหลังจากจบรอบการสรุปปัจจุบัน",
  "chat.conversation_convert_to_free_modal_confirm_button": "ยืนยันการเปลี่ยน",
  "chat.conversation_free_model_chip": "ฟรี",
  "chat.conversation_free_model_banner_title": "กำลังใช้งานโมเดลฟรี",
  "chat.conversation_free_model_banner_persona_limit_description": "โมเดลฟรีรองรับโปรไฟล์สูงสุด {{string_chars}} ตัวอักษร",
  "chat.conversation_free_model_banner_usernote_limit_description": "โมเดลฟรีรองรับโน้ตของผู้ใช้สูงสุด {{string_chars}} ตัวอักษร",
  "chat.conversation_free_model_banner_memory_limit_description": "โมเดลฟรีรองรับความทรงจำระยะยาวสูงสุด {{string_chars}} ตัวอักษร",
  "chat.conversation_free_model_banner_feature_limit_description": "ฟีเจอร์บางส่วนจะถูกจำกัดเมื่อใช้โมเดลฟรี",
  "chat.popup_model_my_bubbles_label": "บับเบิลคงเหลือ",
  "chat.popup_model_topup_button": "เติมเงิน",
  "chat.bottomsheet_model_title": "เลือกโมเดล AI",
  "chat.conversation_persona_no_set_persona_label": "ยังไม่ได้ตั้งค่าตัวตน",
  "chat.conversation_persona_no_set_persona_description1": "ไม่ได้เลือกตัวตน",
  "chat.conversation_persona_no_set_persona_description2": "แชตด้วยชื่อที่ตั้งไว้ใน My Page",
  "chat.conversation_paid_model_chip": "มีค่าใช้จ่าย",
  "chat.bottomsheet_model_estimated_bubbles": "ประมาณ {{int_value}} บับเบิล",
  "chat.conversation_output_environment_memory_paid_only_description": "สามารถปรับระดับความจำได้เฉพาะโมเดลแบบชำระเงินเท่านั้น",
  "chat.conversation_output_environment_response_length_paid_only_description": "สามารถปรับการแสดงผลได้เฉพาะโมเดลแบบชำระเงินเท่านั้น",
  "chat.conversation_long_term_memory_summary_length_title": "จำนวนตัวอักษรบทสรุป",
  "chat.conversation_long_term_memory_summary_length_description": "เมื่อเกินจำนวนตัวอักษรที่กำหนด เนื้อหาจะถูกบีบอัดและบันทึกลงในประวัติ",
  "chat.conversation_long_term_memory_summary_settings_custom_guideline_info": "กำหนดคำสั่งสำหรับสรุปความจำด้วยตนเอง",
  "chat.conversation_long_term_memory_summary_interval_paid_only_description": "สามารถปรับรอบการสรุปผลได้เฉพาะโมเดลแบบชำระเงินเท่านั้น",
  "chat.conversation_long_term_memory_summary_length_paid_only_description": "สามารถปรับจำนวนตัวอักษรบทสรุปได้เฉพาะโมเดลแบบชำระเงินเท่านั้น",
  "chat.conversation_no_model_label": "ไม่มีโมเดล",
  "chat.free_model_ad_unavailable_toast": "ไม่สามารถโหลดโฆษณาได้ กรุณาลองใหม่อีกครั้งในภายหลัง",
  "chat.free_model_ad_loading_title": "กำลังโหลดโฆษณา",
  "chat.free_model_ad_loading_desc": "กรุณารอสักครู่...",
  "chat.conversation_free_limit_modal_ad_preparing_button": "กำลังโหลดโฆษณา",
  "chat.information_conversation_mode_bottomsheet_character": "ตัวละคร",
  "chat.conversation_user_note_disabled_modal_title": "ไม่สามารถใช้งานกับโมเดล Weave ได้",
  "chat.conversation_user_note_disabled_modal_description": "กรุณาเปลี่ยนโมเดล",
  "chat.creator_verification_create_not_verified_alert_description": "กรุณายืนยันตัวตนก่อนสร้างแอสเซต",
  "chat.creator_verification_create_not_verified_alert_identity_verify_button": "ยืนยันตัวตน",
  "chat.creator_verification_my_banner": "ยืนยันตัวตนเป็นครีเอเตอร์เพื่อรับรางวัลเป็นเงินสด!",
  "chat.creator_verification_create_modal_description": "สมัครเป็นครีเอเตอร์ Bubble Chat เพื่อรับรางวัลเป็นเงินสด!",
  "chat.creator_verification_create_modal_view_benefits_button": "ดูสิทธิประโยชน์",
  "chat.creator_verification_verified_modal_description": "คุณได้เป็นครีเอเตอร์ของ Bubble Chat แล้ว!",
  "chat.creator_verification_not_verified_modal_description": "คุณไม่เข้าเกณฑ์การสมัครครีเอเตอร์",
  "chat.creator_verification_verified_modal_view_rewards_button": "ดูรางวัล",
  "chat.rewards_revenue_sharing_terms_agreement_title": "โปรดยอมรับข้อกำหนดและเงื่อนไขการใช้งานสำหรับครีเอเตอร์ เพื่อใช้งานรีวอร์ด",
  "chat.rewards_revenue_sharing_terms_agreement_checkbox": "ฉันยอมรับข้อกำหนดและเงื่อนไขการใช้งานสำหรับครีเอเตอร์",
  "chat.create_image_ai_generated_image_checkbox_description": "ภาพที่สร้างโดย AI",
  "chat.conversation_ai_generated_banner": "บทสนทนานี้สร้างขึ้นโดย AI",
  "dmm.point": "",
  "dmm.charge_button": "",
  "dmm.bubble": "",
  "dmm.point_owned": "",
  "dmm.not_enough_point_alert_description": "",
  "dmm.not_enough_point_alert_charge_guide": "",
  "weave.daily_limit_indicator": "ฟรี {{int_current}}/{{int_max}} ครั้ง",
  "weave.daily_limit_indicator_unlimited": "ฟรี ∞",
  "weave.daily_recharge_note": "รีเซ็ตทุกวันเวลาเที่ยงคืน",
  "weave.free_limit_reached_title": "คุณใช้สิทธิ์แชตฟรีครบแล้ว",
  "weave.limit_reached_alert_title": "คุณใช้สิทธิ์ใช้งานโมเดล Weave รายวันครบแล้ว",
  "weave.limit_reached_alert_body": "สนุกกับการแชตไม่จำกัดด้วย Weave Pass",
  "weave.limit_reached_alert_switch_to_model_cta": "เปลี่ยนเป็น Miru แล้วแชตต่อ",
  "weave.limit_reached_reset_notice": "แชตฟรีจะรีเซ็ตใหม่พรุ่งนี้เที่ยงคืน",
  "weave.pass_product_name": "Weave Pass",
  "weave.pass_product_30days_title": "Weave Pass 30 วัน",
  "weave.pass_product_1day_title": "Weave Pass 1 วัน",
  "weave.pass_price_dmm": "{{int_numbers}} DMM พอยต์",
  "weave.pass_benefit_1": "แชตโมเดล Weave ได้ไม่จำกัด",
  "weave.pass_purchase_confirm": "ต้องการซื้อ {{string_productName}} หรือไม่?",
  "weave.pass_purchase_success": "ซื้อสำเร็จแล้ว!",
  "weave.pass_purchase_fail": "การซื้อไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
  "weave.pass_purchase_insufficient_title": "DMM พอยต์ไม่เพียงพอสำหรับการซื้อ {{string_productName}}",
  "weave.pass_purchase_insufficient_body": "เติม DMM พอยต์ แล้วซื้อสินค้าได้เลย",
  "weave.pass_purchase_insufficient_current": "DMM พอยต์ปัจจุบัน",
  "weave.pass_purchase_insufficient_required": "DMM พอยต์ที่ต้องใช้",
  "weave.pass_purchase_insufficient_shortage": "DMM พอยต์ที่ขาด",
  "weave.pass_purchase_insufficient_cta": "ไปหน้าเติมเงิน",
  "weave.pass_purchase_duplicate": "คุณมีแพ็กเกจที่ใช้งานอยู่ สามารถซื้อ {{string_productName}} ได้หลังจากแพ็กเกจปัจจุบันสิ้นสุดลง",
  "weave.pass_active_badge": "กำลังใช้งาน Weave Pass",
  "weave.pass_expired_title": "Weave Pass สิ้นสุดการใช้งานแล้ว",
  "weave.pass_expired_body": "สิทธิประโยชน์สำหรับการแชตนี้จะสิ้นสุดลง<br/>ต่ออายุแพ็กเกจ เพื่อแชตต่อได้อย่างไม่มีสะดุด!",
  "pwa.common_later": "ทำภายหลัง",
  "pwa.install_headline": "ใช้งาน {{appName}} ได้ทันทีจากหน้าจอหลัก<br/>โดยไม่ต้องติดตั้งแอป",
  "pwa.install_banner_cta_install": "เพิ่มไปยังหน้าจอหลัก",
  "pwa.install_banner_cta_open_browser": "เปิดด้วยเบราว์เซอร์",
  "pwa.install_banner_cta_open_safari": "เปิดด้วย Safari",
  "pwa.install_banner_inapp_text": "เพื่อการใช้งานที่ราบรื่น<br/>โปรดเปิด {{appName}} ผ่านเบราว์เซอร์",
  "pwa.install_banner_aria": "แนะนำการติดตั้งแอป",
  "pwa.push_pre_title": "รับข่าวสารล่าสุดจาก{{appName}}<br/>ผ่านการแจ้งเตือน",
  "pwa.push_pre_desc": "รับแจ้งเตือนข้อความจากตัวละครที่สนใจ<br/>และข่าวสารกิจกรรมใหม่ๆ",
  "pwa.push_pre_bullet_1": "กิจกรรม ประกาศ แอสเซทใหม่",
  "pwa.push_pre_bullet_2": "การแจ้งเตือนการติดตาม ถูกใจ ความคิดเห็น และการตอบกลับ",
  "pwa.push_pre_bullet_3": "การแจ้งเตือนบับเบิล แชมพู แพ็กเกจ",
  "pwa.push_pre_confirm": "เปิดรับแจ้งเตือน",
  "pwa.install_steps_title": "วิธีติดตั้ง",
  "pwa.install_steps_ios_1": "แตะปุ่ม [แชร์] ด้านล่างของ Safari",
  "pwa.install_steps_ios_2": "เลือก [เพิ่มไปยังหน้าจอหลัก]",
  "pwa.install_steps_ios_3": "เลือก [เพิ่ม] ที่มุมขวาบน",
  "pwa.install_steps_aos_1": "เลือกเมนู (⋮) ที่มุมขวาบน",
  "pwa.install_steps_aos_2": "เลือก [เพิ่มไปยังหน้าจอหลัก]",
  "pwa.install_steps_aos_3": "เลือกเพิ่ม",
  "pwa.inapp_guide_title": "กรุณาเปิดด้วย {{targetBrowser}}",
  "pwa.inapp_guide_desc": "คัดลอกลิงก์ แล้วเปิดด้วย {{targetBrowser}}<br/>จากนั้นติดตั้งตามขั้นตอนด้านล่าง",
  "pwa.inapp_guide_copy": "คัดลอกลิงก์",
  "pwa.inapp_guide_default_browser": "เบราว์เซอร์เริ่มต้น",
  "pwa.install_qr_caption": "สแกน QR Code ด้วยกล้องมือถือเพื่อดาวน์โหลด",
  "pwa.install_qr_desktop_cta": "ติดตั้งทางลัดบน PC",
  "pwa.offline_message": "การเชื่อมต่อเครือข่ายไม่เสถียร<br/>โปรดลองอีกครั้งในภายหลัง",
  "pwa.offline_reload": "รีเฟรช",
  "pwa.toast_copy_success": "คัดลอกลิงก์แล้ว",
  "pwa.toast_copy_fail": "คัดลอกลิงก์ไม่สำเร็จ",
  "pwa.toast_desktop_install_unsupported": "เบราว์เซอร์นี้ไม่รองรับการติดตั้งโดยตรง โปรดใช้ไอคอนติดตั้งในแถบที่อยู่เว็บไซต์",
  "pwa.push_default_title": "การแจ้งเตือน",
  "login.start_with_kakao": "เข้าสู่ระบบด้วย Kakao",
  "login.start_with_google": "เข้าสู่ระบบด้วย Google",
  "login.start_with_apple": "เข้าสู่ระบบด้วย Apple",
  "login.start_with_line": "เข้าสู่ระบบด้วย LINE",
  "login.start_with_dmm": "เข้าสู่ระบบด้วย DMM",
  "chat.onboarding_conversation_watch_ad_alert": "ดูโฆษณาเพื่อแชตต่อ",
  "chat.onboarding_chat_load_error_modal_description": "ไม่สามารถโหลดประวัติการแชตได้ ลองใหม่อีกครั้งหรือไม่?",
  "chat.onboarding_chat_load_error_modal_not_now_button": "ไว้ภายหลัง",
  "chat.onboarding_character_recommendation_title": "เลือกตัวละครเพื่อเริ่มแชต",
  "chat.onboarding_character_recommendation_button": "แชตเลย",
  "chat.onboarding_conversation_watch_ad_alert_button": "ดูโฆษณา",
  "chat.onboarding_login_title": "เข้าสู่ระบบได้ง่ายๆ<br/>แล้วสานต่อเรื่องราวสุดโรแมนติก!",
  "general.chat": "บับเบิลแชต",
  "general.chatlist": "แชต",
  "chat.home_install_pwa_button": "เพิ่มเลย",
  "chat.home_install_app_description": "อัปเดตก่อนใครในแอป",
  "chat.custom_character_title": "เลือกตัวละครเพื่อเริ่มแชต",
  "chat.custom_universe_title": "เลือกจักรวาลเพื่อเริ่มแชต",
  "chat.custom_scene_title": "เลือกฉากเพื่อเริ่มแชต",
  "chat.custom_character_browse_button": "ดูตัวละคร",
  "chat.custom_universe_browse_button": "ดูจักรวาล",
  "chat.custom_scene_browse_button": "ดูฉาก",
  "chat.information_selected_persona_and_mode_description": "เริ่มแชต {{string_type}} ด้วยตัวตน {{string_naming}}",
  "chat.information_conversation_mode_bottomsheet_information": "สร้างห้องแชตแล้วจะไม่สามารถเปลี่ยนได้",
  "chat.information_conversation_mode_character_line_story": "\"บทพูดตัวละคร ตอบแบบยาวและละเอียด\"",
  "chat.information_conversation_mode_character_narrative_story": "ใช้สำหรับบรรยายสถานการณ์ ตอบละเอียดและยาวกว่ารูปแบบแชต",
  "chat.information_conversation_mode_user_line": "บทพูดของคุณ",
  "chat.information_conversation_mode_user_narrative": "การกระทำที่คุณพิมพ์",
  "chat.information_conversation_mode_character_line_messenger": "บทพูดตัวละคร คุยโต้ตอบสั้น ๆ แบบแชต",
  "chat.information_conversation_mode_character_narrative_messenger": "ใช้สำหรับบรรยายสถานการณ์",
  "chat.information_conversation_mode_messenger_bottomsheet_start_talk": "เริ่มแชตในรูปแบบแชต",
  "chat.information_conversation_mode_story_bottomsheet_start_talk": "เริ่มแชตในรูปแบบเนื้อเรื่อง",
  "chat.information_bottomsheet_back": "เลือกแล้วย้อนกลับ",
  "chat.information_persona_bottomsheet_hint": "เปลี่ยนตัวตนได้แม้อยู่ในห้องแชต",
  "chat.information_persona_bottomsheet_start": "เริ่มแชตด้วยตัวตนนี้",
  "chat.information_persona_edit_button": "แก้ไข",
  "chat.information_persona_delete_button": "ลบ",
  "chat.information_detail_cta_description": "เริ่มแชตด้วยตัวตน '{{persona}}' ใน '{{mode}}'",
  "chat.information_multi_image": "หลายรูปภาพ",
  "chat.information_multi_image_count": "{{int_count}} รายการ",
  "chat.information_creator_title": "ผู้สร้าง",
  "chat.information_reviews_count": "ความคิดเห็น {{int_count}} รายการ",
  "chat.information_replies_expand": "ดูการตอบกลับอีก {{int_count}} รายการ",
  "chat.information_replies_collapse": "ซ่อนการตอบกลับ {{int_count}} รายการ",
  "chat.information_reply_mention_button": "ตอบกลับ",
  "chat.information_comment_pin_aria": "ปักหมุด",
  "chat.information_comment_unpin_aria": "เลิกปักหมุด",
  "chat.information_comment_edit_aria": "แก้ไขความคิดเห็น",
  "chat.information_reply_edit_aria": "แก้ไขการตอบกลับ",
  "general.back_aria": "ย้อนกลับ",
  "general.share_aria": "แชร์",
  "general.previous_aria": "ก่อนหน้า",
  "chat.information_asset_nsfw": "ตื่นเต้น",
  "chat.bottomsheet_model_section_featured": "โมเดลแนะนำ",
  "chat.bottomsheet_model_section_others": "โมเดลทั้งหมด",
  "chat.bottomsheet_model_chip_etc": "อื่นๆ",
  "chat.bottomsheet_model_own_model_label": "โมเดลเฉพาะของ BubbleChat",
  "chat.bottomsheet_model_changed_toast": "เปลี่ยนเป็น{{string_modelName}}แล้ว",
  "chat.guest_popup_signup_headline": "รวมตัวละครสเปกที่ใช่!",
  "chat.guest_popup_signup_subline": "เข้าสู่ระบบเพื่อเริ่มเรื่องราวของคุณ",
  "chat.guest_popup_memory_headline": "อย่าเพิ่งไป…",
  "chat.guest_popup_memory_subline": "ล็อกอินไว้ จะได้ไม่ลืมกันนะ",
  "chat.guest_popup_app_install_headline": "ไม่ต้องค้นหาทุกครั้ง!",
  "chat.guest_popup_app_install_subline": "เพิ่มแอปไว้ที่หน้าจอหลัก เข้าใช้งานได้ใน 1 วิ!",
  "chat.guest_popup_ad_removal_headline": "คุยลื่นไหล ไม่มีสะดุด!",
  "chat.guest_popup_ad_removal_subline": "สมัครสมาชิก แล้วดื่มด่ำกับแชตได้ต่อเนื่องแบบไม่มีโฆษณา!",
  "chat.guest_popup_watch_ad_button": "ดูโฆษณา แล้วแชตฟรี!",
  "chat.guest_popup_app_download_button": "ดาวน์โหลดแอป",
  "chat.profile_my_password_current_label": "รหัสผ่านปัจจุบัน",
  "chat.profile_my_password_new_label": "รหัสผ่านใหม่",
  "chat.profile_my_status_verified": "ยืนยันแล้ว",
  "chat.profile_my_status_unverified": "ยังไม่ยืนยัน",
  "chat.profile_my_status_password_set": "ตั้งค่าแล้ว",
  "chat.profile_my_status_password_unset": "ยังไม่ตั้งค่า",
  "chat.profile_my_edit_view_content_current_country_description": "แสดงเฉพาะคอนเทนต์ที่สร้างในประเทศที่เลือก",
  "chat.profile_my_edit_view_content_all_countries_description": "แสดงคอนเทนต์ที่สร้างในทุกประเทศที่ให้บริการ",
  "chat.creator_verification_my_banner_button": "สมัครครีเอเตอร์",
  "chat.conversation_unsupported_feature_modal_title": "ต้องการใช้ฟีเจอร์นี้หรือไม่?",
  "chat.conversation_unsupported_feature_modal_current_label": "โมเดลปัจจุบัน",
  "chat.conversation_unsupported_feature_modal_description1": "<model>{{string_modelName}}</model> ไม่รองรับฟีเจอร์นี้",
  "chat.conversation_unsupported_feature_modal_description2": "เปลี่ยนไปใช้โมเดลอื่นเพื่อใช้ฟีเจอร์ที่หลากหลายยิ่งขึ้น!",
  "profile.decorator_expired": "หมดอายุ",
  "general.no_products": "ขณะนี้ไม่มีสินค้าพร้อมจำหน่าย",
  "general.loading": "กำลังโหลด…",
  "profile.user_blocked_alert_message": "หากคุณบล็อกผู้ใช้นี้คุณจะไม่เห็นความเห็นของเขาอีกต่อไป<br/>ต้องการบล็อกหรือไม่?",
  "chat.profile_my_decorator_apply_button": "ยืนยัน",
  "chat.profile_my_decorator_title": "กรอบโปรไฟล์",
  "chat.rewards_mg_title": "รางวัลผู้พิทักษ์ดวงดาว",
  "chat.rewards_mg_current_month_revenue_pre_tax": "รางวัลรวมเดือนนี้ (ก่อนหักภาษี)",
  "chat.rewards_mg_current_month_revenue_after_tax": "รางวัลรวมเดือนนี้ (หลังหักภาษี)",
  "chat.rewards_mg_settlement_period": "รอบการคำนวณ",
  "chat.rewards_mg_payout_date": "วันที่กำหนดจ่ายของเดือนนี้",
  "chat.rewards_mg_previous_month_payout_date": "วันที่กำหนดจ่ายของเดือนก่อน",
  "chat.rewards_mg_previous_month_revenue_pre_tax": "รางวัลที่ยืนยันแล้วเดือนก่อน (ก่อนหักภาษี)",
  "chat.rewards_mg_previous_month_revenue_after_tax": "รางวัลที่ยืนยันแล้วเดือนก่อน (หลังหักภาษี)",
  "chat.rewards_mg_contract_amount": "การันตีรายได้ขั้นต่ำ (MG)",
  "chat.rewards_mg_shortfall": "ส่วนต่างรายได้ MG",
  "chat.rewards_mg_notice": "หากรางวัลรวมของเดือนนั้นต่ำกว่าจำนวนการันตีรายได้ขั้นต่ำ (MG) ระบบจะจ่ายส่วนต่างที่ขาดให้ครบตามการันตีรายได้ขั้นต่ำ\nหากรางวัลรวมเท่ากับหรือมากกว่าการันตีรายได้ขั้นต่ำ จะไม่มีส่วนต่างรายได้ และส่วนที่เกินจะไม่ถูกหักออก\nส่วนต่างรายได้ คำนวณ ณ เวลา 23:59 ของวันสุดท้ายของเดือน และจ่ายในวันที่ 10 ของเดือนถัดไป\nหากวันจ่ายตรงกับวันเสาร์-อาทิตย์หรือวันหยุดนักขัตฤกษ์ วันที่จ่ายอาจมีการเปลี่ยนแปลง\nรางวัลที่ได้รับหลังเวลา 23:59 ของวันสุดท้ายของเดือน จะถูกนำไปคำนวณในเดือนถัดไป",
  "chat.rewards_creator_information_grade": "ระดับครีเอเตอร์",
  "chat.creator_grade_stardust": "ประกายดาว",
  "chat.creator_grade_rising_star": "ดาวรุ่ง",
  "chat.creator_grade_starkeeper": "ผู้พิทักษ์ดวงดาว",
  "profile.user_unblocked_alert_message": "คุณต้องการปลดบล็อกผู้ใช้นี้ใช่หรือไม่?",
  "report.type.spam_text": "โฆษณา",
  "report.type.advertisement_text": "โฆษณาที่ไม่ได้รับอนุญาต",
  "report.type.inappropriate_text": "พฤติกรรมไม่เหมาะสม",
  "report.type.personal_info_text": "ข้อมูลส่วนตัวรั่วไหล",
  "report.type.other_text": "อื่นๆ",
  "payment.page_list_tag_sale_period": "โปรพิเศษวันชูซอก! ถึง {{date}} เท่านั้น",
  "payment.page_list_bonus_expiration": "โบนัสบับเบิลที่ได้รับ มีอายุการใช้งาน {{int_days}} วัน",
  "chat.conversation_reroll_guidance_title": "คำสั่งรีโรล",
  "chat.conversation_reroll_guidance_cost_tooltip": "การใช้คำสั่งรีโรลอาจมีค่าใช้จ่ายเพิ่มเติม",
  "chat.conversation_reroll_guidance_description": "ต้องการให้เขียนใหม่แบบไหน?",
  "chat.conversation_reroll_guidance_description_sub": "สามารถตั้งค่าการแสดงคำสั่งรีโรลได้ที่การตั้งค่าการแสดงผล",
  "chat.conversation_reroll_guidance_input_placeholder": "เช่น) คงรูปแบบสถานะไว้เหมือนเดิม แต่ให้เรน่าตอบโต้เย็นชามากขึ้น",
  "chat.conversation_reroll_guidance_input_caption": "สามารถป้อนคำสั่งได้สูงสุด {{int_numbers}} ตัวอักษร",
  "chat.conversation_reroll_guidance_cost_info_button_label": "ดูรายละเอียดค่าใช้จ่าย",
  "chat.conversation_reroll_guidance_reset_button": "รีเซ็ต",
  "chat.conversation_reroll_guidance_skip_button": "รีโรลโดยไม่ระบุคำสั่ง",
  "chat.conversation_reroll_guidance_submit_button": "รีโรล",
  "chat.conversation_reroll_guidance_discovery_toast": "หากต้องการรีโรลทันทีทุกครั้ง สามารถเปลี่ยนได้ที่การตั้งค่าการแสดงผล",
  "chat.conversation_reroll_guidance_setting_title": "คำสั่งรีโรล",
  "chat.conversation_reroll_guidance_setting_description": "เมื่อกดรีโรล จะแสดงหน้าต่างให้ป้อนคำสั่งสำหรับการเขียนใหม่",
  "chat.conversation_reroll_guidance_setting_on_caption": "เมื่อกดรีโรล จะแสดงหน้าต่างคำสั่ง",
  "chat.conversation_reroll_guidance_setting_off_caption": "เมื่อกดรีโรล ระบบจะเขียนใหม่ทันที",
  "chat.conversation_reroll_guidance_setting_off_toast": "กดรีโรลเพื่อสร้างคำตอบใหม่ทันที",
  "chat.custom_modal_input_settings": "ตั้งค่าช่องพิมพ์",
  "chat.custom_modal_direction_button_position": "ตำแหน่งปุ่มบทบรรยาย",
  "chat.conversation_composition_title": "รูปแบบการแชต",
  "chat.conversation_chat_link_copy_button": "คัดลอกลิงก์",
  "chat.conversation_chat_copy_modal_description": "กรุณาตั้งชื่อสำเนา การตั้งค่าตัวละคร จักรวาล และฉาก รวมถึงประวัติการแชตทั้งหมดจะถูกคัดลอกไปด้วย",
  "chat.free_model_ad_retry_wait_toast": "ไม่สามารถโหลดโฆษณาได้ กรุณาลองใหม่อีกครั้งใน {{int_seconds}} วินาที",
  "chat.free_model_ad_retry_wait_minutes_toast": "ไม่สามารถโหลดโฆษณาได้ กรุณาลองใหม่อีกครั้งใน {{int_minutes}} นาที",
  "chat.conversation_sidebar_chat_copy": "คัดลอกแชต",
  "chat.conversation_sidebar_link_copied": "คัดลอกลิงก์ห้องแชตสำเร็จ",
  "pwa.install_steps_ipad_1": "แตะปุ่ม [แชร์] ด้านบนของ Safari",
  "chat.custom_modal_tab_color": "สี",
  "chat.custom_modal_tab_input": "ช่องพิมพ์",
  "chat.custom_modal_tab_lab": "ตั้งค่าฟอนต์",
  "chat.custom_modal_background_opacity": "ความทึบของพื้นหลัง",
  "chat.custom_modal_opacity_min": "โปร่งใสทั้งหมด",
  "chat.custom_modal_opacity_max": "ทึบทั้งหมด",
  "chat.custom_modal_reset_viewer_button": "รีเซ็ตเฉพาะหน้าแสดงผล",
  "chat.custom_modal_reset_text_button": "รีเซ็ตเฉพาะข้อความ",
  "chat.custom_modal_reset_color_button": "รีเซ็ตเฉพาะสี",
  "chat.custom_modal_reset_input_button": "รีเซ็ตเฉพาะช่องพิมพ์",
  "chat.custom_modal_reset_lab_button": "รีเซ็ตเฉพาะตั้งค่าฟอนต์",
  "chat.custom_modal_reset_all_button": "รีเซ็ตทั้งหมด",
  "chat.custom_modal_reset_all_alert_title": "รีเซ็ตการตั้งค่าทั้งหมดหรือไม่?",
  "chat.custom_modal_reset_all_alert_description": "การตั้งค่าการแสดงผล ข้อความ สี และช่องพิมพ์ทั้งหมดจะกลับเป็นค่าเริ่มต้น กดบันทึกเพื่อใช้งาน",
  "chat.custom_modal_reset_all_alert_description_lab": "การตั้งค่าการแสดงผล ข้อความ สี ช่องพิมพ์ และตั้งค่าฟอนต์ทั้งหมดจะกลับเป็นค่าเริ่มต้น กดบันทึกเพื่อใช้งาน",
  "chat.custom_modal_reset_all_toast": "คืนค่าเริ่มต้นแล้ว กดบันทึกเพื่อใช้งาน",
  "chat.custom_modal_apply_scope_title": "นำไปใช้กับส่วนไหน?",
  "chat.custom_modal_apply_scope_description": "เลือกขอบเขตการใช้งาน",
  "chat.custom_modal_apply_scope_room_button": "ใช้กับห้องแชตนี้เท่านั้น",
  "chat.custom_modal_apply_scope_story_all_button": "ใช้กับห้องแชตแบบเนื้อเรื่องทั้งหมด",
  "chat.custom_modal_apply_scope_chat_all_button": "ใช้กับห้องแชตแบบแชตทั้งหมด",
  "chat.custom_modal_apply_scope_story_note": "การตั้งค่านี้มีผลเฉพาะห้องแชตแบบเนื้อเรื่องเท่านั้น การตั้งค่าห้องแชตแบบแชตจะยังคงเดิม",
  "chat.custom_modal_apply_scope_chat_note": "การตั้งค่านี้มีผลเฉพาะห้องแชตแบบแชตเท่านั้น การตั้งค่าห้องแชตแบบเนื้อเรื่องจะยังคงเดิม",
  "chat.custom_modal_apply_room_toast": "ใช้กับห้องแชตนี้แล้ว",
  "chat.custom_modal_apply_all_toast": "ใช้กับห้องแชตทั้งหมดแล้ว",
  "chat.custom_modal_lab_font": "ฟอนต์",
  "chat.custom_modal_lab_font_batang": "Batang",
  "chat.custom_modal_lab_font_handwriting": "แบบลายมือ",
  "chat.create_character_multi_images_main_image_chip": "ภาพหลัก",
  "chat.create_character_multi_images_bulk_edit_mixed": "ต่างสถานะ",
  "chat.create_character_multi_images_bulk_edit_public_mixed_description": "มีทั้งรูปสาธารณะและส่วนตัว แตะเพื่อตั้งเป็นสาธารณะทั้งหมด",
  "chat.create_character_multi_images_bulk_edit_ai_mixed_description": "มีระบุ AI เพียงบางรูป แตะเพื่อระบุเป็น AI ทั้งหมด",
  "chat.create_character_multi_images_replace_image": "เปลี่ยนรูปภาพ",
  "chat.create_character_multi_images_main_image_always_public": "ภาพหลักจะแสดงเป็นสาธารณะเสมอ",
  "dmm.adult_mismatch_toast_fanza": "",
  "dmm.adult_mismatch_toast_dmm": "",
  "common.service_name": "บับเบิลแชต : BubbleChat",
  "chat.rewards_rising_star_monthly_achievement_bonus": "โบนัสประจำเดือน {{string_month}}",
  "chat.rewards_rising_star_unpaid": "ยังไม่ได้จ่าย",
  "chat.rewards_rising_star_not_morning_star_on_payout_date": "ไม่ได้รับโบนัสเนื่องจากคุณไม่ได้เป็นดาวรุ่ง ณ วันที่จ่าย {{string_payoutDate}}",
  "general.mode": "โหมด",
  "chat.rewards_rising_star_title": "โบนัสระดับดาวรุ่ง",
  "chat.rewards_rising_star_estimated_monthly_bonus": "โบนัสคาดการณ์ประจำเดือน {{string_month}}",
  "chat.rewards_rising_star_scheduled_monthly_bonus": "โบนัสที่กำหนดจ่ายประจำเดือน {{string_month}}",
  "chat.rewards_rising_star_paid_monthly_bonus": "โบนัสที่จ่ายแล้วประจำเดือน{{string_month}}",
  "chat.rewards_rising_star_estimated": "โดยประมาณ",
  "chat.rewards_rising_star_calculated": "คำนวณแล้ว",
  "chat.rewards_rising_star_paid": "จ่ายแล้ว",
  "chat.rewards_rising_star_estimate_description": "ยอดโดยประมาณ ณ วันที่ {{string_asOfAt}} กำหนดจ่ายวันที่ {{string_payoutDate}}",
  "chat.rewards_rising_star_calculated_description": "คำนวณแล้ว ณ วันที่ {{string_asOfAt}} โบนัสจะถูกเพิ่มเข้ายอดรางวัลอัตโนมัติในวันที่ {{string_payoutDate}}",
  "chat.rewards_rising_star_paid_description": "โอนโบนัสเข้ายอดรางวัลแล้ว เมื่อวันที่ {{string_payoutDate}}",
  "chat.rewards_rising_star_next_calculation_date": "วันคำนวณรอบถัดไป",
  "chat.rewards_rising_star_payout_date": "วันที่จ่ายเงิน",
  "chat.rewards_rising_star_achievement_tiers": "สถานะระดับ",
  "chat.rewards_rising_star_next_tier_description": "อีก {{string_remaining}} จะถึงระดับถัดไป (ตั้งแต่ {{string_threshold}} ขึ้นไป) รับโบนัส {{string_bonus}} เมื่อถึงระดับ",
  "chat.rewards_rising_star_highest_tier_description": "คุณอยู่ในระดับสูงสุดแล้ว โดยจะได้รับโบนัส 50% จากยอดรางวัลรวม",
  "chat.rewards_rising_star_threshold_or_more": "ตั้งแต่ {{string_amount}} ขึ้นไป",
  "chat.rewards_rising_star_achievement_fifty_percent": "50% ของยอดที่ทำได้",
  "chat.rewards_rising_star_calculation_details": "รายละเอียดการคำนวณ",
  "chat.rewards_rising_star_combined_rewards": "ยอดรางวัลรวม",
  "chat.rewards_rising_star_applied_tier": "ระดับที่ใช้คำนวณ",
  "chat.rewards_rising_star_applied_rule": "เกณฑ์ที่ใช้คำนวณ",
  "chat.rewards_rising_star_achievement_bonus": "โบนัสความสำเร็จ",
  "chat.rewards_rising_star_fixed_bonus": "โบนัสคงที่",
  "chat.rewards_rising_star_achievement_fifty_percent_rounded_up": "50% ของยอดที่ทำได้ (ปัดเศษขึ้น)",
  "chat.rewards_rising_star_not_achieved": "ยังไม่ถึงเกณฑ์",
  "chat.rewards_rising_star_eligible_assets": "แอสเซตที่มีสิทธิ์รับโบนัส",
  "chat.rewards_rising_star_within_ninety_days_of_first_release": "ภายใน 90 วันนับจากการเผยแพร่ครั้งแรก",
  "chat.rewards_rising_star_first_release": "วันที่เผยแพร่ครั้งแรก",
  "chat.rewards_rising_star_excluded": "ยกเว้น",
  "chat.rewards_rising_star_total": "รวมทั้งหมด",
  "chat.rewards_rising_star_expand_all": "แสดงทั้งหมด {{int_count}} รายการ",
  "chat.rewards_rising_star_no_new_assets": "ไม่มีแอสเซตที่เผยแพร่ใหม่ในช่วง 90 วันที่ผ่านมา",
  "chat.rewards_rising_star_new_asset_description": "เมื่อเผยแพร่แอสเซตใหม่ จะนำไปคำนวณตั้งแต่รอบถัดไป",
  "chat.rewards_rising_star_bonus_history": "ประวัติการรับโบนัส",
  "chat.rewards_rising_star_morning_star_bonus_history": "ประวัติการรับโบนัสจากสถานะดาวรุ่ง",
  "chat.rewards_rising_star_bonus_reclaimed": "เรียกคืนโบนัส",
  "chat.rewards_rising_star_for_year_month": "ประจำเดือน{{string_yearMonth}}",
  "chat.rewards_rising_star_payout_date_label": "จ่ายเมื่อวันที่{{string_payoutDate}}",
  "chat.rewards_rising_star_base_rewards": "รางวัลพื้นฐาน",
  "chat.rewards_rising_star_monthly_total_rewards": "ยอดรางวัลรวมประจำเดือน",
  "chat.rewards_rising_star_bonus_guide": "เกี่ยวกับโบนัส",
  "chat.rewards_rising_star_calculation_notice": "โบนัสจะคำนวณในทุกวันที่ 25 ของเดือน ณ เวลา 23:59 น. โดยรวมรางวัลที่เกิดขึ้นภายในช่วงเวลาเดียวกันจากแอสเซตที่เผยแพร่ครั้งแรกภายใน 90 วันที่ผ่านมา โบนัสที่คำนวณแล้วจะถูกเพิ่มเข้ายอดรางวัลอัตโนมัติในวันสุดท้ายของเดือน",
  "chat.rewards_rising_star_non_cumulative_notice": "โบนัสจะไม่สามารถรับซ้ำได้ โดยจะได้รับเฉพาะโบนัสสูงสุดของระดับนั้นๆ เท่านั้น",
  "chat.rewards_rising_star_rounding_notice": "โบนัส 50% จะปัดเศษขึ้นเป็นจำนวนเต็ม",
  "chat.rewards_rising_star_first_release_notice": "\"เผยแพร่ใหม่\" หมายถึงการเผยแพร่เป็นครั้งแรก",
  "chat.rewards_rising_star_recalculation_notice": "หลังจากการคำนวณ ยอดรางวัลของแอสเซตนั้นจะไม่ถูกนำมาคำนวณ หากเกิดขึ้นหลังการคำนวณในวันที่ 25 แต่ก่อนการจ่ายเงินในวันสิ้นเดือน ระบบจะคำนวณโบนัสใหม่ก่อนการจ่ายเงิน และหากเกิดขึ้นหลังการจ่ายเงิน ยอดโบนัสที่จ่ายไปแล้วอาจถูกเรียกคืนได้",
  "chat.rewards_rising_star_rate_change_notice": "หากมีการเปลี่ยนแปลงอัตราส่วนแบ่งหลังจากการคำนวณ ยอดโบนัสที่คำนวณไว้จะยังคงเดิม",
  "chat.image_number": "รูปที่ {{int_imageNumbers}}",
  "general.ai": "AI",
  "chat.contest_entry_required": "จำเป็น",
  "chat.contest_entry_per_character_fields_hint": "กรุณากรอกแยกตามตัวละคร · {{int_number}} รายการ",
  "chat.contest_entry_staff_only_hint": "เฉพาะทีมงานเท่านั้นที่ดูได้ · แก้ไขไม่ได้หลังส่ง",
  "chat.contest_entry_required_character_field_error": "ข้อมูลจำเป็น กรุณากรอกข้อมูลของตัวละครนี้",
  "chat.contest_entry_additional_fields_remaining": "กรุณากรอกข้อมูลเพิ่มเติม (เหลืออีก {{int_number}} รายการ)",
  "chat.contest_entry_review_confirmation_notice": "การเข้าร่วมจะได้รับการยืนยันหลังทีมงานตรวจสอบ โดยจะแจ้งผลให้ทราบผ่านการแจ้งเตือน",
  "chat.contest_entry_ineligible_characters_notice": "มีตัวละครบางตัวที่ไม่สามารถส่งเข้าร่วมได้ กรุณาตรวจสอบรายการอีกครั้ง",
  "chat.contest_entry_pending_approval": "รออนุมัติ",
  "chat.contest_entry_entry_confirmed": "ยืนยันการเข้าร่วมแล้ว",
  "chat.contest_entry_rejected": "ไม่ผ่านการอนุมัติ",
  "chat.contest_entry_entry_canceled": "ยกเลิกการเข้าร่วม",
  "chat.contest_entry_submitted_pending_review": "ส่งเมื่อ {{string_date}} · รอการตรวจสอบ",
  "chat.contest_entry_closed_awaiting_results": "ปิดรับผลงานแล้ว · รอผลการตัดสิน",
  "chat.contest_entry_approval_revoked_pending_review": "ยกเลิกการอนุมัติ {{string_date}} · รอการตรวจสอบอีกครั้ง",
  "chat.contest_entry_confirmed_date": "ยืนยันแล้ว {{string_date}}",
  "chat.contest_entry_confirmed_grant_amount_paid": "ยืนยันแล้ว {{string_date}} · จ่ายรางวัลสนับสนุนการผลิต {{string_amount}} เรียบร้อยแล้ว",
  "chat.contest_entry_confirmed_grant_paid": "ยืนยันแล้ว {{string_date}} · จ่ายรางวัลสนับสนุนการผลิตแล้ว",
  "chat.contest_entry_rejected_resubmissions_remaining": "ไม่ผ่านการอนุมัติ {{string_date}} · ส่งผลงานใหม่ได้อีก {{int_number}} ครั้ง",
  "chat.contest_entry_rejected_no_resubmission": "ไม่ผ่านการอนุมัติ {{string_date}} · ไม่สามารถส่งผลงานใหม่ได้",
  "chat.contest_entry_rejected_after_deadline": "ไม่ผ่านการอนุมัติหลังปิดรับผลงาน · ไม่สามารถส่งผลงานใหม่ได้",
  "chat.contest_entry_auto_canceled_private_character": "ยกเลิกการเข้าร่วมอัตโนมัติ {{string_date}} · เปลี่ยนตัวละครเป็นส่วนตัวแล้ว",
  "chat.contest_entry_public_characters_only": "สามารถส่งเข้าร่วมการประกวดได้ เฉพาะตัวละครที่ตั้งค่าเป็นสาธารณะเท่านั้น",
  "chat.contest_entry_resubmissions_exhausted_notice": "คุณใช้สิทธิ์ส่งผลงานใหม่ครบแล้ว กรุณาส่งผลงานอื่นเพื่อเข้าร่วม",
  "chat.contest_entry_rejected_after_deadline_notice": "ผลงานที่ไม่ผ่านการอนุมัติหลังปิดรับผลงานแล้ว จะไม่สามารถส่งใหม่ได้",
  "chat.contest_entry_view_rejection_reason": "ดูเหตุผลที่ไม่ผ่านการอนุมัติ",
  "chat.contest_entry_view_submission": "ดูข้อมูลที่ส่ง",
  "chat.contest_entry_collapse_submission": "ย่อข้อมูลที่ส่ง",
  "chat.contest_entry_read_only_hint": "อ่านได้อย่างเดียว · แก้ไขไม่ได้หลังส่งผลงาน",
  "chat.contest_entry_rejection_reason": "เหตุผลที่ไม่ผ่านการอนุมัติ",
  "chat.contest_entry_processed_date": "ดำเนินการเมื่อ {{string_date}}",
  "chat.contest_entry_my_additional_information": "ข้อมูลเพิ่มเติมที่คุณส่ง",
  "chat.contest_entry_resubmission_attempts": "จำนวนครั้งที่ส่งใหม่ได้",
  "chat.contest_entry_resubmissions_remaining": "เหลือ {{int_number}} ครั้ง (ใช้ไปแล้ว {{int_count}} จาก 3 ครั้ง)",
  "chat.contest_entry_resubmissions_exhausted": "เหลือ 0 ครั้ง (ใช้ครบทั้ง 3 ครั้งแล้ว)",
  "chat.contest_entry_resubmission_closed": "ไม่สามารถส่งใหม่ได้ (ปิดรับผลงานแล้ว)",
  "chat.contest_entry_resubmission_check_notice": "ก่อนส่งผลงานอีกครั้ง กรุณาตรวจสอบว่าคุณได้แก้ไขตามเหตุผลที่ไม่ผ่านการอนุมัติแล้ว",
  "chat.contest_entry_confirm_submission": "ยืนยันการส่งผลงาน",
  "chat.contest_entry_resubmitted_notice": "ส่งผลงานอีกครั้งแล้ว ทีมงานจะตรวจสอบและแจ้งผลให้ทราบ",
  "chat.contest_entry_ineligible_resubmission_notice": "ตัวละครนี้ไม่ตรงตามเงื่อนไขการเข้าร่วม จึงไม่สามารถส่งผลงานอีกได้",
  "chat.contest_entry_resubmission_rules": "กฎการส่งผลงานใหม่",
  "chat.contest_entry_resubmission_rules_attempts": "คุณสามารถแก้ไขตามเหตุผลที่ไม่ผ่านการอนุมัติ และส่งใหม่ได้สูงสุด 3 ครั้ง",
  "chat.contest_entry_resubmission_rules_review": "เมื่อส่งผลงานอีกครั้ง สถานะจะเปลี่ยนเป็นรออนุมัติ และจะได้รับการยืนยันหลังทีมงานตรวจสอบ",
  "chat.contest_entry_resubmission_rules_deadline": "ผลงานที่ไม่ผ่านการอนุมัติหลังปิดรับผลงานแล้ว จะไม่สามารถส่งใหม่ได้ และการอนุมัติจะถูกตัดสินในขั้นตอนการพิจารณาผลงาน",
  "chat.contest_entry_resubmit": "ส่งผลงานอีกครั้ง",
  "chat.contest_entry_approval_revoked": "ยกเลิกการอนุมัติ",
  "chat.contest_entry_view_revocation_reason": "ดูเหตุผลที่ยกเลิกการอนุมัติ",
  "chat.contest_entry_revocation_reason": "เหตุผลที่ยกเลิกการอนุมัติ",
  "chat.tag_search_no_results": "ไม่พบแท็กที่ตรงกับ '{{string_keyword}}'",
  "chat.tag_search_try_another": "ลองค้นหาด้วยคำอื่น",
  "chat.chat_list_edit_title": "แก้ไขรายการแชต",
  "chat.chat_list_delete_selected_confirm": "ต้องการลบห้องแชตที่เลือกหรือไม่?",
  "chat.profile_edit_heading": "แก้ไขโปรไฟล์",
  "chat.chat_without_ads": "แชตแบบไม่มีโฆษณา",
  "notification.mark_all_read": "อ่านแล้วทั้งหมด",
  "chat.markdown_apply": "ใช้รูปแบบ Markdown",
  "chat.markdown_plain_text_description": "แสดงข้อความตามที่พิมพ์ สัญลักษณ์อย่าง #, *, - จะแสดงเป็นข้อความปกติ",
  "chat.create_short_intro_max_length": "แนะนำตัวไม่เกิน {{int_number}} ตัวอักษร",
  "chat.markdown_heading_large": "หัวข้อใหญ่",
  "chat.markdown_heading_small": "หัวข้อย่อย",
  "chat.markdown_bold": "ตัวหนา",
  "chat.markdown_italic": "ตัวเอียง",
  "chat.markdown_list": "รายการ",
  "chat.markdown_ordered_list": "รายการลำดับเลข",
  "chat.markdown_quote": "ข้อความอ้างอิง",
  "chat.markdown_inline_code": "โค้ดอินไลน์",
  "chat.markdown_code_block": "บล็อกโค้ด",
  "chat.markdown_table": "ตาราง",
  "chat.markdown_toggle": "ย่อ/ขยาย",
  "chat.markdown_format": "รูปแบบ Markdown",
  "chat.markdown_table_select_size": "เลือกขนาดตาราง",
  "chat.markdown_table_dimensions": "{{int_cols}} คอลัมน์ × {{int_rows}} แถว",
  "chat.markdown_table_size": "ขนาดตาราง",
  "chat.markdown_bold_text": "ข้อความตัวหนา",
  "chat.markdown_italic_text": "ข้อความตัวเอียง",
  "chat.markdown_code": "โค้ด",
  "chat.markdown_list_item": "รายการย่อย",
  "chat.markdown_blockquote": "ข้อความอ้างอิง",
  "chat.markdown_image_description": "คำอธิบายรูปภาพ",
  "chat.markdown_code_placeholder": "ป้อนโค้ด",
  "chat.markdown_collapsed_placeholder": "ป้อนเนื้อหาที่ต้องการซ่อน",
  "chat.markdown_item": "รายการ",
  "chat.create_short_intro": "คำแนะนำตัวสั้นๆ",
  "chat.create_review_info": "ข้อมูลสำหรับตรวจสอบ",
  "chat.create_character_info": "ข้อมูลตัวละคร",
  "chat.create_background_info": "ข้อมูลภูมิหลัง",
  "chat.create_person": "ตัวละคร",
  "chat.create_hidden_from_users": "ผู้ใช้จะไม่เห็นเนื้อหานี้",
  "chat.create_hidden_markdown_description": "ผู้ใช้จะไม่เห็นเนื้อหานี้ โดยรูปแบบ Markdown เช่น ## หัวข้อ จะถูกส่งให้ AI ตามที่เขียน เพื่อช่วยให้เข้าใจโครงสร้าง",
  "chat.create_review_only_description": "ใช้สำหรับตรวจสอบเท่านั้น และจะไม่แสดงในหน้ารายละเอียด หากต้องการให้ผู้ใช้เห็น กรุณาเพิ่มเนื้อหาที่ต้องการในคำอธิบายโดยละเอียด",
  "chat.create_one_per_line": "กรอกทีละบรรทัด",
  "chat.create_prompt_total_count": "พรอมต์รวม {{current}} / {{max}} ตัวอักษร",
  "chat.create_total_count": "รวม {{current}} / {{max}} ตัวอักษร",
  "chat.create_public_description": "คำอธิบายโดยละเอียด",
  "chat.create_public_description_ai_notice": "AI จะไม่อ่านเนื้อหานี้ สามารถเขียนคำแนะนำตัวสำหรับผู้ใช้ได้ตามต้องการ",
  "chat.create_public_description_ai_hidden": "AI จะไม่อ่านเนื้อหานี้",
  "chat.create_public_description_ai_unread": "คำแนะนำที่ AI จะไม่อ่าน",
  "chat.create_public_description_placeholder": "เขียนคำแนะนำที่ต้องการแสดงให้ผู้ใช้เห็น",
  "chat.create_public_description_migrated": "ย้ายเนื้อหาที่คุณเคยเปิดสาธารณะไว้มาให้แล้ว สามารถปรับแก้ได้ตามต้องการ",
  "chat.create_public_description_empty": "ยังไม่มีรายละเอียด คุณสามารถลงทะเบียนได้เลย แต่การเพิ่มคำอธิบายโดยละเอียดจะช่วยเพิ่มโอกาสให้ผู้ใช้เริ่มแชตมากขึ้น",
  "chat.create_character_limit_exceeded": "จำนวนตัวอักษรเกินกำหนด",
  "chat.create_public_description_max_length": "กรอกรายละเอียดไม่เกิน {{int_characters}} ตัวอักษร",
  "chat.create_public_description_token_notice": "นับแยกจากจำนวนตัวอักษรของพรอมป์ต์ · ไม่ส่งไปยัง AI จึงไม่กระทบต่อค่าใช้จ่าย",
  "chat.create_public_description_separate_count": "ไม่ส่งไปยัง AI · นับแยกต่างหาก",
  "chat.create_public_description_preview_placeholder": "รายละเอียดที่กรอกจะแสดงที่นี่",
  "chat.create_public_description_visible_area": "ผู้ใช้จะเห็นเฉพาะส่วนนี้เท่านั้น",
  "chat.image_load_failed": "ไม่สามารถโหลดรูปภาพได้",
  "chat.find_character": "ค้นหาตัวละคร",
  "chat.find_universe": "ค้นหาจักรวาล",
  "chat.find_scene": "ค้นหาฉาก",
  "chat.markdown_image": "รูปภาพ",
  "chat.create_preview_label": "ดูตัวอย่าง",
  "common.list_load_failed": "อุ๊ย! ไม่สามารถโหลดรายการได้",
  "validation.email_request_limit_exceeded": "ส่งคำขอทางอีเมลเกินจำนวนครั้งที่กำหนด กรุณาเช็กกล่องข้อความ หรือจดหมายขยะ แล้วลองอีกครั้งในภายหลัง",
  "validation.email_unavailable": "ไม่สามารถใช้อีเมลนี้ได้ กรุณาระบุอีเมลอื่น",
  "payment.shampoo_sales_end_notice": "สินค้าซูเปอร์แชมพู และรีฟิลซูเปอร์แชมพู จะยุติการจำหน่ายในวันที่ 25 พฤศจิกายนนี้",
  "payment.shampoo_free_provision_end_notice": "ระบบจะยกเลิกการแจกแชมพูฟรี ในวันที่ 16 ธันวาคม และเปลี่ยนเป็นรางวัลเช็กอินรายวันแทน โดยแชมพูฟรีที่มีอยู่สามารถใช้งานได้ถึงวันที่ 15 ธันวาคมเท่านั้น",
  "payment.shampoo_purchased_access_continues": "ซูเปอร์แชมพูที่ซื้อไว้แล้ว จะยังสามารถใช้งานต่อได้จนครบอายุการใช้งาน แม้จะสิ้นสุดการจำหน่ายแล้วก็ตาม",
  "payment.shampoo_contact_support": "หากมีข้อสงสัยเพิ่มเติม กรุณาติดต่อฝ่ายบริการลูกค้า",
  "payment.shampoo_sales_ended": "แพ็กเกจซูเปอร์แชมพู (รวมแบบรีฟิล) ยุติการจำหน่ายแล้ว ตั้งแต่วันที่ 25 พฤศจิกายน 2026",
  "payment.shampoo_pass_validity_continues": "แพ็กเกจที่ซื้อก่อนวันสิ้นสุดการจำหน่าย จะยังสามารถใช้งานได้ตามปกติจนกว่าจะหมดอายุ",
  "weave.purchase_verification_required": "กรุณายืนยันตัวตนก่อนซื้อ",
  "weave.purchase_verified_adults_only": "Weave Plus สงวนสิทธิ์เฉพาะผู้ใหญ่ที่ยืนยันตัวตนแล้วเท่านั้น",
  "weave.purchase_adults_only": "ผู้ใหญ่เท่านั้นที่สามารถซื้อ Weave Plus ได้",
  "weave.purchase_minors_restricted": "ตามข้อกำหนดทางกฎหมาย สมาชิกที่ยังไม่บรรลุนิติภาวะไม่สามารถซื้อ Weave Plus ได้",
  "weave.continued_use_verification_required": "กรุณายืนยันตัวตนเพื่อใช้งาน Weave Plus ต่อ",
  "weave.verified_adults_notice": "ตั้งแต่วันที่ {{string_date}} เป็นต้นไป Weave Plus จะเปิดให้เฉพาะสมาชิกผู้ใหญ่ที่ยืนยันตัวตนแล้วใช้งานได้เท่านั้น กรุณายืนยันตัวตนก่อนถึงวันที่กำหนด",
  "weave.unverified_by_effective_date": "หากไม่ได้ยืนยันตัวตนภายในวันที่กำหนด",
  "weave.termination_prorated_refund": "สิทธิ์การใช้งาน Weave Plus จะสิ้นสุดลง และระบบจะคืนเงินให้ตามระยะเวลาการใช้งานที่เหลืออยู่",
  "weave.model_usage_notice_title": "แจ้งเกี่ยวกับการใช้งานโมเดล Weave",
  "weave.model_adults_only_notice": "ตั้งแต่วันที่ {{string_date}} เป็นต้นไป โมเดล Weave จะให้บริการเฉพาะผู้ใหญ่เท่านั้น ห้องแชตที่ใช้ Weave จะถูกสลับไปใช้ Gemini 3.8 Flash แทน โดยประวัติการแชตจะยังคงอยู่เหมือนเดิม",
  "weave.access_ending_title": "สิทธิ์การใช้งาน Weave Plus ของคุณจะสิ้นสุดลง",
  "weave.access_ending_refund_notice": "ตั้งแต่วันที่ {{string_date}} เป็นต้นไป โมเดล Weave จะเปิดให้เฉพาะผู้ใหญ่ใช้งานได้ จึงทำให้สิทธิ์การใช้งาน Weave Plus สิ้นสุดลงด้วย โดยระบบจะคืนเงินตามระยะเวลาการใช้งานที่เหลืออยู่",
  "weave.app_store_subscription_heading": "กรณีสมัครใช้งานผ่าน App Store",
  "weave.apple_refund_instructions": "กรุณายื่นเรื่องขอคืนเงินกับ Apple ผ่านปุ่ม [ขอคืนเงิน] ด้านล่าง ทั้งนี้ การต่ออายุอัตโนมัติจะถูกยกเลิกพร้อมกันเมื่อส่งคำขอ",
  "weave.request_refund": "ขอคืนเงิน",
  "weave.access_ending_automatic_refund_notice": "ตั้งแต่วันที่ {{string_date}} เป็นต้นไป โมเดล Weave จะเปิดให้เฉพาะผู้ใหญ่ใช้งานได้ จึงทำให้สิทธิ์การใช้งาน Weave Plus สิ้นสุดลงด้วย โดยระบบจะคืนเงินตามระยะเวลาการใช้งานที่เหลืออยู่ ไปยังช่องทางการชำระเงินเดิมโดยอัตโนมัติ",
  "weave.adults_only_badge": "สำหรับผู้ใหญ่เท่านั้น",
  "weave.minors_cannot_purchase": "สมาชิกที่ยังไม่บรรลุนิติภาวะไม่สามารถซื้อ Weave Plus ได้"
}